function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{opacity:0.2;fill:url(#SVGID_2_);}\r\n\t.st2{fill:none;stroke:url(#SVGID_3_);stroke-width:0.7744;stroke-miterlimit:10;}\r\n\t.st3{opacity:0.75;fill:none;stroke:url(#SVGID_4_);stroke-width:0.5226;stroke-miterlimit:10;}\r\n\t.st4{fill:url(#SVGID_5_);}\r\n\t.st5{fill:url(#SVGID_6_);}\r\n\t.st6{fill:url(#SVGID_7_);}\r\n\t.st7{fill:url(#SVGID_8_);}\r\n\t.st8{opacity:0.15;fill:url(#SVGID_9_);}\r\n\t.st9{opacity:0.65;}\r\n\t.st10{fill:#FFFFFF;}\r\n\t.st11{fill:#48347A;}\r\n\t.st12{fill:#6752AA;}\r\n\t.st13{fill:url(#SVGID_10_);}\r\n\t.st14{fill:#7D7D7D;}\r\n\t.st15{fill:#CCCCCC;}\r\n\t.st16{fill:url(#SVGID_11_);}\r\n\t.st17{fill:url(#SVGID_12_);}\r\n\t.st18{fill:url(#SVGID_13_);}\r\n\t.st19{fill:#7F4B28;}\r\n\t.st20{fill:#AF6B38;}\r\n\t.st21{fill:none;stroke:#F4973B;stroke-width:0.1673;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st22{fill:#BABABA;}\r\n\t.st23{fill:url(#SVGID_14_);}\r\n\t.st24{fill:url(#SVGID_15_);}\r\n\t.st25{fill:#EFBD9C;}\r\n\t.st26{fill:#FECFAE;}\r\n\t.st27{fill:#F6BEFC;}\r\n\t.st28{fill:url(#SVGID_16_);}\r\n\t.st29{fill:url(#SVGID_17_);}\r\n\t.st30{fill:url(#SVGID_18_);}\r\n\t.st31{fill:url(#SVGID_19_);}\r\n\t.st32{fill:#D1A586;}\r\n\t.st33{fill:#352C5B;}\r\n\t.st34{fill:#4A3F7A;}\r\n\t.st35{fill:#554684;}\r\n\t.st36{fill:#D146A6;}\r\n\t.st37{fill:#CE956E;}\r\n\t.st38{fill:#EDBB98;}\r\n\t.st39{fill:#F9BDFF;}\r\n\t.st40{fill:url(#SVGID_20_);}\r\n\t.st41{fill:url(#SVGID_21_);}\r\n\t.st42{fill:url(#SVGID_22_);}\r\n\t.st43{fill:#EAB18B;}\r\n\t.st44{fill:url(#SVGID_23_);}\r\n\t.st45{fill:#B58368;}\r\n\t.st46{fill:#FFCBAE;}\r\n\t.st47{fill:#BF8567;}\r\n\t.st48{fill:#A8735B;}\r\n\t.st49{fill:#7A4327;}\r\n\t.st50{fill:#E09C3B;}\r\n\t.st51{fill:url(#SVGID_24_);}\r\n\t.st52{fill:url(#SVGID_25_);}\r\n\t.st53{fill:#469191;}\r\n\t.st54{fill:#58A3A5;}\r\n\t.st55{fill:url(#SVGID_26_);}\r\n\t.st56{fill:#E26196;}\r\n\t.st57{fill:url(#SVGID_27_);}\r\n\t.st58{fill:url(#SVGID_28_);}\r\n\t.st59{fill:#CE8E6E;}\r\n\t.st60{fill:#DD9F7C;}\r\n\t.st61{fill:#DD9E7A;}\r\n\t.st62{fill:#C98865;}\r\n\t.st63{fill:url(#SVGID_29_);}\r\n\t.st64{fill:url(#SVGID_30_);}\r\n\t.st65{fill:#6B361F;}\r\n\t.st66{opacity:0.4;fill:#D39779;}\r\n\t.st67{fill:#FCF5FF;}\r\n\t.st68{fill:url(#SVGID_31_);}\r\n\t.st69{fill:url(#SVGID_32_);}\r\n\t.st70{fill:url(#SVGID_33_);}\r\n\t.st71{fill:url(#SVGID_34_);}\r\n\t.st72{fill:url(#SVGID_35_);}\r\n\t.st73{fill:url(#SVGID_36_);}\r\n\t.st74{fill:url(#SVGID_37_);}\r\n\t.st75{fill:url(#SVGID_38_);}\r\n\t.st76{fill:url(#SVGID_39_);}\r\n\t.st77{fill:#6B4D39;}\r\n\t.st78{fill:url(#SVGID_40_);}\r\n\t.st79{fill:url(#SVGID_41_);}\r\n\t.st80{fill:url(#SVGID_42_);}\r\n\t.st81{fill:url(#SVGID_43_);}\r\n\t.st82{fill:url(#SVGID_44_);}\r\n\t.st83{fill:url(#SVGID_45_);}\r\n\t.st84{fill:url(#SVGID_46_);}\r\n\t.st85{fill:url(#SVGID_47_);}\r\n\t.st86{fill:url(#SVGID_48_);}\r\n\t.st87{fill:url(#SVGID_49_);}\r\n\t.st88{fill:url(#SVGID_50_);}\r\n\t.st89{fill:url(#SVGID_51_);}\r\n\t.st90{fill:url(#SVGID_52_);}\r\n\t.st91{fill:#E59218;}\r\n\t.st92{fill:url(#SVGID_53_);}\r\n\t.st93{fill:url(#SVGID_54_);}\r\n\t.st94{fill:url(#SVGID_55_);}\r\n\t.st95{opacity:0.15;fill:url(#SVGID_56_);}\r\n\t.st96{fill:url(#SVGID_57_);}\r\n\t.st97{fill:#FDFEFF;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  className: "st0",
  width: 500,
  height: 500
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M249.5,206.3c-91,1.5-163.9,49.3-163,106.9c0.9,57.6,75.4,103.1,166.4,101.6s163.9-49.3,163-106.9 C414.9,250.4,340.5,204.8,249.5,206.3z"
});

var _ref5 = /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.9999 -1.603136e-02 1.603136e-02 0.9999 -4.1764 4.0629)",
  className: "st2",
  cx: 251.3,
  cy: 262.5,
  rx: 182.7,
  ry: 122
});

var _ref6 = /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.9999 -1.603106e-02 1.603106e-02 0.9999 -4.1763 4.0629)",
  className: "st3",
  cx: 251.3,
  cy: 262.5,
  rx: 198.3,
  ry: 132.4
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M253.1,364.9c90.8-1.5,163.7-49.7,162.8-107.7l-0.1-9.1l-328.9,7.2l0,7.2 C87.8,320.5,162.2,366.4,253.1,364.9z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M249.7,147.6C158.8,149,85.9,197.2,86.9,255.3c0.9,58,75.3,103.9,166.2,102.5 c90.8-1.5,163.7-49.7,162.8-107.7C414.9,192,340.5,146.1,249.7,147.6z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M252.8,340.8c77.9-1.2,140.3-42.6,139.5-92.3l-0.1-13l-281.9,6.2l0,11.3C111.2,302.7,175,342.1,252.8,340.8 z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M249.9,149.4c-77.9,1.2-140.3,42.6-139.5,92.3c0.8,49.8,64.6,89.1,142.4,87.8s140.3-42.6,139.5-92.3 C391.6,187.4,327.8,148.1,249.9,149.4z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M251.4,37.5c-77.9,0-141,40.6-141,90.6c0,26.8,0,62.6,0,89.5c0-50.1,63.1-90.6,141-90.6s141,40.6,141,90.6 v-89.5C392.4,78.1,329.3,37.5,251.4,37.5z"
});

var _ref12 = /*#__PURE__*/React.createElement("g", {
  className: "st9"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M239.7,48.5l2.1-0.1l3.6,2.3l-1.3,1.3l-2.2-1.5c0,2,0,4.7,0,6.7l-2.2,0.1 C239.7,54.6,239.7,51.1,239.7,48.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M228.4,56.5c0.7-0.1,1.4-0.4,1.6-1.9c0,0,0.4-2.7-0.7-3.5c-1.1-0.8-3.1,0.1-2.6,3.8 C227,56.1,227.5,56.6,228.4,56.5 M228.4,49.2c5.2-0.3,4.2,6,2.9,7.6c-1.5,1.9-6.3,2.7-6.8-1.8 C224.5,54.1,224.2,49.6,228.4,49.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M235.1,60.6c0.5,0.8,1.3,1.6,1.6,2.5c0.3,0.6,0.6,1.5,0.6,2.8c0,2.7-1.5,4.7-2.2,5.6l0,0.1 c-0.5-0.2-1.1-0.4-1.6-0.6c2.6-3.6,2.6-6.3,0-9.5L235.1,60.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M227,61.4c0.5,0.2,1.1,0.4,1.5,0.6c-2.6,3.7-2.6,6.4,0,9.5l-1.5,0.9c-0.5-0.8-1.2-1.5-1.6-2.5 c-0.3-0.6-0.6-1.5-0.6-2.8C224.8,64.4,226.3,62.3,227,61.4L227,61.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M239.5,75.8c4.4-0.1,4.9,3.4,3.2,5.1c-1.3,1.2-4.2,1.7-5.8,0.6c0.5-0.4,1.1-1,1.5-1.4 c1,0.9,3.1,0.2,3-1.4c-0.1-1.5-2.2-1.6-3-0.7c-0.5-0.4-1.1-0.8-1.5-1.2C237.8,76,238.9,75.8,239.5,75.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M229.2,81.4c1.4-0.2,1.8-1.4,1-1.9c-0.2-0.2-0.5-0.3-0.8-0.4c-0.6,0.6-1.3,1.3-1.9,1.9 C228,81.2,228.5,81.4,229.2,81.4 M228.8,77.2c0.5-0.4,0.9-0.8,0.9-1.2c0-0.3-0.2-0.7-0.8-0.7c-0.9,0-1.6,0.8-1.1,1.3 C228.1,76.9,228.6,77.2,228.8,77.2 M228.7,73.8c3.6-0.3,3.8,2.1,2.7,3.4c-0.2,0.2-0.4,0.4-0.6,0.6c2.7,0.6,2.9,3,1.1,4.3 c-0.6,0.4-3.5,1.8-5.7,0.2l-0.9,0.9l-2.8,0.4l2.3-2.4l-2.2-2.2l2.6-0.3l1,1c0.4-0.4,0.9-0.9,1.4-1.4c-2.7-1-2.3-3.2-0.6-4.1 C227.3,74.2,227.9,73.9,228.7,73.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M242.1,40.1l2.1-2.5c-0.9,0-1.8,0.1-2.7,0.1l-1,1.3l-0.9-1.2c-0.8,0-1.7,0.1-2.5,0.1l2,2.3l-2.8,3.4 l2.7-0.2l1.6-2.1l1.7,1.9l2.7-0.1L242.1,40.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M226.9,38.9c-0.5,0.1-1,0.1-1.5,0.2c0.9,1.8,2,4.1,2.9,5.9l1.3-0.5C228.8,42.8,227.7,40.6,226.9,38.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M239.7,97.3l2.1-0.1l3.6,2.3l-1.3,1.3l-2.2-1.5c0,2,0,4.7,0,6.7l-2.2,0.1 C239.7,103.5,239.7,100,239.7,97.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M228.4,105.4c0.7-0.1,1.4-0.4,1.6-1.9c0,0,0.4-2.7-0.7-3.5c-1.1-0.8-3.1,0.1-2.6,3.8 C227,105,227.5,105.5,228.4,105.4 M228.4,98.1c5.2-0.3,4.2,6,2.9,7.6c-1.5,1.9-6.3,2.7-6.8-1.8 C224.5,102.9,224.2,98.5,228.4,98.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M235.1,109.5c0.5,0.8,1.3,1.6,1.6,2.5c0.3,0.6,0.6,1.5,0.6,2.8c0,2.7-1.5,4.7-2.2,5.6l0,0.1 c-0.5-0.2-1.1-0.4-1.6-0.6c2.6-3.6,2.6-6.3,0-9.5L235.1,109.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M227,110.3c0.5,0.2,1.1,0.4,1.5,0.6c-2.6,3.7-2.6,6.4,0,9.5l-1.5,0.9c-0.5-0.8-1.2-1.5-1.6-2.5 c-0.3-0.6-0.6-1.5-0.6-2.8C224.8,113.3,226.3,111.2,227,110.3L227,110.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M243.5,127c-0.1-0.6-0.9-2.3-4.1-2.3c-1.2,0.1-1.9,0.4-2.6,1c0.5,0.4,1.1,0.8,1.5,1.2 c0.8-0.9,2.5-0.6,2.9,0.4c0.8,0,1.6-0.1,2.3-0.1C243.6,127.1,243.5,127,243.5,127"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M229.8,128.1c-0.1-0.1-0.3-0.1-0.4-0.2l-0.3,0.3C229.4,128.1,229.6,128.1,229.8,128.1 C229.9,128.1,229.8,128.1,229.8,128.1 M228.8,126.1c0.5-0.4,0.9-0.8,0.9-1.2c0-0.3-0.2-0.7-0.8-0.7c-0.9,0-1.6,0.8-1.1,1.3 C228.1,125.8,228.6,126,228.8,126.1 M225.2,127.6l0.9,0.9c-0.9,0.1-1.7,0.2-2.6,0.3l-0.9-0.9L225.2,127.6 M232.7,127.8 C232.7,127.8,232.7,127.8,232.7,127.8c-2.1,0.2-4.2,0.5-6.3,0.7l1.2-1.2c-3-1.1-2.1-3.3-0.6-4.1c0.8-0.4,1.6-0.5,2.3-0.5 c2.5,0.1,3.8,1.7,1.5,4C231.3,126.8,232.1,127,232.7,127.8"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st10",
  points: "236.7,86.5 239.3,86.3 240.5,87.9 241.9,86.2 244.6,86.1 242.1,89 245,92.1 242.3,92.2  240.6,90.3 239,92.4 236.3,92.5 239.1,89.1 236.7,86.5  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M226.1,86.1c1.1,2.2,2.5,5.1,3.5,7.3l-1.3,0.5c-1.1-2.2-2.5-5.1-3.5-7.3L226.1,86.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M220.3,40.8l-3.1,0.5v-1.1c-0.6,0.1-1.2,0.2-1.8,0.3v1.1l-3,0.5v1.6l3-0.5v2.6l1.8-0.3v-2.6l3.1-0.5 V40.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M218,57.3c1.2-0.1,1.7,0.9,1,1.7c-0.8,0.9-2.2,0.8-2.4-0.2C216.6,58.1,217.2,57.4,218,57.3 M216.9,50.9 l2.2-0.3c0,1.8,0,4.1,0,5.9l-2.2,0.3C216.9,55,216.9,52.6,216.9,50.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M207.8,59.1c1.2-0.2,1.6,0.8,1.1,1.6c-0.6,1-2.1,1-2.3,0.1C206.4,60.1,207,59.3,207.8,59.1 M207.6,52.4 c2.1-0.4,3.3,0.3,3.5,2c-0.7,0.2-1.5,0.4-2.2,0.6c-0.2-1.2-1.7-0.9-2.2-0.4c-0.7,0.8,0.1,1.2,0.9,1.7c1,0.6,1.2,0.7,1.2,1.4 v0.5l-2.1,0.4c0-0.6,0-0.8-0.5-1.1c-0.9-0.5-1.9-0.9-1.7-2.3C204.7,53.6,206.2,52.7,207.6,52.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M195.2,55.6l1.9-0.5l3.2,1.6l-1.2,1.5l-1.9-1c0,2,0,4.7,0,6.7l-1.9,0.5 C195.2,61.7,195.2,58.2,195.2,55.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M185.4,65.9c0.4-0.2,1.2-0.5,1.4-2.2c0.1-0.5,0.3-3.1-0.8-3.4c-0.4-0.1-1.4,0.1-1.8,1.3 c-0.4,1.2-0.3,3.2,0,3.9C184.5,65.9,184.9,66,185.4,65.9 M185.4,58.5c4.5-1.3,3.6,5.2,2.5,7c-1.2,2-5,3.8-5.7,0.2 C181.9,64.3,181.8,59.7,185.4,58.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M218,69.2l-0.2-1.5l-1.4,0.2l0.2,1.5L218,69.2 M214.3,64.7l1.4-0.2l0.4,2.4l1.4-0.2l-0.4-2.4l1.4-0.2 l0.4,2.4l1.4-0.2v1.1l-1.2,0.2l0.2,1.5l1.4-0.2v1.1l-1.2,0.2l0.4,2.4l-1.4,0.2l-0.4-2.4l-1.4,0.2l0.4,2.4l-1.4,0.2l-0.4-2.4 L214,71v-1.1l1.2-0.2l-0.2-1.5l-1.4,0.2v-1.1l1.2-0.2L214.3,64.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M201,75.1c1.3-0.4,1.7-1.9,0.8-2.3c-1-0.5-2.5,0.7-2.1,1.8C199.9,75,200.4,75.3,201,75.1 M201,71.5 c2.4-0.5,3.4,1.5,2.3,3.3c-1.4,2.1-4.4,2.3-4.9,0.3C198,73.6,199.3,71.9,201,71.5 M208,69.4c1.4-0.3,1.7-1.8,0.9-2.3 c-1-0.5-2.5,0.7-2.1,1.7C206.9,69.3,207.4,69.5,208,69.4 M208,65.7c2.6-0.4,3.4,1.8,2.3,3.4c-1.4,2.1-4.5,2.2-5,0.2 C205,67.8,206.3,66.1,208,65.7 M202.2,66.8c1.9,2.6,3.8,5.2,5.7,7.8l-1.1,0.8c-1.9-2.5-3.8-5.1-5.7-7.6L202.2,66.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M191.2,68.7c1.6,1.9,3.4,5.1,0,10.9l0,0.1c-0.4-0.1-1-0.2-1.4-0.3c2.3-4.1,2.3-6.8,0-9.5L191.2,68.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M184.1,71c0.4,0.1,0.9,0.2,1.3,0.3c-2.2,4.2-2.2,6.8,0,9.5l-1.3,1.2C183.2,80.9,180.5,77.7,184.1,71 L184.1,71"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M217.9,83.1c1.1-0.2,1.2-1,0.8-1.3c-0.5-0.3-1.6-0.1-1.9-0.1l-0.5,0.1c0,0.6,0,0.8,0.3,1 C216.9,83.2,217.5,83.2,217.9,83.1 M217.4,78.1c1.7-0.2,2.6,0.2,3.1,0.5c-0.4,0.4-0.8,0.8-1.2,1.2c-1.3-1-3.1-0.3-3.2,0.9 c6.7-1.1,4.5,2.4,4.5,2.4c-0.8,1.2-3.4,1.8-4.4,0.7l0,0v0.8l-2,0.3c0-4.3,0-4.3,0.3-5C215.2,78.7,216.4,78.3,217.4,78.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M206.2,84.9c2.1-0.5,2-2.5,1.1-3c-1.1-0.6-3.3,0.6-2.7,2.3C204.8,84.8,205.4,85.1,206.2,84.9  M207.7,76.7l2.1-0.4c0,2.7,0,6.3,0,8.9c0,0.1,0,0.3,0,0.4l-2,0.4v-0.8c-2.4,2.6-5.4,1.6-5.4-0.9c0-3.2,3.8-4.9,5.2-3.6l0,0 V76.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M195,83c3.7-0.9,4.3,2.2,3,4.2c-1.2,1.8-3.9,2.8-5.3,2c0.4-0.5,0.9-1.2,1.3-1.7c0.9,0.7,2.7-0.4,2.6-2 c-0.1-1.3-1.7-1.2-2.5-0.3c-0.1,0.1-0.1,0.1-0.1,0.2c-0.4-0.3-0.9-0.6-1.3-0.9C193.5,83.5,194.5,83.2,195,83"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M186.1,90.5c1.2-0.5,1.7-1.8,0.7-2.2c-0.2-0.1-0.3-0.1-0.6-0.2c-0.5,0.7-1.1,1.6-1.6,2.2 C185,90.6,185.5,90.7,186.1,90.5 M185.8,86.5c0.3-0.3,0.7-0.9,0.8-1.3c0-0.5-0.3-0.7-0.6-0.7c-0.8,0.1-1.6,1.1-1,1.6 C185.2,86.3,185.6,86.4,185.8,86.5 M185.6,83.1c3.3-1,3.1,1.5,2.5,2.6c-0.2,0.3-0.4,0.7-0.7,1c2.5,0.1,2.5,2.6,0.7,4.3 c0,0-2.6,2.3-4.7,1l-0.8,1.1l-2.4,0.9l2-2.8l-1.9-1.8l2.2-0.8l0.9,0.8c0.3-0.5,0.8-1.1,1.2-1.6c-2.4-0.4-1.9-2.9-0.3-4.1 C184.5,83.6,185,83.3,185.6,83.1"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st10",
  points: "204.7,44.4 208.2,43.7 208.2,45.1 204.7,45.9 204.7,44.4  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M197.3,46.8l1.9-2.9c-0.8,0.2-1.6,0.4-2.4,0.6L196,46l-0.8-1c-0.7,0.2-1.5,0.4-2.2,0.6l1.8,1.9l-2.5,3.9 l2.4-0.7l1.4-2.4l1.5,1.6l2.4-0.6L197.3,46.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M184.1,48.5c-0.4,0.2-0.9,0.3-1.3,0.5c0.7,1.6,1.7,3.8,2.5,5.4l1.2-0.7 C185.7,52.1,184.8,50.1,184.1,48.5"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st10",
  points: "215.4,87.8 217.3,87.6 217.3,90.2 220.3,89.7 220.3,91.3 217.3,91.7 217.3,94.3 215.4,94.6  215.4,92 212.4,92.6 212.4,91 215.4,90.5 215.4,87.8  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M218,106.1c1.2-0.1,1.7,0.9,1,1.7c-0.8,0.9-2.2,0.8-2.4-0.2C216.6,106.9,217.2,106.3,218,106.1  M216.9,99.8l2.2-0.3c0,1.8,0,4.1,0,5.9l-2.2,0.3C216.9,103.9,216.9,101.5,216.9,99.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M207.8,108c1.2-0.2,1.6,0.8,1.1,1.6c-0.6,1-2.1,1-2.3,0.1C206.4,109,207,108.2,207.8,108 M207.6,101.3 c2.1-0.4,3.3,0.3,3.5,2c-0.7,0.2-1.5,0.4-2.2,0.6c-0.2-1.2-1.7-0.9-2.2-0.4c-0.7,0.8,0.1,1.2,0.9,1.7c1,0.6,1.2,0.7,1.2,1.4 v0.5l-2.1,0.4c0-0.6,0-0.8-0.5-1.1c-0.9-0.5-1.9-0.9-1.7-2.3C204.7,102.4,206.2,101.5,207.6,101.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M195.2,104.5l1.9-0.5l3.2,1.6l-1.2,1.5l-1.9-1c0,2,0,4.7,0,6.7l-1.9,0.5 C195.2,110.6,195.2,107.1,195.2,104.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M185.4,114.7c0.4-0.2,1.2-0.5,1.4-2.2c0.1-0.5,0.3-3.1-0.8-3.4c-0.4-0.1-1.4,0.1-1.8,1.3 c-0.4,1.2-0.3,3.2,0,3.9C184.5,114.8,184.9,114.9,185.4,114.7 M185.4,107.4c4.5-1.3,3.6,5.2,2.5,7c-1.2,2-5,3.8-5.7,0.2 C181.9,113.1,181.8,108.6,185.4,107.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M218,118.1l-0.2-1.5l-1.4,0.2l0.2,1.5L218,118.1 M214.3,113.5l1.4-0.2l0.4,2.4l1.4-0.2l-0.4-2.4l1.4-0.2 l0.4,2.4l1.4-0.2v1.1l-1.2,0.2l0.2,1.5l1.4-0.2v1.1l-1.2,0.2l0.4,2.4l-1.4,0.2l-0.4-2.4l-1.4,0.2l0.4,2.4l-1.4,0.2l-0.4-2.4 l-1.4,0.2v-1.1l1.2-0.2l-0.2-1.5l-1.4,0.2v-1.1l1.2-0.2L214.3,113.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M201,124c1.3-0.4,1.7-1.9,0.8-2.3c-1-0.5-2.5,0.7-2.1,1.8C199.9,123.9,200.4,124.1,201,124 M201,120.3 c2.4-0.5,3.4,1.5,2.3,3.3c-1.4,2.1-4.4,2.3-4.9,0.3C198,122.5,199.3,120.8,201,120.3 M208,118.2c1.4-0.3,1.7-1.8,0.9-2.3 c-1-0.5-2.5,0.7-2.1,1.7C206.9,118.1,207.4,118.4,208,118.2 M208,114.6c2.6-0.4,3.4,1.8,2.3,3.4c-1.4,2.1-4.5,2.2-5,0.2 C205,116.7,206.3,115,208,114.6 M202.2,115.6c1.9,2.6,3.8,5.2,5.7,7.8l-1.1,0.8c-1.9-2.5-3.8-5.1-5.7-7.6L202.2,115.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M191.2,117.6c1.6,1.9,3.4,5.1,0,10.9l0,0.1c-0.4-0.1-1-0.2-1.4-0.3c2.3-4.1,2.3-6.8,0-9.5L191.2,117.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M184.1,119.9c0.4,0.1,0.9,0.2,1.3,0.3c-2.2,4.2-2.2,6.8,0,9.5l-1.3,1.2 C183.2,129.8,180.5,126.6,184.1,119.9L184.1,119.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M220.2,127.3c0.1,0,0.2,0.1,0.3,0.2c-0.4,0.4-0.8,0.8-1.2,1.2c-1.4-1-3-0.3-3.2,0.9 c1.2-0.2,2.3-0.3,3.2-0.2c-1.8,0.3-3.5,0.5-5.2,0.8l0-0.3c0.2-1.6,0.9-2.6,3.6-3C218.4,126.9,219.3,126.9,220.2,127.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M207.8,131.3c-0.5-1.1-2.6-0.6-3.1,0.7c0,0,0,0.1,0,0.1c1.1-0.2,2.1-0.5,3.2-0.7 C207.8,131.4,207.8,131.4,207.8,131.3 M209.8,125.2c0,1.8,0,4.1,0,5.9c-2.5,0.5-4.9,1-7.3,1.6l0-0.1c1-3.8,4.3-3.7,5.2-3 c0,0,0,0,0,0v-4L209.8,125.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M198.6,133.4c-0.1-0.5-0.8-2.2-3.6-1.5c-1,0.3-1.6,0.7-2.3,1.5c0.4,0.3,0.9,0.6,1.3,0.9 c0.7-1,2.2-1.1,2.5-0.1c0.7-0.2,1.4-0.4,2.1-0.5C198.6,133.5,198.6,133.5,198.6,133.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M186.6,137.1c-0.1,0-0.2-0.1-0.4-0.1l-0.2,0.3C186.2,137.3,186.4,137.2,186.6,137.1 C186.6,137.1,186.6,137.1,186.6,137.1 M185.8,135.4c0.3-0.3,0.7-0.9,0.8-1.3c0-0.5-0.3-0.7-0.6-0.7c-0.8,0.1-1.6,1.1-1,1.6 C185.2,135.2,185.6,135.3,185.8,135.4 M182.6,137.5l0.8,0.7c-0.7,0.3-1.5,0.5-2.2,0.8l-0.8-0.7L182.6,137.5 M189.1,136.3 C189.1,136.3,189.1,136.3,189.1,136.3c-1.8,0.6-3.7,1.3-5.5,1.9l1-1.4c-2.8-0.6-1.7-3.2,0-4.3c0.6-0.3,0.9-0.5,1.5-0.6 c2.2-0.3,3.3,1,1.3,3.7C187.9,135.6,188.6,135.7,189.1,136.3"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st10",
  points: "204.7,93.3 208.2,92.5 208.2,94 204.7,94.8 204.7,93.3  "
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st10",
  points: "192.6,94.2 194.9,93.6 196,94.9 197.1,93 199.5,92.3 197.3,95.7 200,98.2 197.6,98.9 196,97.3  194.6,99.7 192.2,100.4 194.7,96.4 192.6,94.2  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M183.4,95.9c0.9,2,2.1,4.6,3.1,6.6l-1.2,0.7c-0.9-2-2.1-4.6-3-6.6L183.4,95.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M178.5,51.7l-2.6,1v-1.1c-0.5,0.2-1,0.4-1.5,0.6v1.1l-2.5,1.1V56l2.5-1.1v2.6l1.5-0.6v-2.6l2.6-1V51.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M176.4,68.5c1-0.4,1.3,0.5,1,1.3c-0.5,1.1-1.8,1.5-2.1,0.6C175.1,69.8,175.7,68.9,176.4,68.5  M175.5,62.4l1.8-0.7c0,1.8,0,4.1,0,5.9l-1.8,0.7C175.5,66.5,175.5,64.1,175.5,62.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M167.9,72.3c1-0.4,1.3,0.5,0.9,1.2c-0.4,1-1.6,1.5-1.9,0.8C166.6,73.7,167.1,72.6,167.9,72.3  M167.8,65.6c1.7-0.8,2.7-0.3,2.9,1.3c-0.5,0.3-1.3,0.7-1.8,1c-0.1-1.1-1.3-0.7-1.7-0.1c-0.8,1,0.1,1.4,0.6,1.7 c0.9,0.4,1,0.5,1,1.2v0.5L167,72c0-0.6,0-0.8-0.5-1c-0.8-0.3-1.6-0.6-1.4-2C165.4,67.3,166.6,66.1,167.8,65.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M157.7,71.1l1.5-0.9l2.6,1l-0.9,1.7l-1.6-0.7c0,2,0,4.7,0,6.7l-1.6,0.9 C157.7,77.2,157.7,73.7,157.7,71.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M149.9,83.1c1.8-1.4,1.3-5.7,0.5-5.8c0,0-1-0.1-1.5,1.9c-0.2,0.8-0.3,3.1,0.1,3.8 C149.3,83.3,149.5,83.3,149.9,83.1 M149.9,75.7c3.8-2.2,2.4,5.2,2.4,5.3c-0.8,3.2-3.5,5.1-4.5,3.7 C147,83.4,146.8,77.7,149.9,75.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M176.5,80.5l-0.2-1.5l-1.2,0.5l0.2,1.5L176.5,80.5 M173.4,76.6l1.2-0.5l0.3,2.3l1.2-0.5l-0.3-2.3 l1.2-0.5l0.3,2.3l1.2-0.5v1.1l-1,0.4l0.2,1.5l1.2-0.5v1.1l-1,0.4l0.3,2.3l-1.2,0.5l-0.3-2.3l-1.2,0.5l0.3,2.3l-1.2,0.5 l-0.3-2.3l-1.2,0.5v-1.1l1-0.4l-0.2-1.5l-1.2,0.5v-1.1l1-0.4L173.4,76.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M162.3,89.5c1.2-0.7,1.4-2.3,0.6-2.5c-0.9-0.2-2.1,1.5-1.5,2.4C161.6,89.7,161.9,89.7,162.3,89.5  M162.3,85.9c1.9-0.9,2.7,0.7,2,2.6c-0.9,2.3-3.3,3.4-4,1.9C159.7,89,160.8,86.7,162.3,85.9 M168.1,82.5 c1.2-0.6,1.5-2.2,0.6-2.5c-0.9-0.2-2.1,1.5-1.6,2.3C167.3,82.6,167.7,82.7,168.1,82.5 M168.1,78.9c2.1-0.9,2.7,1,2,2.7 c-0.9,2.2-3.4,3.3-4.1,1.7C165.3,81.9,166.5,79.6,168.1,78.9 M163.4,80.9c3,4.3,3,4.3,4.7,6.7l-0.9,1 c-3.1-4.3-3.1-4.3-4.7-6.6L163.4,80.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M154.5,84.8c1.3,1.6,2.7,4.5,0,10.9l0,0.1c-0.3,0-0.8-0.1-1.1-0.1c1.8-4.5,1.8-7.2,0-9.5L154.5,84.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M148.9,88.4c0.3,0,0.7,0,1,0c-1.7,4.5-1.7,7.3,0,9.5l-1,1.4C148.2,98.5,146.1,95.8,148.9,88.4 L148.9,88.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M176.4,94.4c1-0.4,1.1-1.3,0.6-1.4c-0.4-0.1-1.2,0.2-1.5,0.3l-0.5,0.2c0,0.6,0,0.8,0.3,1 C175.6,94.7,176.1,94.5,176.4,94.4 M176,89.5c1.4-0.5,2.2-0.3,2.6-0.1c-0.3,0.4-0.7,1-1,1.4c-1.1-0.7-2.6,0.3-2.7,1.4 c5.1-2.1,4.1,0.8,3.9,1.4c-0.6,1.5-2.9,2.7-3.9,1.7l0,0v0.8l-1.7,0.7C173.3,91.7,173.3,90.6,176,89.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M166.6,98.4c1.7-0.9,1.7-3,0.8-3.2c-1.3-0.3-2.7,1.9-2.1,3C165.7,98.7,166.3,98.5,166.6,98.4  M167.9,89.9l1.8-0.8c0,2.7,0,6.3,0,8.9c0,0.1,0,0.3,0,0.4l-1.6,0.8v-0.8c-1.9,2.9-4.1,2.5-4.4,0.7c-0.6-3.3,2.8-6.3,4.2-5.2 c0,0,0.1,0,0.1,0.1l0,0V89.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M157.5,98.5c2.9-1.5,3.3,1.1,2.7,2.9c-0.8,2.5-3.4,4.3-4.6,3.7c0.3-0.6,0.7-1.3,1.1-1.9 c0.8,0.6,2.3-1.2,2.1-2.6c-0.2-1.1-1.3-0.7-1.8,0.1c-0.1,0.2-0.2,0.3-0.2,0.4c-0.3-0.2-0.7-0.5-1.1-0.7 C156.3,99.3,157.1,98.7,157.5,98.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M150.4,107.6c0.9-0.6,1.5-2.2,0.4-2.4c-0.1,0-0.2,0-0.3,0c-0.4,0.8-0.9,1.8-1.3,2.5 C149.6,107.9,149.9,107.9,150.4,107.6 M150.2,103.6c0.2-0.4,0.6-1,0.6-1.4c0-0.5-0.2-0.6-0.5-0.5c-0.7,0.2-1.3,1.5-0.6,1.8 C149.8,103.6,150.1,103.6,150.2,103.6 M150,100.3c2.4-1.5,2.4,0.7,2.2,1.5c-0.1,0.6-0.4,1.1-0.7,1.7c1.8-0.4,2,2,0.7,3.9 c-0.4,0.6-2.4,3-3.8,2.1l-0.6,1.2l-1.9,1.3l1.5-3.2l-1.4-1.4l1.7-1.2l0.7,0.7c0.3-0.5,0.6-1.3,0.9-1.8c-2,0-1.5-2.8,0-4.3 C149.5,100.7,149.8,100.5,150,100.3"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st10",
  points: "165.4,58.1 168.2,56.7 168.2,58.2 165.4,59.6 165.4,58.1  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M159.4,61.9l1.5-3.2c-0.6,0.3-1.3,0.7-1.9,1.1l-0.7,1.6l-0.7-0.8c-0.6,0.3-1.2,0.7-1.8,1l1.4,1.5l-2,4.4 l1.9-1.1l1.1-2.7l1.2,1.3l1.9-1.1L159.4,61.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M148.9,66c-0.3,0.2-0.7,0.5-1,0.7c0.6,1.5,1.3,3.5,1.9,4.9l0.9-0.9C150.1,69.2,149.4,67.4,148.9,66"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st10",
  points: "174.3,99.6 175.9,99 175.9,101.6 178.5,100.5 178.5,102.1 175.9,103.1 175.9,105.7  174.3,106.4 174.3,103.8 171.8,104.9 171.8,103.3 174.3,102.2 174.3,99.6  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M176.4,117.4c1-0.4,1.3,0.5,1,1.3c-0.5,1.1-1.8,1.5-2.1,0.6C175.1,118.7,175.7,117.7,176.4,117.4  M175.5,111.2l1.8-0.7c0,1.8,0,4.1,0,5.9l-1.8,0.7C175.5,115.3,175.5,113,175.5,111.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M167.9,121.2c1-0.4,1.3,0.5,0.9,1.2c-0.4,1-1.6,1.5-1.9,0.8C166.6,122.6,167.1,121.5,167.9,121.2  M167.8,114.5c1.7-0.8,2.7-0.3,2.9,1.3c-0.5,0.3-1.3,0.7-1.8,1c-0.1-1.1-1.3-0.7-1.7-0.1c-0.8,1,0.1,1.4,0.6,1.7 c0.9,0.4,1,0.5,1,1.2v0.5l-1.8,0.8c0-0.6,0-0.8-0.5-1c-0.8-0.3-1.6-0.6-1.4-2C165.4,116.2,166.6,115,167.8,114.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M157.7,119.9l1.5-0.9l2.6,1l-0.9,1.7l-1.6-0.7c0,2,0,4.7,0,6.7l-1.6,0.9 C157.7,126.1,157.7,122.6,157.7,119.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M149.9,131.9c1.8-1.4,1.3-5.7,0.5-5.8c0,0-1-0.1-1.5,1.9c-0.2,0.8-0.3,3.1,0.1,3.8 C149.3,132.2,149.5,132.2,149.9,131.9 M149.9,124.6c3.8-2.2,2.4,5.2,2.4,5.3c-0.8,3.2-3.5,5.1-4.5,3.7 C147,132.3,146.8,126.6,149.9,124.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M176.5,129.4l-0.2-1.5l-1.2,0.5l0.2,1.5L176.5,129.4 M173.4,125.5l1.2-0.5l0.3,2.3l1.2-0.5l-0.3-2.3 l1.2-0.5l0.3,2.3l1.2-0.5v1.1l-1,0.4l0.2,1.5l1.2-0.5v1.1l-1,0.4l0.3,2.3l-1.2,0.5l-0.3-2.3l-1.2,0.5l0.3,2.3l-1.2,0.5 l-0.3-2.3l-1.2,0.5v-1.1l1-0.4l-0.2-1.5l-1.2,0.5v-1.1l1-0.4L173.4,125.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M162.3,138.4c1.1-0.7,1.4-2.3,0.6-2.5c-0.9-0.2-2.1,1.5-1.5,2.4C161.6,138.5,161.9,138.6,162.3,138.4  M162.3,134.7c1.9-0.9,2.7,0.7,2,2.6c-0.9,2.3-3.3,3.4-4,1.9C159.7,137.9,160.8,135.6,162.3,134.7 M168.1,131.4 c1.2-0.6,1.5-2.2,0.6-2.5c-0.9-0.2-2.1,1.5-1.6,2.3C167.3,131.5,167.7,131.6,168.1,131.4 M168.1,127.7c2.1-0.9,2.7,1,2,2.7 c-0.9,2.2-3.4,3.3-4.1,1.7C165.3,130.8,166.5,128.5,168.1,127.7 M163.4,129.8c3,4.3,3,4.3,4.7,6.7l-0.9,1 c-3.1-4.3-3.1-4.3-4.7-6.6L163.4,129.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M154.5,133.7c1.3,1.6,2.7,4.5,0,10.9l0,0.1c-0.3,0-0.8-0.1-1.1-0.1c1.8-4.5,1.8-7.2,0-9.5L154.5,133.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M148.9,137.3c0.3,0,0.7,0,1,0.1c-1.7,4.5-1.7,7.3,0,9.5l-1,1.4C148.2,147.4,146.1,144.6,148.9,137.3 L148.9,137.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M178.4,138.2c0.1,0,0.2,0.1,0.3,0.1c-0.3,0.4-0.7,1-1,1.4c-1.1-0.7-2.5,0.1-2.7,1.4 c1-0.4,1.9-0.8,2.7-0.8c-1.5,0.6-3,1.2-4.4,1.8l0-0.3c0.2-1.7,0.7-2.8,3-3.6C176.8,138.1,177.6,137.9,178.4,138.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M167.9,144.5c-0.4-1-2-0.2-2.5,0.9c-0.1,0.2-0.1,0.4-0.2,0.5c0.9-0.4,1.8-0.9,2.7-1.3 C167.9,144.6,167.9,144.5,167.9,144.5 M169.6,138c0,1.8,0,4.1,0,5.9c-2.1,0.9-4.1,1.9-6.1,2.9l0-0.1c0.7-3.8,3.4-4.6,4.3-3.9 c0,0,0,0,0,0v-4L169.6,138"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M160.4,148.2c-0.1-0.5-0.6-2-2.9-0.9c-0.8,0.5-1.3,1-1.9,1.9c0.3,0.2,0.7,0.5,1.1,0.7 c0.5-1.1,1.7-1.5,2-0.7c0,0,0,0.1,0,0.1c0.6-0.3,1.1-0.6,1.7-0.9C160.4,148.4,160.4,148.3,160.4,148.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M150.8,154.1c-0.1,0-0.2,0-0.3,0l-0.2,0.4C150.5,154.3,150.7,154.2,150.8,154.1 C150.9,154.1,150.9,154.1,150.8,154.1 M150.2,152.5c1.3-2.3,0.1-2,0.1-2c-0.7,0.2-1.3,1.5-0.6,1.8 C149.8,152.5,150.1,152.5,150.2,152.5 M147.7,155.2l0.6,0.6c-0.6,0.4-1.1,0.8-1.7,1.2l-0.6-0.6L147.7,155.2 M152.8,152.8 C152.8,152.8,152.8,152.9,152.8,152.8c-1.4,1-2.9,1.9-4.3,2.9l0.8-1.6c-2.2-0.1-1.4-3.2,0.3-4.6c0.2-0.2,0.6-0.4,0.8-0.5 c2.5-1.1,1.7,1.9,1.5,2.5c-0.1,0.3-0.3,0.6-0.5,1C151.9,152.4,152.4,152.3,152.8,152.8"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st10",
  points: "165.4,107 168.2,105.6 168.2,107.1 165.4,108.5 165.4,107  "
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st10",
  points: "155.6,110.1 157.4,109.1 158.3,110.2 159.2,108.1 161.2,107 159.4,110.8 161.5,112.8  159.6,113.9 158.3,112.6 157.2,115.2 155.3,116.3 157.3,111.9 155.6,110.1  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M148.3,113.5c0.7,1.8,1.7,4.2,2.4,6.1l-0.9,0.9c-0.7-1.8-1.7-4.2-2.4-6L148.3,113.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M144.6,70.1l-2,1.5v-1.1c-0.4,0.3-0.8,0.6-1.2,0.9v1.1l-1.9,1.5v1.6l1.9-1.5v2.6l1.2-0.9v-2.6l2-1.5 V70.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M143,87.3c0.7-0.5,1,0.2,0.8,0.9c-0.2,1.1-1.2,2-1.6,1.4C142,89.1,142.4,87.8,143,87.3 M142.3,81.3 l1.4-1.1c0,1.8,0,4.1,0,5.9l-1.4,1.1C142.3,85.4,142.3,83.1,142.3,81.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M136.7,92.6c0.6-0.5,0.8,0.1,0.8,0.7c-0.1,1.1-1,2.2-1.4,1.7C135.7,94.5,136.1,93.1,136.7,92.6  M136.6,85.9c1.3-1.1,2-0.8,2.1,0.8c-0.4,0.4-0.9,0.9-1.3,1.3c-0.1-1.2-1-0.2-1-0.2c-0.1,0.1-1.2,1.4,0.2,2 c0.6,0.3,0.7,0.3,0.7,1v0.5l-1.3,1.1c0-0.6,0-0.8-0.3-0.9c-0.6-0.2-1.1-0.3-1-1.8C134.9,88,135.8,86.6,136.6,85.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M129.5,93.2l1-1.1l1.8,0.6l-0.7,1.9l-1.1-0.4c0,2,0,4.7,0,6.7l-1.1,1.2 C129.5,99.3,128.6,95.6,129.5,93.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M124.4,106.5c1-1.5,0.9-5.9,0.3-5.9c0,0-0.7,0.1-0.9,2.1c-0.1,0.9-0.2,3.5,0.1,3.9 C124,106.8,124.1,106.9,124.4,106.5 M124.4,99.2c0.4-0.5,1.4-1.7,1.7,1.2c0.4,5.2-1.9,9.2-2.8,8.5 C122.5,108.2,122.4,101.8,124.4,99.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M143,99.3l-0.2-1.4l-0.9,0.7l0.2,1.4L143,99.3 M140.7,96l0.9-0.7l0.3,2.3l0.9-0.7l-0.3-2.3l0.9-0.7 l0.3,2.3l0.9-0.7v1.1l-0.8,0.6l0.2,1.4l0.9-0.7V99l-0.8,0.6l0.3,2.3l-0.9,0.7l-0.3-2.3l-0.9,0.7l0.3,2.3l-0.9,0.7l-0.3-2.3 l-0.9,0.7v-1.1l0.8-0.6l-0.2-1.4l-0.9,0.7v-1.1l0.8-0.6L140.7,96"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M132.7,110.8c0.8-0.9,1-2.7,0.4-2.6c-0.8,0.1-1.5,2.4-0.9,2.8C132.4,111.1,132.6,110.9,132.7,110.8  M132.7,107.1c1.2-1.1,1.6,0,1.6,1.2c-0.1,2.3-1.9,4.8-2.7,4C130.7,111.6,131.5,108.4,132.7,107.1 M136.9,102.8 c0.9-0.9,1.1-2.5,0.5-2.6c-0.7-0.1-1.6,2-1.1,2.7C136.3,103,136.6,103,136.9,102.8 M136.9,99.1c1.3-1.1,1.8,0.2,1.7,1.5 c-0.3,2.3-2.2,4.6-3,3.6C134.7,103.2,135.5,100.3,136.9,99.1 M133.5,102c2,3.7,2.1,3.8,3.3,5.9l-0.6,1.1 c-2.1-3.6-2.2-3.8-3.4-5.8L133.5,102"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M127.4,107.5c0.9,1.4,1.8,4,0,10.9l0,0.1c-0.2,0-0.5,0.1-0.7,0.1c1.2-4.9,1.2-7.5,0-9.5L127.4,107.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M123.8,112.1c0.2,0,0.5-0.1,0.6-0.1c-1.1,4.8-1.1,7.6,0,9.5l-0.6,1.6C122.6,121,122.6,117.3,123.8,112.1 L123.8,112.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M143,113.2c0.7-0.6,0.8-1.5,0.4-1.5c-0.3,0-0.9,0.4-1.1,0.6l-0.3,0.3c0,0.6,0,0.8,0.2,0.9 C142.4,113.6,142.8,113.4,143,113.2 M142.7,108.4c1.1-0.8,1.7-0.7,2-0.6c-0.2,0.5-0.5,1.1-0.8,1.6c-0.8-0.6-2,0.7-2,1.9 c2.3-1.8,3.3-1.7,3,0.2c-0.3,1.8-2.3,3.7-3,2.8l0,0v0.8l-1.2,1C140.7,111.1,140.7,110,142.7,108.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M135.8,118.9c1.3-1.2,1.2-3.3,0.6-3.3c-1-0.1-2.1,2.8-1.4,3.5C135.2,119.3,135.4,119.2,135.8,118.9  M136.7,110.2l1.3-1.1c0,2.7,0,6.3,0,8.9c0,0.1,0,0.3,0,0.4l-1.2,1v-0.8c-1.3,3.1-2.6,2.9-3,2.2c-1-2.3,1.3-7.2,2.7-6.7 c0.1,0,0.1,0.1,0.2,0.1l0,0V110.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M129.4,120.6c1.6-1.6,2-0.2,2,1c0,3.1-2.3,6.4-3.3,5.9c0.2-0.6,0.5-1.5,0.7-2.1c0.6,0.4,1.6-1.6,1.4-2.9 c-0.1-0.8-0.5-0.7-0.9-0.2c-0.1,0.1-0.3,0.5-0.5,1c-0.2-0.1-0.5-0.3-0.7-0.5C128.6,121.6,129.1,120.9,129.4,120.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M124.7,131c0.5-0.7,0.6-1.5,0.6-1.8c0-0.8-0.2-0.7-0.5-0.7c-0.2,0.8-0.6,1.9-0.8,2.7 C124.2,131.4,124.4,131.4,124.7,131 M124.6,127c0.8-2.3,0.2-2,0.1-2c-0.4,0.3-1,1.9-0.4,2C124.4,127.1,124.5,127,124.6,127  M124.5,123.7c1.1-1.4,1.3-0.6,1.4-0.1c0.2,1-0.2,2.1-0.5,3.1c1.1-0.6,1.2,1.2,0.8,2.8c-0.4,1.6-1.8,4.3-2.8,3.8l-0.4,1.3 l-1.2,1.7l0.9-3.4l-0.9-1.2l1-1.5l0.4,0.6c0.2-0.6,0.4-1.4,0.6-2c-1.3,0.3-0.9-2.8,0.1-4.5 C124.2,124.1,124.4,123.9,124.5,123.7"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st10",
  points: "134.9,78.9 137,77 137,78.5 134.9,80.4 134.9,78.9  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M130.7,83.7l1-3.5c-0.4,0.5-0.9,0.9-1.3,1.4l-0.5,1.7l-0.5-0.7c-0.4,0.4-0.8,0.9-1.2,1.3l1,1.3l-1.3,4.7 l1.3-1.4l0.8-2.9l0.9,1.1l1.3-1.4L130.7,83.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M123.8,89.6c-0.2,0.3-0.4,0.6-0.6,0.9c0.4,1.4,0.8,3.2,1.2,4.6l0.6-1.1 C124.6,92.7,124.1,90.9,123.8,89.6"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st10",
  points: "141.4,118.8 142.6,117.9 142.6,120.5 144.6,119 144.6,120.5 142.6,122 142.6,124.6  141.4,125.6 141.4,122.9 139.5,124.5 139.5,122.9 141.4,121.4 141.4,118.8  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M143,136.2c0.7-0.5,1,0.2,0.8,0.9c-0.2,1.1-1.2,2-1.6,1.4C142,138,142.4,136.7,143,136.2 M142.3,130.2 l1.4-1.1c0,1.8,0,4.1,0,5.9l-1.4,1.1C142.3,134.3,142.3,132,142.3,130.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M136.7,141.5c0.6-0.5,0.8,0.1,0.8,0.7c-0.1,1.1-1,2.1-1.4,1.7C135.7,143.4,136.1,142,136.7,141.5  M136.6,134.8c1.3-1.1,2-0.8,2.1,0.8c-0.4,0.4-0.9,0.9-1.3,1.3c-0.1-1.2-1-0.2-1-0.2c-0.1,0.1-1.2,1.4,0.2,2 c0.6,0.3,0.7,0.3,0.7,1v0.5l-1.3,1.1c0-0.6,0-0.8-0.3-0.9c-0.6-0.2-1.1-0.3-1-1.8C134.9,136.9,135.8,135.5,136.6,134.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M129.5,142l1-1.1l1.8,0.6l-0.7,1.9l-1.1-0.4c0,2,0,4.7,0,6.7l-1.1,1.2 C129.5,148.2,128.6,144.5,129.5,142"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M124.4,155.4c1-1.5,0.9-5.9,0.3-5.9c0,0-0.7,0.1-0.9,2.1c-0.1,0.9-0.2,3.5,0.1,3.9 C124,155.7,124.1,155.7,124.4,155.4 M124.4,148.1c0.4-0.5,1.4-1.7,1.7,1.2c0.4,5.2-1.9,9.2-2.8,8.5 C122.5,157.1,122.4,150.7,124.4,148.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M143,148.2l-0.2-1.4l-0.9,0.7l0.2,1.4L143,148.2 M140.7,144.8l0.9-0.7l0.3,2.3l0.9-0.7l-0.3-2.3l0.9-0.7 l0.3,2.3l0.9-0.7v1.1l-0.8,0.6l0.2,1.4l0.9-0.7v1.1l-0.8,0.6l0.3,2.3l-0.9,0.7l-0.3-2.3l-0.9,0.7l0.3,2.3l-0.9,0.7l-0.3-2.3 l-0.9,0.7v-1.1l0.8-0.6l-0.2-1.4l-0.9,0.7v-1.1l0.8-0.6L140.7,144.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M132.7,159.7c0.8-0.9,1-2.7,0.4-2.6c-0.8,0.1-1.5,2.4-0.9,2.8C132.4,160,132.6,159.8,132.7,159.7  M132.7,156c1.2-1.1,1.6,0,1.6,1.2c-0.1,2.3-1.9,4.8-2.7,4C130.7,160.5,131.5,157.3,132.7,156 M136.9,151.6 c0.9-0.9,1.1-2.5,0.5-2.6c-0.7-0.1-1.6,2-1.1,2.7C136.3,151.9,136.6,151.9,136.9,151.6 M136.9,148c1.3-1.1,1.8,0.2,1.7,1.5 c-0.3,2.3-2.2,4.6-3,3.6C134.7,152.1,135.5,149.2,136.9,148 M133.5,150.9c2,3.7,2.1,3.8,3.3,5.9l-0.6,1.1 c-2.1-3.6-2.2-3.8-3.4-5.8L133.5,150.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M127.4,156.4c0.9,1.4,1.8,4,0,10.9l0,0.1c-0.2,0-0.5,0.1-0.7,0.1c1.2-4.9,1.2-7.5,0-9.5L127.4,156.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M123.8,160.9c0.2,0,0.5-0.1,0.6-0.1c-1.1,4.8-1.1,7.6,0,9.5l-0.6,1.6 C122.6,169.9,122.6,166.2,123.8,160.9L123.8,160.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M144.5,156.7c0.1,0,0.1,0.1,0.2,0.1c-0.2,0.5-0.5,1.1-0.8,1.6c-0.9-0.5-1.9,0.7-2,1.9 c0.7-0.6,1.4-1.1,2.1-1.3c-1.1,0.9-2.2,1.7-3.3,2.6l0-0.3c0.1-1.7,0.6-2.9,2.3-4.2C143.3,156.9,143.9,156.5,144.5,156.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M136.7,164.8c-0.3-0.8-1.1,0-1.5,0.7c-0.3,0.5-0.3,0.9-0.4,1.1c0.6-0.6,1.3-1.2,1.9-1.8 C136.7,164.9,136.7,164.8,136.7,164.8 M138,158c0,1.8,0,4.1,0,5.9c-1.5,1.3-3,2.6-4.4,4l0-0.1c0.5-3.9,2.4-5.2,3.1-4.7 c0,0,0,0,0,0v-4L138,158"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M131.4,169.9c-0.1-0.5-0.4-2-2-0.3c-0.6,0.7-0.9,1.2-1.2,2.2c0.2,0.1,0.5,0.3,0.7,0.5 c0.4-1.1,1-1.7,1.3-1.2c0,0.1,0.1,0.2,0.1,0.3c0.4-0.4,0.8-0.8,1.2-1.2C131.4,170,131.4,169.9,131.4,169.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M125,177.4c-0.1,0-0.1,0-0.2,0l-0.1,0.4C124.8,177.7,124.9,177.6,125,177.4 C125,177.4,125,177.4,125,177.4 M124.6,175.9c0.8-2.3,0.2-2,0.1-2c-0.4,0.3-1,1.9-0.4,2C124.4,175.9,124.5,175.9,124.6,175.9  M123,179.1l0.4,0.5c-0.4,0.5-0.7,1-1,1.5l-0.4-0.5L123,179.1 M126.3,175.8C126.3,175.8,126.3,175.8,126.3,175.8 c-0.9,1.2-1.9,2.4-2.7,3.6l0.5-1.8c-1.3,0.3-0.8-3,0.2-4.7c0.1-0.2,0.4-0.5,0.5-0.7c0.9-0.8,1.3-0.5,1.2,1 c0,0.8-0.2,1.4-0.5,2.3C125.7,175.5,126,175.3,126.3,175.8"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st10",
  points: "134.9,127.7 137,125.9 137,127.4 134.9,129.2 134.9,127.7  "
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st10",
  points: "128.1,132.6 129.3,131.2 129.9,132.2 130.6,129.9 131.9,128.5 130.7,132.6 132.2,134.3  130.8,135.6 130,134.6 129.2,137.4 127.9,138.9 129.3,134.1 128.1,132.6  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M123.4,137.2c0.4,1.7,1,4,1.5,5.6l-0.6,1.1c-0.4-1.7-1-3.9-1.5-5.6L123.4,137.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M121.1,94.5l-1.2,1.9v-1.1c-0.2,0.4-0.4,0.7-0.7,1.1v1.1l-1.1,1.9v1.6l1.1-1.9v2.6l0.7-1.1v-2.6l1.2-1.9 V94.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M120.2,112c0.3-0.5,0.5-0.1,0.5,0c0.2,0.9-0.5,2.7-0.8,2.5C119.6,114.3,119.8,112.7,120.2,112  M119.8,106.1l0.8-1.3c0,1.8,0,4.1,0,5.9l-0.8,1.3C119.8,110.2,119.3,107.8,119.8,106.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M116.7,118.4c0.2-0.4,0.3-0.3,0.4-0.1c0.2,0.7-0.3,2.9-0.6,2.7C116.2,120.7,116.4,119.1,116.7,118.4  M116.7,111.7c0.2-0.4,0.7-1.5,1-0.5c0.1,0.3,0.1,0.6,0.1,0.9c-0.2,0.5-0.5,1.1-0.7,1.5c0-0.4-0.1-0.5-0.2-0.5 c-0.4,0.1-0.9,2.1-0.4,2.4c0.5,0.3,0.5,0.3,0.5,1v0.5l-0.7,1.4c0-0.7,0-0.8-0.2-0.9c-0.2,0-0.5-0.2-0.4-1.6 C115.8,114.1,116.3,112.6,116.7,111.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M113.3,120.3l0.4-1.3l0.8,0.3l-0.3,2l-0.5-0.2c0,2,0,4.7,0,6.7l-0.5,1.4 C113.3,126.4,112.9,122.9,113.3,120.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M111.5,134.6c0.3-1.8,0.3-5.6,0.1-5.9c-0.3,0.2-0.4,5.7-0.2,6.2C111.4,134.9,111.4,134.9,111.5,134.6  M111.5,127.3c0.1-0.7,0.2-0.8,0.3-0.9c0.6,0.6,0.1,9.4-0.5,10.8c0,0-0.1,0-0.1,0C110.9,136.4,111,129.9,111.5,127.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M120.2,124l-0.1-1.4l-0.5,0.9l0.1,1.4L120.2,124 M118.9,121.1l0.5-0.9l0.1,2.2l0.5-0.9l-0.1-2.2l0.5-0.9 l0.2,2.2l0.5-0.8v1.1l-0.5,0.7l0.1,1.4l0.5-0.8v1.1l-0.5,0.7l0.2,2.2l-0.5,0.8l-0.2-2.2l-0.5,0.9l0.1,2.2l-0.5,0.9l-0.1-2.2 l-0.5,0.9v-1.1l0.4-0.7l-0.1-1.4l-0.5,0.9V124l0.4-0.7L118.9,121.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M114.8,137.3c0.4-1.1,0.5-2.9,0.2-2.7c-0.4,0.2-0.7,2.9-0.4,3C114.6,137.6,114.6,137.6,114.8,137.3  M114.8,133.7c0.3-0.6,0.5-0.8,0.6-0.4c0.5,1.1-0.5,6.1-1.1,6C113.8,139.1,114.1,135.3,114.8,133.7 M116.8,128.5 c0.5-1.1,0.6-2.8,0.2-2.6c-0.4,0.2-0.9,2.8-0.5,2.9C116.6,128.8,116.7,128.8,116.8,128.5 M116.8,124.9 c0.4-0.8,0.7-0.6,0.8-0.3c0.5,1.4-0.6,6-1.3,5.8C115.6,130.2,116,126.5,116.8,124.9 M115.1,128.5c1,3.3,1,3.4,1.7,5.3 l-0.3,1.2c-1.1-3.2-1.1-3.4-1.7-5.2L115.1,128.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M112.5,135c0.5,2,0.5,5.3,0,10.9l0,0.1c-0.1,0.1-0.2,0.2-0.3,0.2c0.4-4.5,0.5-7.5,0-9.5L112.5,135"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M111.3,140.3c0.1-0.1,0.1-0.2,0.2-0.3c-0.5,7.1-0.1,8.8,0,9.5l-0.2,1.7 C110.9,148.8,111.2,142.8,111.3,140.3L111.3,140.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M120.2,137.9c0.4-0.7,0.5-1.6,0.2-1.6c-0.1,0-0.4,0.3-0.7,0.8l-0.2,0.3c0,0.6,0,1.2,0.4,0.8 C120,138.2,120.1,138.1,120.2,137.9 M120,133.1c0.6-1,1-1,1.2-0.9c-0.1,0.5-0.3,1.2-0.4,1.7c-0.6-0.4-1.2,1.2-1.2,2.3 c0.4-0.7,1.5-2.5,1.7-1.4c0.4,1.6-1,4.9-1.6,4.6c-0.1,0-0.1-0.1-0.1-0.1l0,0v0.8l-0.7,1.2C118.9,136.1,118.9,135.1,120,133.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M116.2,144.9c0.7-1.5,0.6-3.5,0.3-3.4c-0.5,0.1-1.1,3.4-0.7,3.8C116,145.4,116.1,145.2,116.2,144.9  M116.7,136l0.7-1.4c0,2.7,0,6.3,0,8.9c0,0.1,0,0.3,0,0.4l-0.6,1.3v-0.8c-0.8,3.8-1.4,3-1.4,3c-0.7-1.2,0.3-7.5,1.2-7.5 c0,0,0.1,0.1,0.1,0.1l0,0V136"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M113.3,147.8c0.1-0.3,0.5-1.4,0.7-0.8c0.5,1.2-0.4,7.7-1.2,8c0,0,0,0-0.1,0c0.1-0.7,0.2-1.6,0.3-2.2 c0,0,0,0,0,0c0,0,0,0,0,0c0.3-0.3,0.8-3.6,0.4-3.8c-0.3,0.2-0.4,1.1-0.4,1.6c-0.1-0.1-0.2-0.2-0.3-0.3 C112.9,149,113.1,148.2,113.3,147.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M111.6,159c0.2-0.9,0.3-2.6,0.1-2.5c0,0,0,0-0.1,0.1c-0.1,0.9-0.2,2-0.2,2.9 C111.4,159.5,111.5,159.5,111.6,159 M111.5,155.1c0.1-0.8,0.2-1.9,0.1-2.1c0,0,0,0,0,0C111.5,153.2,111.3,155.2,111.5,155.1 C111.5,155.2,111.5,155.1,111.5,155.1 M111.5,151.8c0.2-0.8,0.2-0.8,0.3-1c0.3,0.2,0.1,2.9,0,3.8c0.1-0.2,0.1-0.2,0.2-0.2 c0.5,0.7-0.3,6.8-0.7,7.2c0,0,0,0-0.1,0l-0.1,1.4l-0.3,1.9l0.2-3.6l-0.2-1l0.2-1.7l0.1,0.5c0-0.6,0.1-1.5,0.2-2.1 c0,0,0,0,0,0.1c0,0-0.1,0-0.1,0C111.1,156.5,111.2,153.6,111.5,151.8"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st10",
  points: "115.8,105 116.8,102.8 116.8,104.2 115.8,106.5 115.8,105  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M113.8,110.6l0.5-3.7c-0.2,0.5-0.4,1.1-0.6,1.6l-0.2,1.8l-0.2-0.6c-0.2,0.5-0.3,1-0.5,1.6l0.4,1.1 l-0.5,5l0.5-1.7l0.3-3l0.4,0.9l0.6-1.6L113.8,110.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M111.3,117.9c-0.1,0.3-0.1,0.7-0.2,1c0.1,1.3,0.2,3,0.3,4.4l0.2-1.2 C111.5,120.7,111.4,119.1,111.3,117.9"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st10",
  points: "119.3,143.7 120,142.6 120,145.2 121.1,143.4 121.1,144.9 120,146.8 120,149.4 119.3,150.5  119.3,147.9 118.2,149.8 118.2,148.2 119.3,146.4 119.3,143.7  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M120.2,160.9c0.3-0.5,0.5-0.1,0.5,0c0.2,0.9-0.5,2.7-0.8,2.5C119.6,163.2,119.8,161.6,120.2,160.9  M119.8,155l0.8-1.3c0,1.8,0,4.1,0,5.9l-0.8,1.3C119.8,159.1,119.3,156.7,119.8,155"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M116.7,167.3c0.2-0.4,0.3-0.3,0.4-0.1c0.2,0.7-0.3,2.9-0.6,2.7C116.2,169.6,116.4,168,116.7,167.3  M116.7,160.6c0.2-0.4,0.7-1.5,1-0.5c0.1,0.3,0.1,0.6,0.1,0.9c-0.2,0.5-0.5,1.1-0.7,1.5c0-0.4-0.1-0.5-0.2-0.5 c-0.4,0.1-0.9,2.1-0.4,2.4c0.5,0.3,0.5,0.3,0.5,1v0.5l-0.7,1.4c0-0.7,0-0.8-0.2-0.9c-0.2,0-0.5-0.2-0.4-1.6 C115.8,163,116.3,161.5,116.7,160.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M113.3,169.2l0.4-1.3l0.8,0.3l-0.3,2l-0.5-0.2c0,2,0,4.7,0,6.7l-0.5,1.4 C113.3,175.3,112.9,171.8,113.3,169.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M111.5,183.5c0.3-1.8,0.3-5.6,0.1-5.9c-0.3,0.2-0.4,5.7-0.2,6.2C111.4,183.8,111.4,183.8,111.5,183.5  M111.5,176.2c0.1-0.7,0.2-0.8,0.3-0.9c0.6,0.6,0.1,9.4-0.5,10.8c0,0-0.1,0-0.1,0C110.9,185.2,111,178.8,111.5,176.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M120.2,172.8l-0.1-1.4l-0.5,0.9l0.1,1.4L120.2,172.8 M118.9,169.9l0.5-0.9l0.1,2.2l0.5-0.9l-0.1-2.2 l0.5-0.9l0.2,2.2l0.5-0.8v1.1l-0.5,0.7l0.1,1.4l0.5-0.8v1.1l-0.5,0.7l0.2,2.2l-0.5,0.8l-0.2-2.2l-0.5,0.9l0.1,2.2l-0.5,0.9 l-0.1-2.2l-0.5,0.9v-1.1l0.4-0.7l-0.1-1.4l-0.5,0.9v-1.1l0.4-0.7L118.9,169.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M114.8,186.2c0.4-1.1,0.5-2.9,0.2-2.7c-0.4,0.2-0.7,2.9-0.4,3C114.6,186.5,114.6,186.5,114.8,186.2  M114.8,182.6c0.3-0.6,0.5-0.8,0.6-0.4c0.5,1.1-0.4,6.1-1.1,6C113.8,187.9,114.1,184.2,114.8,182.6 M116.8,177.4 c0.5-1.1,0.6-2.8,0.2-2.6c-0.4,0.2-0.9,2.8-0.5,2.9C116.6,177.7,116.7,177.7,116.8,177.4 M116.8,173.8 c0.4-0.8,0.7-0.6,0.8-0.3c0.5,1.4-0.6,6-1.3,5.8C115.6,179.1,116,175.4,116.8,173.8 M115.1,177.3c1,3.4,1,3.4,1.7,5.3 l-0.3,1.2c-1.1-3.2-1.1-3.4-1.7-5.2L115.1,177.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M112.5,183.9c0.5,2,0.5,5.3,0,10.9l0,0.1c-0.1,0.1-0.2,0.2-0.3,0.2c0.4-4.5,0.5-7.5,0-9.5L112.5,183.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M111.3,189.2c0.1-0.1,0.1-0.2,0.2-0.3c-0.5,7.1-0.1,8.8,0,9.5l-0.2,1.7 C110.9,197.6,111.2,191.7,111.3,189.2L111.3,189.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M121.1,181.1c0,0,0.1,0,0.1,0c-0.1,0.5-0.3,1.2-0.4,1.7c-0.5-0.4-1.1,1-1.2,2.3c0.4-0.7,0.8-1.4,1.2-1.6 c-0.7,1.1-1.3,2.1-1.9,3.2l0-0.3c0.1-1.8,0.3-3.1,1.3-4.6C120.4,181.5,120.7,181,121.1,181.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M116.7,190.6c-0.1-0.3-0.2-0.4-0.3-0.2c0,0-0.5,0.7-0.6,2.4c0.3-0.7,0.6-1.4,1-2.1 C116.7,190.7,116.7,190.6,116.7,190.6 M117.4,183.6c0,1.8,0,4.1,0,5.9c-0.8,1.6-1.5,3.2-2.2,4.8l0-0.1 c0.3-4.4,1.3-5.4,1.5-5.3c0,0,0,0.1,0.1,0.1c0,0,0,0,0,0v-4L117.4,183.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M114.1,196.6c-0.1-0.8-0.2-1.1-0.5-0.9c-0.2,0.2-0.3,0.6-0.4,0.9c-0.2,0.7-0.4,1.4-0.5,2.4 c0.1,0.1,0.2,0.2,0.3,0.3c0.1-0.9,0.3-1.4,0.4-1.6c0,0,0,0,0.1,0c0.1,0.1,0.1,0.1,0.1,0.4c0.2-0.5,0.3-1,0.5-1.4 C114.1,196.8,114.1,196.7,114.1,196.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M111.7,205.4C111.7,205.4,111.6,205.4,111.7,205.4l-0.1,0.5C111.6,205.7,111.6,205.6,111.7,205.4 C111.7,205.4,111.7,205.4,111.7,205.4 M111.5,204c0.1-0.8,0.2-1.9,0.1-2.1c0,0,0,0,0,0C111.5,202.1,111.3,204.1,111.5,204 C111.5,204,111.5,204,111.5,204 M111.1,207.5l0.1,0.4c-0.1,0.6-0.2,1.1-0.3,1.7l-0.1-0.4L111.1,207.5 M112.1,203.5 C112.1,203.6,112.1,203.6,112.1,203.5c-0.3,1.4-0.6,2.8-0.8,4.2l0.1-1.8c0,0-0.1,0.1-0.1,0.1c-0.2-0.2-0.2-3.3,0.3-5.6 c0.1-0.4,0.1-0.5,0.2-0.6c0.3,0.2,0.1,2.9,0,3.8c0-0.1,0.1-0.2,0.1-0.2c0,0,0,0,0.1,0C112,203.4,112.1,203.5,112.1,203.5"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st10",
  points: "115.8,153.9 116.8,151.6 116.8,153.1 115.8,155.4 115.8,153.9  "
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st10",
  points: "112.8,160 113.2,158.4 113.5,159.3 113.8,156.8 114.4,155.2 113.8,159.5 114.5,160.9  113.9,162.5 113.5,161.6 113.2,164.6 112.7,166.3 113.2,161.3 112.8,160  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M111.2,165.5c0.1,1.6,0.3,3.7,0.4,5.3l-0.2,1.2c-0.1-1.6-0.3-3.7-0.4-5.3L111.2,165.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M110.7,123.3l-0.2,2.1v-1.1c0,0.4-0.1,0.8-0.1,1.3v1.1l-0.1,2.1v1.6l0.1-2.1v2.6l0.1-1.3v-2.6l0.2-2.1 V123.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M110.6,141c0-0.2,0-0.3,0-0.3c0.1,0.2,0,2.8-0.1,2.9C110.5,143.4,110.5,141.6,110.6,141 M110.5,135.2 l0.1-1.5c0,1.8,0,4.1,0,5.9l-0.1,1.5C110.5,139.3,110.4,136.9,110.5,135.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M110.6,152.9l0-1.4l-0.1,1l0,1.4L110.6,152.9 M110.4,150.3l0-1l0,2.2l0.1-1l0-2.2l0.1-1l0,2.2l0.1-0.9 v1.1l-0.1,0.8l0,1.4l0.1-0.9v1.1l-0.1,0.8l0,2.2l-0.1,1l0-2.2l-0.1,1l0,2.2l-0.1,1l0-2.2l0,1v-1.1l0-0.8l0-1.4l0,1v-1.1l0-0.8 L110.4,150.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M110.5,166.9c0.1-0.8,0.1-1.5,0-1.7c0,0,0,0.1-0.1,0.9l0,0.4c0,0.7,0,0.8,0,0.9 C110.5,167.4,110.5,167.3,110.5,166.9 M110.5,162.1c0.1-0.9,0.1-1,0.1-1.2c0,0,0,0,0,0c0,0.5-0.1,1.3-0.1,1.8c0,0,0,0,0,0 c-0.1,0.3-0.1,2.5-0.1,2.6c0.1-1.5,0.1-1.9,0.2-2c0.2,0.5-0.1,4.8-0.2,5.2c0,0,0-0.1,0-0.1l0,0v0.8l-0.1,1.4 C110.4,164.9,110.4,163.8,110.5,162.1"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st10",
  points: "110.4,172.9 110.5,171.6 110.5,174.2 110.7,172.1 110.7,173.7 110.5,175.8 110.5,178.4  110.4,179.7 110.4,177 110.4,179.2 110.4,177.6 110.4,175.5 110.4,172.9  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M110.6,189.8c0-0.2,0-0.3,0-0.3c0.1,0.2,0,2.8-0.1,2.9C110.5,192.3,110.5,190.4,110.6,189.8 M110.5,184 l0.1-1.5c0,1.8,0,4.1,0,5.9l-0.1,1.5C110.5,188.1,110.4,185.8,110.5,184"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M110.6,201.8l0-1.4l-0.1,1l0,1.4L110.6,201.8 M110.4,199.2l0-1l0,2.2l0.1-1l0-2.2l0.1-1l0,2.2l0.1-0.9 v1.1l-0.1,0.8l0,1.4l0.1-0.9v1.1l-0.1,0.8l0,2.2l-0.1,1l0-2.2l-0.1,1l0,2.2l-0.1,1l0-2.2l0,1v-1.1l0-0.8l0-1.4l0,1v-1.1l0-0.8 L110.4,199.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M110.7,209.8l-0.1,1.8c0,0,0,0,0,0c-0.1,0.2-0.1,2.2-0.1,2.6c0-0.3,0.1-1.4,0.2-1.9 c-0.1,1.2-0.2,2.4-0.2,3.6l0-0.3c0-2.5,0-3.6,0.1-4.9C110.6,210.1,110.6,209.9,110.7,209.8"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M246.9,38.7l3.3,0v-1.1c0.7,0,1.3,0,2,0v1.1l3.3-0.1v1.6l-3.3,0.1v2.6l-2,0v-2.6l-3.3,0V38.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M251.4,54.8c-1.3,0.1-1.8,1.2-1.1,1.9c0.9,0.8,2.5,0.3,2.5-0.7C252.8,55.3,252.2,54.8,251.4,54.8  M252.6,48.2l-2.3,0c0,1.8,0,4.1,0,5.9l2.3,0C252.6,52.3,252.6,50,252.6,48.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M249.5,66.8l0.3-1.6l1.5,0l-0.3,1.6L249.5,66.8 M253.4,61.5l-1.5,0l-0.4,2.5l-1.5,0l0.4-2.5l-1.5,0 l-0.4,2.5l-1.5,0v1.1l1.3,0l-0.3,1.6l-1.5,0v1.1l1.3,0l-0.4,2.5l1.5,0l0.4-2.5l1.5,0l-0.4,2.5l1.5,0l0.4-2.5l1.5,0v-1.1 l-1.3,0l0.3-1.6l1.5,0V64l-1.3,0L253.4,61.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M249.6,80.6c-1.1,0-1.3-0.6-1-1c0.4-0.5,1.7-0.5,2.2-0.5l0.6,0c0,0.6,0,0.8-0.3,1.1 C250.6,80.6,249.9,80.6,249.6,80.6 M250.1,75.6c-1.8,0-2.8,0.6-3.3,1c0.4,0.3,0.9,0.7,1.2,1c1.4-1.2,3.3-0.8,3.4,0.3 c-1.2,0-3.4,0.1-4.3,0.7c-1.1,0.8-0.9,2-0.3,2.5c0.9,0.9,3.5,1.1,4.6-0.2l0,0v0.8l2.1,0c0-4.2,0-4.2-0.4-4.9 C252.5,75.7,251.2,75.6,250.1,75.6"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st10",
  points: "252,85.6 250.4,85.6 250.4,87.7 247.8,87.7 247.8,89 250.4,89 250.4,91.1 252,91.1 252,89  254.6,88.9 254.6,87.6 252,87.7 252,85.6  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M251.2,103.7c-1.3,0.1-1.8,1.2-1.1,1.9c0.9,0.8,2.5,0.3,2.5-0.7C252.6,104.2,252,103.7,251.2,103.7  M252.4,97.1l-2.3,0c0,1.8,0,4.1,0,5.9l2.3,0C252.4,101.2,252.4,98.9,252.4,97.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M249.5,115.6l0.3-1.6l1.5,0l-0.3,1.6L249.5,115.6 M253.4,110.4l-1.5,0l-0.4,2.5l-1.5,0l0.4-2.5l-1.5,0 l-0.4,2.5l-1.5,0v1.1l1.3,0l-0.3,1.6l-1.5,0v1.1l1.3,0l-0.4,2.5l1.5,0l0.4-2.5l1.5,0l-0.4,2.5l1.5,0l0.4-2.5l1.5,0v-1.1 l-1.3,0l0.3-1.6l1.5,0v-1.1l-1.3,0L253.4,110.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M247,125.1c-0.1,0.1-0.2,0.2-0.3,0.2c0.4,0.3,0.9,0.7,1.2,1c1.4-1.1,3.2-0.9,3.4,0.3 c-1.1,0-2.4,0-3.5,0.4c1.9,0,3.7,0,5.6-0.1l0-0.3c-0.3-1.8-1.3-2.4-3.9-2.3C249,124.5,247.9,124.6,247,125.1"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M392.4,139.5v7.2l0-0.4C392.4,144.1,392.4,141.8,392.4,139.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M392.4,152.4c0,2.5,0,5.1,0,7.6V152.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M392.4,164.6v1.7v-0.1C392.4,165.6,392.4,165.1,392.4,164.6 M392.4,168.5v3.3l0,0.1l0-1.9l0-0.5l0-3.9 l0,1.7L392.4,168.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M392.4,128.2c0-0.1,0-0.2,0-0.3l0,1.2V128.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M392.4,188.4v7.2l0-0.4C392.4,193,392.4,190.7,392.4,188.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M392.4,201.2c0,2.5,0,5.1,0,7.6V201.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M392.4,213.5v1.7V215C392.4,214.5,392.4,214,392.4,213.5 M392.4,217.4v0.3c0-0.5,0-1,0-1.5l0-1.7l0,1.7 L392.4,217.4"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st10",
  points: "392.4,175.4 392.4,174.9 392.4,178 392.4,175.4  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M392.3,125.5l-0.2-2.1v-1.1c0-0.4-0.1-0.8-0.1-1.2v1.1l-0.3-2.1v1.6l0.3,2.1v2.6l0.1,1.2V125l0.2,2.1 V125.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M392.2,140c0.1,0.9,0.1,2.4,0.1,2.6c-0.1-0.1-0.2-2.7-0.1-2.9C392.1,139.7,392.1,139.7,392.2,140  M392.1,132.7l0.1,1.5c0,1.8,0,4.1,0,5.9l-0.1-1.5C392.1,136.8,392.1,134.5,392.1,132.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M391.1,133.1c0.2,0.9,0.2,2.5,0.1,2.6c-0.2-0.2-0.4-2.7-0.2-2.9C391,132.7,391,132.8,391.1,133.1  M391.1,126.2c0.2,0.9,0.4,2.4,0.5,5.1c-0.1-0.4-0.3-1-0.3-1.5c0-0.9-0.2-2-0.3-2.2c-0.1,0.1,0,1,0.1,2.2 c0.2,1.6,0.2,1.9,0.2,2.8v0.5l-0.3-1.5c0-0.6,0-0.8-0.1-1.6c-0.3-3-0.4-4.6-0.1-4.8C390.8,125.3,390.9,125.4,391.1,126.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M388.6,117.8l0.5,1.3l0.7,4.6l-0.3,0.4l-0.4-2.9c0,2,0,4.7,0,6.7l-0.5-1.4 C388.6,124,388.6,120.4,388.6,117.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M385.6,118.2c0.1,0.2,0.3,0.5,0.4,0.1c0.5-1.4-0.1-6.4-0.7-6C385,112.5,384.9,116.8,385.6,118.2  M385.6,110.8c1.5,3.3,1.4,10.1,0.6,9.8c-1.4-0.4-2.6-10.2-1.3-10.6C385.2,110,385.4,110.4,385.6,110.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M392.2,152l0-1.7l-0.1-1l0,1.7L392.2,152 M391.9,144.4l0.1,1l0,2.8l0.1,1l0-2.8l0.1,1l0,2.8l0.1,1v1.1 l-0.1-0.8l0,1.7l0.1,1v1.1l-0.1-0.8l0,2.8l-0.1-1l0-2.8l-0.1-1l0,2.8l-0.1-1l0-2.8l-0.1-0.9v-1.1l0.1,0.8l0-1.7l-0.1-0.9v-1.1 l0.1,0.8L391.9,144.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M389.9,142.8c0,0.1,0.1,0.4,0.2,0.3c0.2-0.4-0.1-3-0.4-3C389.6,140.2,389.7,142,389.9,142.8  M389.9,139.2c0.6,2,0.7,5.7,0.3,5.5c-0.6-0.2-1.2-6-0.7-6.2C389.6,138.5,389.8,138.6,389.9,139.2 M391.1,143.5 c0,0.2,0.1,0.3,0.1,0.3c0,0,0,0,0,0c0.2-0.3-0.1-3-0.3-3C390.9,140.9,391,142.7,391.1,143.5 M391.1,139.9 c0.4,1.9,0.5,5.4,0.2,5.6c-0.5-0.3-0.9-5.9-0.5-6.2C390.9,139.2,391,139.2,391.1,139.9 M390.2,135.6c0.6,8.1,0.7,8.4,0.9,12.9 l-0.2-0.2c-0.6-8.1-0.6-8.4-1-12.9L390.2,135.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M387.5,126.9c0.4,3.8,1,8.5,0,11l0,0c-0.1-0.5-0.6-1.3-0.3-1.8c0.9-2.4,0.2-7.6-0.1-9.3L387.5,126.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M385.2,122c0.2,0.5,0.6,1.3,0.4,1.8c-1,2.4-0.3,6.9,0.1,9.3l-0.5-0.2C384.6,128.6,384,124.5,385.2,122 L385.2,122"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M392.1,165.8c0,0.2,0,0.3,0,0.3c0,0,0-1.1-0.1-2.6l0-0.4C392,163.7,392,164.6,392.1,165.8 M392.1,160.4 c0.1,0.8,0.1,1.8,0.2,3.1c0,0.1,0,0.2-0.1,0.2c0-1.2-0.1-2-0.2-2.3c0,0-0.1,0.2,0,0.7c0.3,2.6,0.3,5.8,0.2,6 c-0.1-0.2-0.2-1.8-0.2-3.1l0,0v0.8l-0.2-1.4c0-4.7,0-4.7,0.1-5C392,159.5,392,159.5,392.1,160.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M390.9,157.4c0.1,0.3,0.1,0.4,0.2,0.4c0,0,0,0,0,0c0.2-0.5-0.1-3.9-0.4-3.9 C390.5,154.1,390.6,156.2,390.9,157.4 M391.1,150.6l0.3,1.5c0,2.7,0,6.3,0,8.9c0,0.1,0,0.3,0,0.4l-0.3-1.3v-0.8c0,0,0,0,0,0.1 c0,0,0,0-0.1,0c-0.5-0.6-1.2-6.8-0.6-7.7c0,0,0.1,0,0.1,0c0.3,0.3,0.5,1.7,0.6,3l0,0V150.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M388.6,145c1,3,1.1,7.6,0.5,7.2c-0.3-0.1-0.8-1.4-1.1-3.3c0.1-0.1,0.3-0.3,0.4-0.4 c0.2,1.3,0.4,1.5,0.5,1.6c0.4-0.4,0-3.6-0.5-3.8c0,0,0,0-0.1,0.1c-0.1-0.7-0.3-1.5-0.4-2.2C388.2,144.1,388.4,144.7,388.6,145 "
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M385.9,143.5c0.2,0.5,0.3,0.3,0.4,0.2c0.2-0.6-0.2-1.8-0.3-2.4c-0.2,0.2-0.4,0.4-0.6,0.5 C385.5,142.4,385.6,143.1,385.9,143.5 M385.7,139.1c0.1-0.1,0.3-0.2,0.2-0.9c-0.1-0.8-0.3-1.3-0.5-1.4 C385.5,136.9,385.1,136.7,385.7,139.1 M385.7,135.6c0.9,1.9,1.3,4.8,0.7,5.5c0.1,1.2,0.6,2.4,0.6,3.6c0,0.7,0,1.7-0.5,1.4 c0,0-0.8-0.6-1.6-3.8l-0.3,0.3l-1-1.7l0.8-0.7l-0.7-3.8l0.9,1.6l0.3,1.8c0.1-0.1,0.3-0.3,0.4-0.4c-0.9-3.2-0.7-4.8-0.2-4.5 C385.3,135,385.4,135.1,385.7,135.6"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st10",
  points: "390.6,115.6 391.2,117.9 391.2,119.4 390.6,117 390.6,115.6  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M389.1,111.1l0.4-1.1c-0.2-0.6-0.4-1.1-0.5-1.6l-0.2,0.6l-0.2-1.8c-0.2-0.5-0.4-1-0.6-1.5l0.5,3.6 l-0.7,1.5l0.6,1.6l0.4-1l0.4,3.1l0.5,1.7L389.1,111.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M385.1,99.4c-0.2-0.3-0.3-0.6-0.5-0.9c0.3,2.4,0.6,5.6,0.9,8l0.4,0.5 C385.7,104.7,385.8,101.6,385.1,99.4"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st10",
  points: "392,168.5 392.1,169.7 392.1,172.3 392.3,174.4 392.3,176 392.1,173.9 392.1,176.5 392,175.3  392,172.6 391.7,170.6 391.7,169 392,171.1 392,168.5  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M392.2,188.9c0.1,0.9,0.1,2.4,0.1,2.6c-0.1-0.1-0.2-2.7-0.1-2.9C392.1,188.6,392.1,188.6,392.2,188.9  M392.1,181.6l0.1,1.5c0,1.8,0,4.1,0,5.9l-0.1-1.5C392.1,185.7,392.1,183.4,392.1,181.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M391.1,181.9c0.2,0.9,0.2,2.5,0.1,2.6c-0.2-0.2-0.4-2.7-0.2-2.9C391,181.6,391,181.6,391.1,181.9  M391.1,175c0.2,0.9,0.4,2.4,0.5,5.1c-0.1-0.4-0.3-1-0.3-1.5c0-0.9-0.2-2-0.3-2.2c-0.1,0.1,0,1,0.1,2.2 c0.2,1.6,0.2,1.9,0.2,2.8v0.5l-0.3-1.5c0-0.6,0-0.8-0.1-1.6c-0.3-3-0.4-4.6-0.1-4.8C390.8,174.2,390.9,174.2,391.1,175"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M388.6,166.7l0.5,1.3l0.7,4.6l-0.3,0.4l-0.4-2.9c0,2,0,4.7,0,6.7l-0.5-1.4 C388.6,172.8,388.6,169.3,388.6,166.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M385.6,167c0.1,0.2,0.3,0.5,0.4,0.1c0.5-1.4-0.1-6.4-0.7-6C385,161.3,384.9,165.7,385.6,167  M385.6,159.7c1.5,3.3,1.4,10.1,0.6,9.8c-1.4-0.4-2.6-10.2-1.3-10.6C385.2,158.9,385.4,159.3,385.6,159.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M392.2,200.9l0-1.7l-0.1-1l0,1.7L392.2,200.9 M391.9,193.2l0.1,1l0,2.8l0.1,1l0-2.8l0.1,1l0,2.8l0.1,1 v1.1l-0.1-0.8l0,1.7l0.1,1v1.1l-0.1-0.8l0,2.8l-0.1-1l0-2.8l-0.1-1l0,2.8l-0.1-1l0-2.8l-0.1-0.9v-1.1l0.1,0.8l0-1.7l-0.1-0.9 v-1.1l0.1,0.8L391.9,193.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M389.9,191.7c0,0.1,0.1,0.4,0.2,0.3c0.2-0.4-0.1-3-0.4-3C389.6,189.1,389.7,190.8,389.9,191.7  M389.9,188.1c0.6,2,0.7,5.7,0.3,5.5c-0.6-0.2-1.2-6-0.7-6.2C389.6,187.4,389.8,187.5,389.9,188.1 M391.1,192.4 c0,0.2,0.1,0.3,0.1,0.3c0,0,0,0,0,0c0.2-0.3-0.1-3-0.3-3C390.9,189.8,391,191.6,391.1,192.4 M391.1,188.7 c0.4,1.9,0.5,5.4,0.2,5.6c-0.5-0.3-0.9-5.9-0.5-6.2C390.9,188.1,391,188.1,391.1,188.7 M390.2,184.5c0.6,8.1,0.7,8.4,0.9,12.9 l-0.2-0.2c-0.6-8.1-0.6-8.4-1-12.9L390.2,184.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M387.5,175.8c0.4,3.8,1,8.5,0,11l0,0c-0.1-0.5-0.6-1.3-0.3-1.8c0.9-2.4,0.2-7.6-0.1-9.3L387.5,175.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M385.2,170.8c0.2,0.5,0.6,1.3,0.4,1.8c-1,2.4-0.3,6.9,0.1,9.3l-0.5-0.2 C384.6,177.5,384,173.3,385.2,170.8L385.2,170.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M392.3,212c0,0.2,0,0.5,0,0.7c0-0.5-0.1-1.9-0.2-2.3c0,0-0.1,0.1,0,0.7c0.1,0.7,0.1,1.5,0.2,2.3 c-0.1-1.2-0.2-2.4-0.4-3.6l0-0.3c0-0.8,0-1.1,0.1-1.2c0,0,0.1,0.1,0.2,1.3C392.2,210.1,392.2,210.7,392.3,212"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M391.1,205.3c-0.1-1.3-0.3-2.4-0.4-2.4c0,0-0.1,0.1-0.1,0.4c0.2,0.7,0.4,1.5,0.5,2.2 C391.1,205.4,391.1,205.3,391.1,205.3 M391.4,200.9c0,1.8,0,4.1,0,5.9c-0.3-1.7-0.7-3.4-1.2-5.1l0-0.1c0.1-0.9,0.1-1,0.2-1.2 c0.1,0.1,0.2,0.1,0.4,0.9c0.1,0.7,0.1,1.4,0.3,2.1v-4L391.4,200.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M389.4,198.9c0-0.9-0.2-3-0.9-5c-0.3-0.7-0.4-0.9-0.6-0.8c0.1,0.7,0.3,1.5,0.4,2.2c0,0,0,0,0-0.1 c0.3,0.1,0.5,1.4,0.6,2.4c0.2,0.5,0.3,1,0.5,1.4C389.4,199,389.4,198.9,389.4,198.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M386,190.7c0-0.2-0.1-0.3-0.1-0.5l-0.1,0.1C385.9,190.4,386,190.6,386,190.7 C386.1,190.7,386,190.7,386,190.7 M385.7,188c0.1-0.1,0.3-0.2,0.2-0.9c-0.1-0.8-0.3-1.3-0.5-1.4 C385.5,185.8,385.1,185.6,385.7,188 M384.6,186.8l0.3,1.6c-0.3-0.5-0.6-1-0.8-1.5l-0.3-1.6L384.6,186.8 M386.8,192.4 C386.9,192.4,386.9,192.4,386.8,192.4c-0.6-1.2-1.2-2.5-1.9-3.8l0.4-0.3c-0.8-2.8-0.7-4.3-0.3-4.5c0.3,0.1,0.5,0.3,0.9,1.2 c0.8,2.1,1,4.5,0.4,5.1C386.4,190.4,386.7,191.2,386.8,192.4"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st10",
  points: "390.6,164.4 391.2,166.8 391.2,168.3 390.6,165.9 390.6,164.4  "
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st10",
  points: "387.9,153.9 388.5,155.4 388.8,157.8 389.1,157 389.6,158.7 389.1,159.9 389.7,165  389.2,163.3 388.8,160.2 388.4,161.3 387.8,159.6 388.5,158.1 387.9,153.9  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M384.9,146.1c0.3,2.9,0.8,6.9,1.1,9.8l-0.4-0.5c-0.3-2.9-0.8-6.9-1.1-9.8L384.9,146.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M382.9,96.5l-1.2-1.9v-1.1c-0.2-0.4-0.5-0.7-0.7-1.1v1.1l-1.3-1.8v1.6l1.3,1.8v2.6l0.7,1.1v-2.6l1.2,1.9 V96.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M382,111.2c0.6,1,0.7,2.7,0.2,2.5c-0.5-0.2-1-2.5-0.6-2.8C381.8,110.9,382,111.1,382,111.2 M381.6,104 l0.8,1.3c0,1.8,0,4.1,0,5.9l-0.8-1.3C381.6,108.1,381.6,105.7,381.6,104"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M377.7,105.1c0.7,0.9,0.8,2.6,0.3,2.5c-0.6-0.2-1.2-2.4-0.7-2.7C377.5,104.8,377.7,104.9,377.7,105.1  M377.7,98.2c1,1.3,1.5,2.8,1.6,4.8c-0.3-0.4-0.9-0.8-1-1.3c-0.1-1.3-1-2.7-1.1-1.7c-0.1,0.5,0.1,1,0.5,2.1 c0.5,1.4,0.6,1.6,0.6,2.4v0.5l-1-1.3c0-1.7-1.1-3.3-1.1-5c0-1.9,0.9-1.2,1.2-0.9C377.5,97.9,377.6,98.1,377.7,98.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M371.3,91.1l1.1,1.1l1.7,4.3l-0.6,0.5l-1.1-2.7c0,2,0,4.7,0,6.7l-1.1-1.1 C371.3,97.2,371.3,93.7,371.3,91.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M365.2,92.5c1.4,1.1,0.9-3.5,0.9-3.6c-0.3-2-1.2-2.5-1.5-2.1C364.1,87.3,363.9,91.4,365.2,92.5  M365.2,85.1c3.1,3,2.5,9.6,1.1,9.6c-0.8,0-2.3-1.4-2.9-3.6c-0.7-2.6-0.5-5.5,0.1-6.3C364,84.4,364.5,84.5,365.2,85.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M382,123.2l-0.1-1.7l-0.6-0.9l0.1,1.7L382,123.2 M380.6,115.8l0.6,0.8l0.2,2.7l0.6,0.9l-0.2-2.7l0.5,0.8 l0.2,2.7l0.5,0.8v1.1l-0.5-0.7l0.1,1.7l0.5,0.8v1.1l-0.4-0.7l0.2,2.7l-0.5-0.9l-0.2-2.7l-0.6-0.9l0.2,2.7l-0.6-0.8l-0.2-2.7 l-0.6-0.8v-1.1l0.5,0.7l-0.1-1.7l-0.6-0.8v-1.1l0.5,0.7L380.6,115.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M374.4,115.5c0.6,0.6,0.7-0.2,0.7-0.3c0.1-1.1-0.8-2.7-1.2-2.3C373.5,113.3,373.8,114.8,374.4,115.5  M374.4,111.8c1.5,1.9,1.8,5.6,0.7,5.4c-1.5-0.3-2.8-5.1-1.7-5.8C373.8,111.2,374.2,111.6,374.4,111.8 M377.9,115.5 c0.5,0.6,0.6,0,0.6-0.2c0.1-1-0.6-2.7-1-2.4C377,113.2,377.3,114.8,377.9,115.5 M377.9,111.9c1.4,2,1.6,5.7,0.6,5.4 c-1.3-0.4-2.6-5.2-1.5-5.9C377.3,111.2,377.7,111.6,377.9,111.9 M375.1,108.2c1.8,7.9,1.8,8,2.7,12.4l-0.5-0.1 c-1.8-8-1.8-8-2.8-12.4L375.1,108.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M368.9,100.6c1,4.2,2,8.2,0,10.9l0,0c-0.3-0.5-0.6-1.1-0.8-1.5c1.4-2,1.4-4.8,0-9.5L368.9,100.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M364.4,96.4c0.3,0.5,0.6,1.1,0.9,1.5c-1.5,2.1-1.5,4.8,0,9.5l-0.9,0C363.2,102.9,362.2,99.3,364.4,96.4 L364.4,96.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M382,137c0.3,0.4,0.4,0.2,0.4,0.1c0-0.2,0.1-0.9-0.8-2.3l-0.2-0.3C381.4,135,381.4,136,382,137  M381.8,131.7c0.6,1,1,2.1,1.2,2.8c-0.1,0.1-0.3,0.2-0.4,0.3c-0.4-1.6-0.9-2.3-1.1-2c-0.2,0.3,0,0.6,0,0.7 c1.2,1.8,1.7,3.5,1.7,5c-0.1,1.6-1.3,0.1-1.8-2.1l0,0v0.8l-0.8-1.2c0-3.9,0-3.9,0.1-4.5c0.1-0.3,0.2-0.8,0.7-0.3 C381.4,131,381.6,131.2,381.8,131.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M377,129.6c0.4,0.5,0.7,0.5,0.8-0.2c0.2-1.6-0.9-3.5-1.4-3.1C376,126.5,376.1,128.5,377,129.6  M377.7,122.6l1,1.3c0,2.7,0,6.3,0,8.9c0,0.1,0,0.3,0,0.4l-0.9-1.2v-0.8c-1.1,0.8-2.9-3.3-2.6-6c0.1-1.1,0.6-1.9,1.5-0.8 c0.4,0.5,0.8,1.2,1,2.1l0,0V122.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M371.2,118.3c2.4,2.6,2.5,7.1,1.1,7c-0.7-0.1-1.8-1.1-2.5-2.9c0.2-0.2,0.5-0.4,0.8-0.5 c0.5,1.3,1.2,1.6,1.4,1.1c0.4-1-0.5-3.6-1.3-3.3c0,0-0.1,0-0.1,0.1c-0.2-0.6-0.5-1.4-0.8-2.1 C370.3,117.5,370.9,118,371.2,118.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M365.7,117.8c0.6,0.5,0.8,0.1,0.8-0.5c0-0.6-0.3-1.2-0.7-1.7c-0.3,0.2-0.7,0.5-1.1,0.7 C364.9,116.8,365.2,117.4,365.7,117.8 M365.5,113.4c0.2-0.1,0.6-0.3,0.5-0.8c-0.1-0.9-0.6-1.2-0.8-1.3 c-0.3-0.1-0.6,0.3-0.1,1.3C365.2,112.9,365.4,113.3,365.5,113.4 M365.4,109.9c1.7,1.5,2.6,4.3,1.2,5.3 c1.6,2.4,1.6,5.1,0.3,4.9c-0.1,0-1.6-0.3-2.9-3.3l-0.5,0.4l-1.7-1.4l1.4-0.9l-1.3-3.5l1.6,1.3l0.6,1.7 c0.2-0.2,0.6-0.4,0.8-0.5c-1.6-2.6-1.3-4.6-0.3-4.4C364.6,109.4,364.9,109.5,365.4,109.9"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st10",
  points: "376.3,87.9 377.9,89.9 377.9,91.4 376.3,89.3 376.3,87.9  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M372.5,84.1l1-1.3c-0.4-0.5-0.9-0.9-1.3-1.4l-0.5,0.7l-0.5-1.7c-0.4-0.4-0.8-0.9-1.3-1.3l1,3.4l-1.5,1.7 l1.4,1.4l0.8-1.2l0.9,2.9l1.3,1.4L372.5,84.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M364.3,73.9c-0.3-0.3-0.6-0.5-0.9-0.8c0.5,2.3,1.2,5.4,1.7,7.7l0.8,0.3C365.4,79,365.5,75.8,364.3,73.9"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st10",
  points: "381,139.8 381.8,140.9 381.8,143.5 382.9,145.4 382.9,147 381.8,145.1 381.8,147.7 381,146.6  381,144 379.8,142.2 379.8,140.6 381,142.4 381,139.8  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M382,160.1c0.6,1,0.7,2.7,0.2,2.5c-0.5-0.2-1-2.5-0.6-2.8C381.8,159.7,382,159.9,382,160.1 M381.6,152.8 l0.8,1.3c0,1.8,0,4.1,0,5.9l-0.8-1.3C381.6,156.9,381.6,154.6,381.6,152.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M377.7,153.9c0.7,0.9,0.8,2.6,0.3,2.5c-0.6-0.2-1.2-2.4-0.7-2.7C377.5,153.6,377.7,153.8,377.7,153.9  M377.7,147.1c1,1.3,1.5,2.8,1.6,4.8c-0.3-0.4-0.9-0.8-1-1.3c-0.1-1.3-1-2.7-1.1-1.7c-0.1,0.5,0.1,1,0.5,2.1 c0.5,1.4,0.6,1.6,0.6,2.4v0.5l-1-1.3c0-1.7-1.1-3.3-1.1-5c0-1.9,0.9-1.2,1.2-0.9C377.5,146.8,377.6,147,377.7,147.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M371.3,139.9l1.1,1.1l1.7,4.3l-0.6,0.5l-1.1-2.7c0,2,0,4.7,0,6.7l-1.1-1.1 C371.3,146.1,371.3,142.6,371.3,139.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M365.2,141.4c1.4,1.1,0.9-3.5,0.9-3.6c-0.3-2-1.2-2.5-1.5-2.1C364.1,136.2,363.9,140.2,365.2,141.4  M365.2,134c3.1,3,2.5,9.6,1.1,9.6c-0.8,0-2.3-1.4-2.9-3.6c-0.7-2.6-0.5-5.5,0.1-6.3C364,133.3,364.5,133.4,365.2,134"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M382,172l-0.1-1.7l-0.6-0.9l0.1,1.7L382,172 M380.6,164.7l0.6,0.8l0.2,2.7l0.6,0.9l-0.2-2.7l0.5,0.8 l0.2,2.7l0.5,0.8v1.1l-0.5-0.7l0.1,1.7l0.5,0.8v1.1l-0.4-0.7l0.2,2.7l-0.5-0.9l-0.2-2.7l-0.6-0.9l0.2,2.7l-0.6-0.8l-0.2-2.7 l-0.6-0.8v-1.1l0.5,0.7l-0.1-1.7l-0.6-0.8v-1.1l0.5,0.7L380.6,164.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M374.4,164.4c0.6,0.6,0.7-0.2,0.7-0.3c0.1-1.1-0.8-2.7-1.2-2.3C373.5,162.2,373.8,163.7,374.4,164.4  M374.4,160.7c1.5,1.9,1.8,5.6,0.7,5.4c-1.5-0.3-2.8-5.1-1.7-5.8C373.8,160.1,374.2,160.5,374.4,160.7 M377.9,164.4 c0.5,0.6,0.6,0,0.6-0.2c0.1-1-0.6-2.7-1-2.4C377,162,377.3,163.7,377.9,164.4 M377.9,160.7c1.4,2,1.6,5.7,0.6,5.4 c-1.3-0.4-2.6-5.2-1.5-5.9C377.3,160.1,377.7,160.5,377.9,160.7 M375.1,157.1c1.8,7.9,1.8,8,2.7,12.4l-0.5-0.1 c-1.8-7.9-1.8-8-2.8-12.4L375.1,157.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M368.9,149.5c1,4.2,2,8.2,0,10.9l0,0c-0.3-0.5-0.6-1.1-0.8-1.5c1.4-2.1,1.4-4.8,0-9.5L368.9,149.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M364.4,145.3c0.3,0.5,0.6,1.1,0.9,1.5c-1.5,2.1-1.5,4.8,0,9.5l-0.9,0 C363.2,151.8,362.2,148.2,364.4,145.3L364.4,145.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M382.9,183c0,0.1,0.1,0.3,0.1,0.4c-0.1,0.1-0.3,0.2-0.4,0.3c-0.5-1.9-1-2.2-1.1-2c-0.2,0.3,0,0.6,0,0.7 c0.7,1.1,1,1.8,1.1,2.1c-0.6-1.1-1.3-2.1-2-3.1l0-0.3c0.1-0.9,0.2-1.8,0.9-1c0.2,0.2,0.4,0.6,0.5,0.7 C382.2,181.2,382.6,181.8,382.9,183"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M377.7,177.3c-0.2-1.4-1-2.5-1.4-2.1c-0.1,0.1-0.1,0.2-0.1,0.3c0.5,0.6,1,1.3,1.5,1.9 C377.8,177.4,377.7,177.3,377.7,177.3 M378.7,172.8c0,1.8,0,4.1,0,5.9c-1.1-1.5-2.3-2.9-3.5-4.4l0-0.1 c0.3-1.9,1.1-1.4,1.6-0.6c0.5,0.8,0.8,1.5,0.9,1.9c0,0,0,0,0,0v-4L378.7,172.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M373.2,171.8c-0.1-0.8-0.5-2.9-2-4.6c-0.6-0.6-1-0.7-1.3-0.6c0.2,0.6,0.5,1.4,0.8,2.1 c0.4-0.4,1.3,0.8,1.4,2.1c0.4,0.4,0.8,0.8,1.1,1.2C373.2,171.9,373.2,171.8,373.2,171.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M366,164.9c-0.1-0.2-0.2-0.3-0.2-0.4l-0.2,0.1C365.8,164.7,365.9,164.8,366,164.9 C366,164.9,366,164.9,366,164.9 M365.5,162.3c0.2-0.1,0.6-0.3,0.5-0.8c-0.1-0.9-0.6-1.2-0.8-1.3c-0.3-0.1-0.6,0.3-0.1,1.3 C365.2,161.8,365.4,162.2,365.5,162.3 M363.3,161.5l0.5,1.5c-0.5-0.4-1-0.9-1.5-1.3l-0.6-1.5L363.3,161.5 M367.6,166.3 C367.6,166.3,367.6,166.3,367.6,166.3c-1.1-1-2.4-2.1-3.6-3.1l0.7-0.5c-1.8-3-1.2-4.6-0.3-4.4c0.5,0.1,0.9,0.5,1.3,0.9 c1.4,1.6,2.1,4,0.9,4.9C366.8,164.5,367.3,165.2,367.6,166.3"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st10",
  points: "376.3,136.7 377.9,138.8 377.9,140.3 376.3,138.2 376.3,136.7  "
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st10",
  points: "369.8,127.4 371.1,128.7 371.7,131 372.4,130 373.7,131.5 372.5,133 373.9,137.7 372.6,136.3  371.7,133.4 370.9,134.6 369.5,133.2 371,131.4 369.8,127.4  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M363.9,120.6c0.6,2.8,1.4,6.6,2,9.4l-0.8-0.3c-0.6-2.8-1.4-6.6-2.1-9.4L363.9,120.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M360.4,71.7l-2-1.5v-1.1c-0.4-0.3-0.8-0.6-1.2-0.9v1.1l-2-1.5v1.6l2,1.5v2.6l1.2,0.9v-2.6l2,1.5V71.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M358.9,86.7c0.9,0.8,1.1,2.4,0.5,2.4c-0.8,0.1-1.7-1.8-1.2-2.5C358.3,86.4,358.6,86.4,358.9,86.7  M358.1,79.6l1.4,1.1c0,1.8,0,4.1,0,5.9l-1.4-1.1C358.1,83.7,358.1,81.3,358.1,79.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M351.9,81.8c1,0.7,1.2,2.3,0.5,2.4c-0.8,0.1-1.8-1.6-1.3-2.4C351.3,81.6,351.6,81.5,351.9,81.8  M351.8,74.9c1.5,1,2.3,2.5,2.5,4.4c-0.5-0.3-1.1-0.6-1.5-0.9c-0.1-1.3-1.3-2.2-1.6-1.8c-0.4,0.4,0.1,1.2,0.7,2.2 c0.7,1.3,0.9,1.5,0.9,2.3v0.5l-1.5-1c0-0.6,0-0.8-0.4-1.5c-0.7-1.2-1.4-2.3-1.3-3.5C349.6,74.1,350.8,74.3,351.8,74.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M342.2,69.5l1.5,0.8l2.5,3.8l-0.9,0.7l-1.5-2.4c0,2,0,4.7,0,6.7l-1.6-0.9 C342.2,75.6,342.2,72.1,342.2,69.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M333.7,72.4c2,0.7,1.3-3.9,0.9-4.8c-0.4-0.8-1.6-1.6-2-0.3C332.4,67.9,331.9,71.6,333.7,72.4 M333.7,65 c4.3,2.2,3.4,8.6,1.8,9.3c-0.8,0.3-2.9-0.2-4.1-2.4c-0.9-1.7-1-4.5-0.5-5.9C331.3,65.1,332,64.3,333.7,65"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M358.9,98.6l-0.2-1.7l-0.9-0.7l0.2,1.7L358.9,98.6 M356.5,91.7l0.9,0.7l0.3,2.7l0.9,0.7l-0.3-2.7 l0.9,0.7l0.3,2.7l0.9,0.7v1.1l-0.8-0.6l0.2,1.7l0.9,0.7v1.1l-0.8-0.6l0.3,2.7l-0.9-0.7l-0.3-2.7l-0.9-0.7l0.3,2.7l-0.9-0.7 l-0.3-2.7l-0.9-0.7v-1.1l0.8,0.6l-0.2-1.7l-0.9-0.7v-1.1l0.8,0.6L356.5,91.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M346.8,93.1c0.9,0.5,1.1-0.4,0.9-1.1c-0.3-1.1-1.4-1.8-1.8-1.2C345.6,91.4,346.1,92.6,346.8,93.1  M346.8,89.4c2.3,1.5,2.7,4.9,1.2,5.2c-1.8,0.4-4.1-3.4-3-5C345.4,89,346.1,89,346.8,89.4 M352.1,92.2 c0.8,0.5,1.1-0.3,0.9-1.1c-0.3-1.1-1.3-1.9-1.7-1.2C350.9,90.4,351.3,91.7,352.1,92.2 M352.1,88.5c2.2,1.6,2.6,5,1.1,5.2 c-1.7,0.3-3.9-3.5-2.9-5.1C350.7,88.1,351.3,88.1,352.1,88.5 M347.8,85.6c2.7,7.4,2.8,7.5,4.2,11.6l-0.8,0 c-2.7-7.3-2.8-7.6-4.3-11.6L347.8,85.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M338.9,79.6c1.4,3.8,2.9,7.7,0,10.9l0,0c-0.4-0.4-0.8-0.9-1.2-1.3c2-2.4,2-5.1,0-9.5L338.9,79.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M332.6,76.6c0.4,0.4,0.9,0.9,1.2,1.3c-2,2.5-2,5.1,0,9.5l-1.2,0.2c-1.7-4.5-1.7-4.5-1.7-6.3 C330.8,78.5,332,77.2,332.6,76.6L332.6,76.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M358.8,112.5c0.5,0.3,0.7,0.2,0.7-0.3c-0.1-0.8-1.1-1.5-1.4-1.8l-0.4-0.3 C357.7,110.7,357.7,111.6,358.8,112.5 M358.5,107.2c1.1,0.8,1.7,1.8,2,2.5c-0.2,0.1-0.5,0.3-0.7,0.4c-0.8-1.7-1.8-2.1-2-1.5 c0,0.1,0,0.2,0,0.3c4.5,3.3,2.9,5.4,2.5,5.5c-0.5,0-1.8-0.7-2.5-2.4l0,0v0.8l-1.3-1c0-4.2,0-4.2,0.2-4.8 C357,106.2,357.9,106.7,358.5,107.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M350.8,106.5c1.4,0.8,1.3-0.9,1.1-1.4c-0.3-1.4-1.8-2.4-2.2-1.6C349.3,104.1,349.5,105.7,350.8,106.5  M351.9,99.3l1.5,1c0,2.7,0,6.3,0,8.9c0,0.1,0,0.3,0,0.4l-1.4-0.9V108c-2.3,1.3-4.6-3.6-3.9-5.8c0.7-2.1,2.9-0.6,3.7,1 c0,0,0,0.1,0.1,0.1l0,0V99.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M342.1,96.7c3.3,1.9,3.7,6.2,1.9,6.7c-1,0.3-2.8-0.5-3.8-2.2c0.3-0.2,0.8-0.5,1.1-0.7 c0.7,1.2,1.8,1.5,2.1,0.5c0.4-1.4-1.2-3.2-2-2.8c0,0-0.1,0.1-0.1,0.1c-0.3-0.6-0.8-1.3-1.1-1.9 C340.8,96.1,341.6,96.5,342.1,96.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M334.3,97.6c1,0.4,1.3-0.4,1-1.1c-0.2-0.4-0.5-0.7-0.8-1.1c-0.4,0.3-1,0.7-1.5,1 C333.3,96.7,333.7,97.3,334.3,97.6 M334,93.3c0.6-0.3,0.7-0.5,0.7-1c-0.1-0.4-0.4-0.9-1-1.1c-0.6-0.2-0.9,0.3-0.5,1.1 C333.5,92.7,333.9,93.1,334,93.3 M333.9,89.8c2.3,1.2,3.6,3.7,1.7,5c2.3,2,2.2,4.8,0.4,4.8c-0.1,0-2.3,0.1-4-2.6l-0.7,0.5 l-2.3-1l1.9-1.2l-1.8-3.2l2.1,0.9l0.8,1.5c0.3-0.2,0.8-0.5,1.1-0.7c-2.3-2.4-1.8-4.4-0.2-4.3 C332.9,89.5,333.3,89.5,333.9,89.8"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st10",
  points: "349.7,65 352.2,66.6 352.2,68.1 349.7,66.4 349.7,65  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M344,62.2l1.5-1.5c-0.6-0.4-1.3-0.7-1.9-1.1l-0.7,0.8l-0.7-1.6c-0.6-0.3-1.2-0.7-1.8-1l1.5,3.2l-2.1,2.1 l2,1l1.2-1.4l1.2,2.7l1.9,1.1L344,62.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M332.5,54c-0.4-0.2-0.8-0.4-1.2-0.5c0.7,2.2,1.6,5.1,2.3,7.3l1.1,0.1C334,58.9,333.2,56.1,332.5,54"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st10",
  points: "357.2,115.6 358.4,116.5 358.4,119.1 360.4,120.6 360.4,122.2 358.4,120.7 358.4,123.3  357.2,122.4 357.2,119.8 355.2,118.3 355.2,116.8 357.2,118.2 357.2,115.6  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M358.9,135.5c0.9,0.8,1.1,2.4,0.5,2.4c-0.8,0.1-1.7-1.8-1.2-2.5C358.3,135.3,358.6,135.3,358.9,135.5  M358.1,128.4l1.4,1.1c0,1.8,0,4.1,0,5.9l-1.4-1.1C358.1,132.5,358.1,130.2,358.1,128.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M351.9,130.7c1,0.7,1.2,2.3,0.5,2.4c-0.8,0.1-1.8-1.6-1.3-2.4C351.3,130.5,351.6,130.4,351.9,130.7  M351.8,123.8c1.5,1.1,2.3,2.4,2.5,4.4c-0.5-0.3-1.1-0.6-1.5-0.9c-0.1-1.3-1.3-2.2-1.6-1.8c-0.4,0.4,0.1,1.2,0.7,2.2 c0.7,1.3,0.9,1.5,0.9,2.3v0.5l-1.5-1c0-0.6,0-0.8-0.4-1.5c-0.7-1.2-1.4-2.3-1.3-3.5C349.6,123,350.8,123.2,351.8,123.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M342.2,118.3l1.5,0.8l2.5,3.8l-0.9,0.7l-1.5-2.4c0,2,0,4.7,0,6.7l-1.6-0.9 C342.2,124.5,342.2,121,342.2,118.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M333.7,121.3c2,0.7,1.3-3.9,0.9-4.8c-0.4-0.8-1.6-1.6-2-0.3C332.4,116.7,331.9,120.4,333.7,121.3  M333.7,113.9c4.3,2.2,3.4,8.6,1.8,9.3c-0.8,0.3-2.9-0.2-4.1-2.4c-0.9-1.7-1-4.5-0.5-5.9C331.3,114,332,113.1,333.7,113.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M358.9,147.5l-0.2-1.7l-0.9-0.7l0.2,1.7L358.9,147.5 M356.5,140.6l0.9,0.7l0.3,2.7l0.9,0.7l-0.3-2.7 l0.9,0.7l0.3,2.7l0.9,0.7v1.1l-0.8-0.6l0.2,1.7l0.9,0.7v1.1l-0.8-0.6l0.3,2.7l-0.9-0.7l-0.3-2.7l-0.9-0.7l0.3,2.7l-0.9-0.7 l-0.3-2.7l-0.9-0.7v-1.1l0.8,0.6l-0.2-1.7l-0.9-0.7v-1.1l0.8,0.6L356.5,140.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M346.8,142c0.9,0.5,1.1-0.4,0.9-1.1c-0.3-1.1-1.4-1.8-1.8-1.2C345.6,140.2,346.1,141.5,346.8,142  M346.8,138.3c2.3,1.5,2.7,4.9,1.2,5.2c-1.8,0.4-4.1-3.4-3-5C345.4,137.9,346.1,137.8,346.8,138.3 M352.1,141.1 c0.8,0.5,1.1-0.3,0.9-1.1c-0.3-1.1-1.3-1.9-1.7-1.2C350.9,139.3,351.3,140.6,352.1,141.1 M352.1,137.4c2.2,1.6,2.6,5,1.1,5.2 c-1.7,0.3-3.9-3.5-2.9-5.1C350.7,137,351.3,136.9,352.1,137.4 M347.8,134.5c2.7,7.4,2.8,7.5,4.2,11.6l-0.8,0 c-2.7-7.3-2.8-7.6-4.3-11.6L347.8,134.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M338.9,128.5c1.4,3.8,2.9,7.7,0,10.9l0,0c-0.4-0.4-0.8-0.9-1.2-1.3c2-2.4,2-5.1,0-9.5L338.9,128.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M332.6,125.4c0.4,0.4,0.9,0.9,1.2,1.3c-2,2.5-2,5.1,0,9.5l-1.2,0.2c-1.7-4.5-1.7-4.5-1.7-6.3 C330.8,127.4,332,126.1,332.6,125.4L332.6,125.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M360.3,158.2c0.1,0.1,0.1,0.3,0.2,0.4c-0.2,0.1-0.5,0.3-0.7,0.4c-0.9-1.9-1.8-2-2-1.6 c-0.1,0.1-0.1,0.3-0.1,0.4c0.8,0.6,1.5,1.1,2.1,1.9c-1.1-0.9-2.2-1.7-3.4-2.5l0-0.3c0.1-1.5,0.6-2.1,2.4-0.6 C359.1,156.6,359.7,157.2,360.3,158.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M351.9,154c-0.3-1.4-1.8-2.4-2.2-1.6c0,0.1-0.1,0.2-0.1,0.2c0.8,0.5,1.6,1,2.4,1.5 C351.9,154.1,351.9,154,351.9,154 M353.4,149.2c0,1.8,0,4.1,0,5.9c-1.7-1.2-3.5-2.3-5.4-3.4l0-0.1c0.7-3.2,3.2-0.4,3.5,0.1 c0.1,0.2,0.1,0.4,0.3,0.6v-4L353.4,149.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M345,149.7c-0.1-0.6-0.6-2.7-2.9-4.1c-0.8-0.4-1.4-0.5-1.9-0.2c0.3,0.6,0.8,1.3,1.1,1.9 c0.6-0.5,1.8,0.5,2.1,1.7c0.6,0.3,1.1,0.6,1.7,0.9C345,149.8,345,149.7,345,149.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M334.8,144.6c-0.1-0.1-0.2-0.2-0.3-0.4l-0.2,0.1C334.5,144.4,334.7,144.5,334.8,144.6 C334.8,144.6,334.8,144.6,334.8,144.6 M334,142.2c0.6-0.3,0.7-0.5,0.7-1c-0.1-0.4-0.4-0.9-1-1.1c-0.6-0.2-0.9,0.3-0.5,1.1 C333.5,141.6,333.9,142,334,142.2 M331.1,141.9l0.7,1.3c-0.7-0.3-1.4-0.6-2.1-0.9L329,141L331.1,141.9 M337,145.6 C337,145.6,337,145.7,337,145.6c-1.6-0.7-3.3-1.5-5-2.3l1-0.6c-2.4-2.5-1.6-4.3-0.5-4.3c0.7,0,1.3,0.3,1.8,0.6 c1.9,1.3,3,3.5,1.2,4.7C335.9,144,336.6,144.6,337,145.6"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st10",
  points: "349.7,113.8 352.2,115.4 352.2,116.9 349.7,115.3 349.7,113.8  "
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st10",
  points: "340.1,106.2 341.9,107.2 342.8,109.3 343.8,108.2 345.7,109.3 344,111.1 346,115.5  344.1,114.4 342.9,111.7 341.7,113.1 339.7,112 341.8,109.9 340.1,106.2  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M331.9,100.9c0.8,2.7,2,6.3,2.8,8.9l-1.1-0.1c-0.8-2.7-2-6.3-2.8-8.9L331.9,100.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M327.1,52.8l-2.6-1v-1.1c-0.5-0.2-1-0.4-1.6-0.6l0,1.1l-2.7-1v1.6l2.7,1l0,2.6l1.6,0.6v-2.6l2.6,1V52.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M325.1,68.1c1.2,0.5,1.5,2,0.7,2.3c-0.9,0.4-2.2-1-1.8-1.9C324.2,68,324.6,67.9,325.1,68.1 M324.2,61.1 l1.9,0.7c0,1.8,0,4.1,0,5.9l-1.9-0.7C324.2,65.3,324.2,62.9,324.2,61.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M316.1,64.8c1.2,0.5,1.6,1.9,0.8,2.3c-0.9,0.4-2.3-0.9-1.9-1.8C315.1,64.8,315.6,64.6,316.1,64.8  M316,58c1.9,0.7,3,1.9,3.2,3.8c-0.6-0.2-1.4-0.4-2-0.6c-0.2-1.4-1.7-1.9-2.1-1.4c-0.4,0.5,0.1,1.1,0.9,2 c0.9,1.1,1.1,1.3,1.1,2.1v0.5l-1.9-0.6c0-0.6,0-0.8-0.5-1.4c-0.9-1-1.8-1.9-1.6-3.2C313.2,57.6,314.7,57.5,316,58"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M304,54.7l1.9,0.5l3.1,3.3l-1.1,0.9l-1.9-2.1c0,2,0,4.7,0,6.7l-2-0.5C304,60.8,304,57.3,304,54.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M293.6,59.5c2.4,0.3,1.6-4.2,1-5c-0.5-0.7-2.3-1.4-2.6,0.8C292,55.7,291.6,59.1,293.6,59.5 M293.6,52.1 c0.7,0.2,2.8,0.7,3.4,3.3c0.5,2.1,0.3,4.8-1.3,5.6c-1.4,0.7-3.8-0.1-4.7-1.2c-2-2.5-1-5.8-1-5.8 C290.8,52,292.4,51.9,293.6,52.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M325.2,80l-0.2-1.6l-1.2-0.5l0.2,1.6L325.2,80 M322,73.7l1.2,0.5l0.4,2.6l1.2,0.5l-0.3-2.6l1.2,0.5 l0.3,2.6l1.2,0.5v1.1l-1-0.4l0.2,1.6l1.2,0.5v1.1l-1-0.4l0.3,2.6l-1.2-0.5l-0.3-2.6l-1.2-0.5l0.3,2.6l-1.2-0.5l-0.4-2.6 l-1.2-0.5v-1.1l1.1,0.4l-0.2-1.6l-1.2-0.4v-1.1l1.1,0.4L322,73.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M309.7,77.2c1.2,0.3,1.5-0.8,1.1-1.6c-0.6-1.1-2.1-1.2-2.3-0.2C308.3,76.1,308.9,77,309.7,77.2  M309.7,73.6c2.7,0.9,3.4,4,1.7,4.8c-2,1-5-1.7-4.2-3.8C307.5,73.7,308.6,73.3,309.7,73.6 M316.3,75.2c1.2,0.3,1.5-0.7,1-1.5 c-0.6-1.1-2-1.3-2.2-0.3C315,74,315.5,74.9,316.3,75.2 M316.3,71.5c2.6,1,3.3,4.1,1.6,4.9c-2,0.9-4.8-1.9-4.1-4 C314.2,71.5,315.2,71.1,316.3,71.5 M310.9,69.6c3.3,6.7,3.5,6.9,5.3,10.7l-1,0.2c-3.4-6.8-3.5-6.9-5.4-10.7L310.9,69.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M299.9,65.5c0.5,1,1.1,1.9,1.5,3c0.2,0.7,0.5,1.7,0.5,3c0,2.7-1.3,4.2-2,5l0,0c-0.4-0.3-1-0.8-1.4-1.1 c2.4-2.9,2.4-5.5,0-9.5L299.9,65.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M292.2,63.9c0.4,0.3,1,0.7,1.5,1c-2.5,2.9-2.5,5.6,0,9.5l-1.5,0.5c-2.1-4-2.1-4-2.1-5.9 C290.1,66.3,291.5,64.7,292.2,63.9L292.2,63.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M325.1,93.9c0.7,0.3,1-0.1,0.8-0.6c-0.3-0.7-1.4-1.1-1.8-1.3l-0.5-0.2c0,0.6,0,0.8,0.3,1.2 C324.3,93.5,324.8,93.8,325.1,93.9 M324.7,88.7c1.4,0.6,2.2,1.4,2.6,2c-0.3,0.2-0.7,0.4-1,0.6c-1.1-1.6-2.5-1.7-2.7-0.9 c0,0.1,0,0.2,0,0.2c1.8,0.7,2.9,1.3,3.6,2.4c0.5,0.6,0.7,2.1-0.2,2.5c-0.8,0.3-2.6-0.3-3.4-1.8l0,0v0.8l-1.7-0.7 c0-4.2,0-4.2,0.3-4.8C322.7,88.1,323.9,88.4,324.7,88.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M314.6,89.8c1.8,0.5,1.7-1.3,1.3-2c-0.6-1.2-2.5-1.7-2.8-0.5C312.9,88,313.2,89.3,314.6,89.8  M316.1,82.4L318,83c0,2.7,0,6.3,0,8.9c0,0.1,0,0.3,0,0.4l-1.8-0.6V91c-2.6,1.6-5.8-2-5-4.7c0.7-2.4,3.7-1.7,4.8,0l0,0V82.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M303.8,82c4.1,1.2,4.4,5.1,2.6,6.1c-1.2,0.7-3.6,0.3-5-1.2c0.4-0.3,1-0.7,1.4-0.9c0.9,1.2,2.5,1,2.6-0.2 c0.1-1.6-1.8-2.6-2.6-2c0,0,0,0,0,0c-0.4-0.5-1-1.1-1.4-1.6C302.2,81.7,303.3,81.8,303.8,82"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M294.3,84.5c1.3,0.2,1.6-0.8,1.1-1.4c-0.2-0.3-0.5-0.6-0.9-0.8c-0.5,0.4-1.2,0.9-1.8,1.3 C293.1,83.9,293.6,84.4,294.3,84.5 M294,80.3c0.3-0.2,0.8-0.5,0.8-0.9c0-0.6-0.5-0.9-0.9-1c-0.9-0.2-1.3,0.3-1,0.9 C293.2,79.7,293.8,80.1,294,80.3 M293.8,76.9c2.8,0.6,4.3,2.9,2,4.6c2.6,1.4,2.7,4,0.8,4.7c0,0-2.9,0.8-5.1-1.6l-0.8,0.7 l-2.8-0.5l2.3-1.7l-2.1-2.8l2.5,0.4l1,1.3c0.4-0.3,0.9-0.7,1.3-0.9c-2.6-1.8-2.2-3.9-0.5-4.2 C292.6,76.8,293.1,76.7,293.8,76.9"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st10",
  points: "313.3,48.5 316.5,49.5 316.5,51 313.3,50 313.3,48.5  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M306.1,47l1.9-1.9c-0.8-0.2-1.6-0.4-2.4-0.6l-0.9,1l-0.8-1.4c-0.7-0.2-1.5-0.4-2.3-0.6l1.8,2.8l-2.6,2.6 l2.4,0.6l1.4-1.6l1.5,2.4l2.4,0.7L306.1,47"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M292.2,41.4c-0.5-0.1-1-0.2-1.4-0.3c0.8,2,1.9,4.7,2.8,6.8l1.3-0.1C294,45.9,292.9,43.3,292.2,41.4"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st10",
  points: "323,97.4 324.5,98 324.5,100.6 327.1,101.7 327.1,103.2 324.5,102.2 324.5,104.8 323,104.2  323,101.6 320.3,100.6 320.3,99 323,100 323,97.4  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M325.1,116.9c1.2,0.5,1.5,2,0.7,2.3c-0.9,0.4-2.2-1-1.8-1.9C324.2,116.9,324.6,116.7,325.1,116.9  M324.2,110l1.9,0.7c0,1.8,0,4.1,0,5.9l-1.9-0.7C324.2,114.1,324.2,111.8,324.2,110"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M316.1,113.7c1.2,0.5,1.6,1.9,0.8,2.3c-0.9,0.4-2.3-0.9-1.9-1.8C315.1,113.7,315.6,113.5,316.1,113.7  M316,106.8c1.9,0.7,3,1.9,3.2,3.8c-0.6-0.2-1.4-0.4-2-0.6c-0.2-1.4-1.7-1.9-2.1-1.4c-0.4,0.5,0.1,1.1,0.9,2 c0.9,1.1,1.1,1.3,1.1,2.1v0.5l-1.9-0.6c0-0.6,0-0.8-0.5-1.4c-0.9-1-1.8-1.9-1.6-3.2C313.2,106.5,314.7,106.4,316,106.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M304,103.5l1.9,0.5l3.1,3.3l-1.1,0.9l-1.9-2.1c0,2,0,4.7,0,6.7l-2-0.5C304,109.7,304,106.2,304,103.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M293.6,108.4c2.4,0.3,1.6-4.2,1-5c-0.5-0.7-2.3-1.4-2.6,0.8C292,104.6,291.6,107.9,293.6,108.4  M293.6,101c0.7,0.2,2.8,0.7,3.4,3.3c0.5,2.1,0.3,4.8-1.3,5.6c-1.4,0.7-3.8-0.1-4.7-1.2c-2-2.5-1-5.8-1-5.8 C290.8,100.9,292.4,100.8,293.6,101"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M325.2,128.9l-0.2-1.6l-1.2-0.5l0.2,1.6L325.2,128.9 M322,122.6l1.2,0.5l0.4,2.6l1.2,0.5l-0.3-2.6 l1.2,0.5l0.3,2.6l1.2,0.5v1.1l-1-0.4l0.2,1.6l1.2,0.5v1.1l-1-0.4l0.3,2.6l-1.2-0.5l-0.3-2.6l-1.2-0.5l0.3,2.6l-1.2-0.5 l-0.4-2.6l-1.2-0.5v-1.1l1.1,0.4l-0.2-1.6l-1.2-0.4v-1.1l1.1,0.4L322,122.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M309.7,126.1c1.2,0.3,1.5-0.8,1.1-1.6c-0.6-1.1-2.1-1.2-2.3-0.2C308.3,125,308.9,125.9,309.7,126.1  M309.7,122.5c2.7,0.9,3.4,4,1.7,4.8c-2,1-5-1.7-4.2-3.8C307.5,122.5,308.6,122.1,309.7,122.5 M316.3,124 c1.2,0.3,1.5-0.7,1-1.5c-0.6-1.1-2-1.3-2.2-0.3C315,122.9,315.5,123.8,316.3,124 M316.3,120.4c2.6,1,3.3,4.1,1.6,4.9 c-2,0.9-4.8-1.9-4.1-4C314.2,120.4,315.2,120,316.3,120.4 M310.9,118.4c3.3,6.7,3.5,6.9,5.3,10.7l-1,0.2 c-3.4-6.8-3.5-6.9-5.4-10.7L310.9,118.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M299.9,114.4c0.5,1,1.1,1.9,1.5,3c0.2,0.7,0.5,1.7,0.5,3c0,2.7-1.3,4.2-2,5l0,0c-0.4-0.3-1-0.8-1.4-1.1 c2.4-2.9,2.4-5.5,0-9.5L299.9,114.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M292.2,112.8c0.4,0.3,1,0.7,1.5,1c-2.5,2.9-2.5,5.6,0,9.5l-1.5,0.5c-2.1-4-2.1-4-2.1-5.9 C290.1,115.1,291.5,113.6,292.2,112.8L292.2,112.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M327.1,139.3c0.1,0.1,0.2,0.2,0.3,0.3c-0.3,0.2-0.7,0.4-1,0.6c-1.1-1.6-2.5-1.7-2.7-0.9 c0,0.1,0,0.2,0,0.2c1,0.4,2,0.8,2.8,1.4c-1.5-0.6-3-1.2-4.5-1.7l0-0.3c0.2-1.5,0.8-2.2,3.1-1.2 C325.5,138,326.3,138.4,327.1,139.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M316.1,137c-0.5-1.4-2.5-2-2.9-0.9c0,0,0,0.1,0,0.1c1,0.3,2,0.6,3,1C316.1,137.1,316.1,137,316.1,137  M318,131.9c0,1.8,0,4.1,0,5.9c-2.2-0.8-4.5-1.5-6.9-2.2l0-0.1c0.3-1.2,0.9-1.8,1.7-1.8c1.3-0.1,2.5,0.5,3.2,1.6c0,0,0,0,0,0 v-4L318,131.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M307.4,134.3c-0.1-0.6-0.7-2.6-3.6-3.4c-1-0.2-1.7-0.2-2.4,0.2c0.4,0.5,1,1.1,1.4,1.6 c0.8-0.6,2.3,0.1,2.6,1.2c0.7,0.2,1.4,0.4,2.1,0.6C307.4,134.4,307.4,134.3,307.4,134.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M295,131.4c-0.1-0.1-0.2-0.2-0.4-0.3l-0.3,0.2C294.5,131.4,294.8,131.4,295,131.4 C295,131.5,295,131.4,295,131.4 M294,129.2c0.3-0.2,0.8-0.5,0.8-0.9c0-0.6-0.5-0.9-0.9-1c-0.9-0.2-1.3,0.3-1,0.9 C293.2,128.6,293.8,129,294,129.2 M290.5,129.6l0.9,1.2c-0.8-0.2-1.6-0.3-2.5-0.5l-0.9-1.2L290.5,129.6 M297.6,132 C297.6,132,297.6,132,297.6,132c-1.9-0.4-3.9-0.8-6-1.2l1.1-0.8c-2.9-2-2-3.9-0.5-4.2c0.8-0.2,1.5,0,2.2,0.2 c2.4,0.9,3.6,2.8,1.4,4.5C296.3,130.6,297.1,131.1,297.6,132"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st10",
  points: "313.3,97.4 316.5,98.4 316.5,99.9 313.3,98.8 313.3,97.4  "
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st10",
  points: "301.3,91.8 303.6,92.4 304.7,94.3 305.9,93 308.3,93.7 306.1,95.9 308.7,99.8 306.3,99.2  304.8,96.7 303.3,98.4 300.9,97.8 303.5,95.2 301.3,91.8  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M291.4,88.4c1,2.5,2.4,5.8,3.4,8.3l-1.3,0.1c-1-2.5-2.4-5.8-3.4-8.3L291.4,88.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M285.8,41.3l-3.1-0.5v-1.1c-0.6-0.1-1.2-0.2-1.8-0.3l0,1.1l-3.1-0.4v1.6l3.1,0.4v2.6l1.8,0.3v-2.6 l3.1,0.5V41.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M283.4,57c1.3,0.3,1.7,1.5,0.9,2.1c-0.9,0.6-2.4-0.2-2.3-1.3C282.1,57.3,282.7,56.9,283.4,57  M282.3,50.3l2.2,0.3c0,1.8,0,4.1,0,5.9l-2.2-0.3C282.3,54.4,282.3,52.1,282.3,50.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M272.9,55.7c1.3,0.2,1.8,1.5,1,2c-0.9,0.7-2.5-0.1-2.3-1.2C271.6,56.1,272.2,55.7,272.9,55.7  M272.7,48.9c2.2,0.3,3.4,1.3,3.7,3.1c-0.7,0-1.6-0.1-2.3-0.1c-0.2-1.4-2-1.5-2.4-0.9c-0.4,0.6,0.2,1.1,1,1.8 c1.1,0.9,1.3,1.1,1.3,1.8v0.5l-2.2-0.2c0-0.6,0-0.8-0.6-1.3c-1-0.8-2.1-1.5-1.8-2.9C269.6,49.2,271.2,48.8,272.7,48.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M259.1,48.3l2.2,0.1l3.5,2.6l-1.3,1.1l-2.2-1.7c0,2,0,4.7,0,6.7l-2.2-0.1 C259.1,54.4,259.1,50.9,259.1,48.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M283.4,69l-0.2-1.6l-1.4-0.2l0.2,1.6L283.4,69 M279.7,63.3l1.4,0.2l0.4,2.5l1.4,0.2l-0.4-2.5l1.4,0.2 l0.4,2.5l1.4,0.2v1.1l-1.2-0.2l0.2,1.6l1.4,0.2v1.1l-1.2-0.2l0.4,2.6l-1.4-0.2l-0.4-2.5l-1.4-0.2l0.4,2.5l-1.4-0.2l-0.4-2.5 l-1.4-0.2v-1.1l1.2,0.2l-0.3-1.6l-1.4-0.2v-1.1l1.2,0.2L279.7,63.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M265.5,69.6c1.5,0,1.8-1.2,1.1-1.9c-0.9-0.9-2.6-0.5-2.6,0.6C264.1,69,264.7,69.6,265.5,69.6 M265.5,66 c2.9,0.3,3.9,3,2.1,4.3c-2,1.5-5.4,0-5.1-2.3C262.7,66.7,264,65.9,265.5,66 M273.1,66.1c1.4,0.1,1.7-1.1,1.1-1.8 c-0.8-1-2.5-0.6-2.5,0.5C271.7,65.4,272.3,66,273.1,66.1 M273.1,62.4c2.9,0.4,3.8,3.2,2.1,4.4c-2,1.4-5.3-0.2-5-2.5 C270.3,63.1,271.6,62.3,273.1,62.4 M266.9,61.7c3.7,5.7,4,6.2,6.1,9.5l-1.1,0.4c-3.9-5.9-4-6.2-6.2-9.5L266.9,61.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M283.3,82.9c1,0.1,1.2-0.5,0.9-0.9c-0.4-0.5-1.6-0.7-2-0.8l-0.5-0.1c0,0.6,0,0.8,0.3,1.1 C282.4,82.7,283,82.8,283.3,82.9 M282.9,77.8c1.7,0.3,2.6,1,3.1,1.4c-0.3,0.2-0.8,0.6-1.2,0.8c-1.3-1.4-3.1-1.3-3.2-0.1 c0.9,0.1,3.1,0.5,4,1.3c1.2,1.1,0.8,2.3,0.1,2.7c-0.9,0.6-3.2,0.4-4.2-0.9l0,0v0.8l-2-0.3c0-4.2,0-4.2,0.4-4.9 C280.6,77.6,281.8,77.6,282.9,77.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M271.2,81.1c2.2,0.1,2-1.7,1.4-2.4c-0.8-1-3.1-1-3.2,0.5C269.3,80,269.8,80.9,271.2,81.1 M272.8,73.3 l2.2,0.2c0,2.7,0,6.3,0,8.9c0,0.1,0,0.3,0,0.4l-2.1-0.2v-0.8c-2.8,2-6.4-0.5-5.8-3.3c0.5-2.8,4.2-2.9,5.6-1.3l0,0V73.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M258.8,75.6c4.4,0.3,5,3.9,3.2,5.4c-1.4,1.2-4.3,1.3-5.9,0.1c0.5-0.4,1.1-0.9,1.5-1.2c1,0.9,3,0.5,3-1 c0-1.6-2.1-2-2.9-1.2c0,0,0,0,0,0c-0.5-0.4-1.1-0.9-1.5-1.3C257.1,75.7,258.2,75.6,258.8,75.6"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st10",
  points: "269.6,40.1 273.3,40.4 273.3,41.9 269.6,41.5 269.6,40.1  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M261.5,40.1l2.1-2.3c-0.9,0-1.8-0.1-2.7-0.1l-1,1.2l-0.9-1.2c-0.8,0-1.7-0.1-2.5-0.1l2.1,2.4l-2.9,3.1 l2.7,0.1l1.6-1.9l1.8,2.1l2.7,0.1L261.5,40.1"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st10",
  points: "280.9,86.9 282.7,87.1 282.7,89.7 285.8,90.2 285.8,91.8 282.7,91.3 282.7,93.9 280.9,93.6  280.9,91 277.8,90.6 277.8,89.1 280.9,89.5 280.9,86.9  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M283.4,105.9c1.3,0.3,1.7,1.5,0.9,2.1c-0.9,0.6-2.4-0.2-2.3-1.3C282.1,106.2,282.7,105.8,283.4,105.9  M282.3,99.2l2.2,0.3c0,1.8,0,4.1,0,5.9l-2.2-0.3C282.3,103.3,282.3,101,282.3,99.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M272.9,104.6c1.3,0.2,1.8,1.5,1,2c-0.9,0.7-2.5-0.1-2.3-1.2C271.6,104.9,272.2,104.6,272.9,104.6  M272.7,97.8c2.2,0.3,3.4,1.3,3.7,3.1c-0.7,0-1.6-0.1-2.3-0.1c-0.2-1.4-2-1.5-2.4-0.9c-0.4,0.6,0.2,1.1,1,1.8 c1.1,0.9,1.3,1.1,1.3,1.8v0.5l-2.2-0.2c0-0.6,0-0.8-0.6-1.3c-1-0.8-2.1-1.5-1.8-2.9C269.6,98.1,271.2,97.7,272.7,97.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M259.1,97.2l2.2,0.1l3.5,2.6l-1.3,1.1l-2.2-1.7c0,2,0,4.7,0,6.7l-2.2-0.1 C259.1,103.3,259.1,99.8,259.1,97.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M283.4,117.9l-0.2-1.6l-1.4-0.2l0.2,1.6L283.4,117.9 M279.7,112.2l1.4,0.2l0.4,2.5l1.4,0.2l-0.4-2.5 l1.4,0.2l0.4,2.5l1.4,0.2v1.1l-1.2-0.2l0.2,1.6l1.4,0.2v1.1l-1.2-0.2l0.4,2.6l-1.4-0.2l-0.4-2.5l-1.4-0.2l0.4,2.5l-1.4-0.2 l-0.4-2.5l-1.4-0.2v-1.1l1.2,0.2l-0.3-1.6l-1.4-0.2v-1.1l1.2,0.2L279.7,112.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M265.5,118.5c1.5,0,1.8-1.2,1.1-1.9c-0.9-0.9-2.6-0.5-2.6,0.6C264.1,117.9,264.7,118.4,265.5,118.5  M265.5,114.8c2.9,0.3,3.8,3,2.1,4.3c-2,1.5-5.4,0-5.1-2.3C262.7,115.6,264,114.7,265.5,114.8 M273.1,114.9 c1.4,0.1,1.7-1.1,1.1-1.8c-0.8-1-2.5-0.6-2.5,0.5C271.7,114.3,272.3,114.9,273.1,114.9 M273.1,111.3c2.9,0.4,3.8,3.2,2.1,4.4 c-2,1.4-5.3-0.2-5-2.5C270.3,112,271.6,111.2,273.1,111.3 M266.9,110.5c3.7,5.7,4,6.2,6.1,9.5l-1.1,0.4 c-3.9-5.9-4-6.2-6.2-9.5L266.9,110.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M285.7,127.8c0.1,0.1,0.2,0.2,0.3,0.3c-0.3,0.2-0.8,0.6-1.2,0.8c-1.3-1.3-3-1.4-3.2-0.1 c1.2,0.2,2.3,0.4,3.3,0.8c-1.7-0.3-3.5-0.5-5.3-0.8l0-0.3c0.2-1.5,0.9-2.4,3.7-1.9C283.8,126.9,284.8,127.1,285.7,127.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M272.9,128c-0.5-1.3-2.8-1.5-3.4-0.3c0,0,0,0.1-0.1,0.1c1.2,0.1,2.3,0.2,3.5,0.3 C272.9,128.1,272.9,128,272.9,128 M275.1,122.5c0,1.8,0,4.1,0,5.9c-2.6-0.3-5.2-0.5-7.9-0.7l0-0.1c0.4-1.2,1-2,1.9-2.2 c1.5-0.4,2.9,0,3.7,0.9c0,0,0,0,0,0v-4L275.1,122.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M262.9,127.1c-0.1-0.6-0.8-2.4-4.1-2.6c-1.2,0-1.9,0.2-2.7,0.7c0.5,0.4,1.1,0.9,1.5,1.3 c0.9-0.8,2.6-0.4,2.9,0.7c0.8,0,1.6,0.1,2.3,0.1C262.9,127.3,262.9,127.2,262.9,127.1"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st10",
  points: "269.6,88.9 273.3,89.3 273.3,90.8 269.6,90.4 269.6,88.9  "
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st10",
  points: "256,86.1 258.6,86.1 259.9,87.8 261.2,86.2 263.9,86.4 261.5,89 264.4,92.4 261.7,92.3  260,90.2 258.3,92.1 255.6,92.1 258.5,88.9 256,86.1  "
})));

var _ref13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M278,221.2c0.8,0,1.5-0.4,1.5-1l0-1.9l-2.9,0.1l0,1.9C276.5,220.8,277.1,221.2,278,221.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st12",
  d: "M277.9,217.4c-0.8,0-1.5,0.4-1.5,1c0,0.5,0.7,0.9,1.5,0.9c0.8,0,1.5-0.4,1.5-1 C279.4,217.8,278.7,217.4,277.9,217.4z"
}));

var _ref14 = /*#__PURE__*/React.createElement("path", {
  className: "st13",
  d: "M278,219c0.7,0,1.3-0.4,1.3-0.8l0-27.3l-2.5,0.1l0,27.3C276.7,218.6,277.3,219,278,219z"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M277.9,190c-0.7,0-1.3,0.4-1.3,0.8c0,0.4,0.6,0.8,1.3,0.8c0.7,0,1.3-0.4,1.3-0.8 C279.2,190.4,278.6,190,277.9,190z"
});

var _ref16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M324.6,194.8c0.8,0,1.5-0.4,1.5-1l0-1.9l-2.9,0.1l0,1.9C323.1,194.4,323.8,194.8,324.6,194.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st12",
  d: "M324.6,191c-0.8,0-1.5,0.4-1.5,1c0,0.5,0.7,0.9,1.5,0.9c0.8,0,1.5-0.4,1.5-1 C326.1,191.4,325.4,191,324.6,191z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st15",
  d: "M324.6,192.6c0.7,0,1.3-0.4,1.3-0.8l0-27.3l-2.5,0.1l0,27.3C323.3,192.2,323.9,192.6,324.6,192.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M324.6,163.6c-0.7,0-1.3,0.4-1.3,0.8c0,0.4,0.6,0.8,1.3,0.8c0.7,0,1.3-0.4,1.3-0.8 S325.3,163.6,324.6,163.6z"
})));

var _ref17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M255.7,208.5c0.8,0,1.5-0.4,1.5-1l0-1.9l-2.9,0.1l0,1.9C254.2,208.1,254.9,208.5,255.7,208.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st12",
  d: "M255.7,204.7c-0.8,0-1.5,0.4-1.5,1c0,0.5,0.7,0.9,1.5,0.9c0.8,0,1.5-0.4,1.5-1 C257.2,205.1,256.5,204.7,255.7,204.7z"
}));

var _ref18 = /*#__PURE__*/React.createElement("path", {
  className: "st16",
  d: "M255.7,206.3c0.7,0,1.3-0.4,1.3-0.8l0-27.3l-2.5,0.1l0,27.3C254.4,206,255,206.4,255.7,206.3z"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M255.7,177.4c-0.7,0-1.3,0.4-1.3,0.8c0,0.4,0.6,0.8,1.3,0.8c0.7,0,1.3-0.4,1.3-0.8 C257,177.7,256.4,177.4,255.7,177.4z"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  className: "st17",
  d: "M328.2,164.2L328.2,164.2l0-2.1l-2.8,2.1l-18.3-10.6c-2.6-1.5-5.9-1.5-8.5,0l-43.2,24.9 c-0.3-0.8-0.6-1.6-0.7-1.7c-0.2,0-2-0.7-2-0.7v2.1c0,1,0.5,2.1,1.5,2.7l19.5,11.2c3.1,1.8,6.8,1.8,9.9,0l42.8-24.7 C327.7,166.8,328.3,165.5,328.2,164.2z"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  className: "st18",
  d: "M254.2,173.5l44.3-25.6c2.6-1.5,5.9-1.5,8.5,0l19.3,11.2c2.4,1.4,2.4,4.9,0,6.3l-42.8,24.7 c-3.1,1.8-6.8,1.8-9.9,0l-19.5-11.2C252.2,177.7,252.2,174.7,254.2,173.5z"
});

var _ref22 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st19",
  d: "M308,166.2L308,166.2l-12.7-7.3l-18.3,10.5l-3-0.2v0.4l15.2,8.8l10.2-5.9c0,0,1.7,0,2.3-1.3l8.7-5.1 v-0.4L308,166.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st20",
  d: "M274.1,169.3l15.2,8.8l10.2-5.9c0,0,1.4-0.1,2.3-1.3l8.7-5.1l-15.2-8.8L274.1,169.3z"
}));

var _ref23 = /*#__PURE__*/React.createElement("path", {
  className: "st21",
  d: "M300.2,170.2"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  className: "st22",
  d: "M308.3,165.1l-0.5,0.2l0,0.1l-12.8-7.4l-8.3,4.8l13.5,7.5c0,0,0.4-0.5,1.3,0.3l8.2-4.7v-0.8H308.3z"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  className: "st23",
  d: "M300.1,170.2c0.5-3,7.5-3.7,9.5-5.2l-15.1-8.6c-2.3,2.1-9.4,2.8-9.6,5.3L300.1,170.2z"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  className: "st22",
  d: "M299.6,170l-3.1-0.3l-0.6,0.4l-11-6.4l-8.3,4.8l0.1-0.4l-1.2-0.3L275,168v1l14.6,8.5l9.6-5.6 c0.3-1.6,0.9-1.6,0.9-1.6L299.6,170z"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  className: "st24",
  d: "M300.2,170.2c-3.5-1.4-6.8,4.6-10.6,6.2L275,168c0,0,6.5-8,9.9-6.2L300.2,170.2z"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  className: "st25",
  d: "M307.6,162c0,0-0.9-0.8-1.3-0.8c-0.4,0-1.6,0.2-2.1-0.1c-0.5-0.3-0.7-0.4-0.8-0.6 c-0.2-0.3,0.1-0.8,0.9-0.5c0.7,0.3,1.1,0.2,1.1,0.2c-0.1-0.5-0.9-1.2-2-1.6c-0.5-0.2-0.6-0.8-0.3-1.1c0.5-0.6,1.4-1.1,2.2-0.9 c1.3,0.4,2.5,1.7,2.5,1.7l1.1,1.6c0,0,0,1.8,0,1.9C308.8,161.9,307.6,162,307.6,162z"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  className: "st26",
  d: "M290.9,176.4c0,0-1.1-1-1.6-1.3c-0.5-0.3-1.8,0.2-2.4-0.5c-0.6-0.7-2-1.7-1.9-2.3c0.1-0.6,0.9-3.9,2-3.5 c1,0.3,1.4,0.7,1.8,1.1c-0.1-0.6,0.5-0.7,0.8-0.1c0.3,0.5,0.4,1.1,0.8,2c0.4,0.9,1.4,2.5,1.4,2.5L290.9,176.4z"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  className: "st27",
  d: "M317.9,169.5c0,0-9.6-5.6-10.6-6.6c-1-1-0.3-3.6,2.3-3.2c2.7,0.4,11.2,6.6,11.2,6.6L317.9,169.5z"
});

var _ref31 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M327.5,218c0.6,0,1-0.3,1-0.7l0-1.4l-2.1,0l0,1.4C326.4,217.7,326.9,218,327.5,218z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st12",
  d: "M327.4,215.2c-0.6,0-1,0.3-1,0.7c0,0.4,0.5,0.7,1.1,0.7c0.6,0,1-0.3,1-0.7 C328.5,215.5,328,215.2,327.4,215.2z"
}));

var _ref32 = /*#__PURE__*/React.createElement("path", {
  className: "st28",
  d: "M327.5,216.4c0.5,0,0.9-0.3,0.9-0.6l0-17.5l-1.8,0l0,17.5C326.5,216.1,327,216.4,327.5,216.4z"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M327.4,197.7c-0.5,0-0.9,0.3-0.9,0.6c0,0.3,0.4,0.6,0.9,0.6c0.5,0,0.9-0.3,0.9-0.6 C328.4,198,327.9,197.7,327.4,197.7z"
});

var _ref34 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M314.1,210.1c0.6,0,1-0.3,1-0.7l0-1.4l-2.1,0l0,1.4C313.1,209.8,313.6,210.1,314.1,210.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st12",
  d: "M314.1,207.4c-0.6,0-1,0.3-1,0.7c0,0.4,0.5,0.7,1.1,0.7c0.6,0,1-0.3,1-0.7 C315.2,207.7,314.7,207.4,314.1,207.4z"
}));

var _ref35 = /*#__PURE__*/React.createElement("path", {
  className: "st29",
  d: "M314.1,208.5c0.5,0,0.9-0.3,0.9-0.6l0-16.6l-1.8,0l0,16.5C313.2,208.3,313.6,208.5,314.1,208.5z"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M314.1,190.8c-0.5,0-0.9,0.3-0.9,0.6c0,0.3,0.4,0.6,0.9,0.6c0.5,0,0.9-0.3,0.9-0.6 C315,191.1,314.6,190.8,314.1,190.8z"
});

var _ref37 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M315.6,224.6c0.6,0,1-0.3,1-0.7l0-1.4l-2.1,0l0,1.4C314.6,224.3,315,224.6,315.6,224.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st12",
  d: "M315.6,221.9c-0.6,0-1,0.3-1,0.7c0,0.4,0.5,0.7,1.1,0.7c0.6,0,1-0.3,1-0.7 C316.7,222.2,316.2,221.9,315.6,221.9z"
}));

var _ref38 = /*#__PURE__*/React.createElement("path", {
  className: "st30",
  d: "M315.6,223c0.5,0,0.9-0.3,0.9-0.6l0-19.8l-1.8,0l0,19.8C314.7,222.8,315.1,223,315.6,223z"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M315.6,202.1c-0.5,0-0.9,0.3-0.9,0.6c0,0.3,0.4,0.6,0.9,0.6c0.5,0,0.9-0.3,0.9-0.6 C316.5,202.3,316.1,202.1,315.6,202.1z"
});

var _ref40 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M302.3,216.7c0.6,0,1-0.3,1-0.7l0-1.4l-2.1,0l0,1.4C301.2,216.4,301.7,216.7,302.3,216.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st12",
  d: "M302.3,214c-0.6,0-1,0.3-1,0.7c0,0.4,0.5,0.7,1.1,0.7c0.6,0,1-0.3,1-0.7 C303.3,214.3,302.9,214,302.3,214z"
}));

var _ref41 = /*#__PURE__*/React.createElement("path", {
  className: "st31",
  d: "M302.3,215.2c0.5,0,0.9-0.3,0.9-0.6l0-16.6l-1.8,0l0,16.5C301.4,214.9,301.8,215.2,302.3,215.2z"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M302.3,197.5c-0.5,0-0.9,0.3-0.9,0.6c0,0.3,0.4,0.6,0.9,0.6c0.5,0,0.9-0.3,0.9-0.6 C303.2,197.7,302.8,197.4,302.3,197.5z"
});

var _ref43 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st32",
  d: "M312.2,207l-11-6.3c-1.5-0.9-1.5-3.1,0-4l10.4-6c1.7-1,3.7-1,5.3,0l11.5,6.6c1.8,1.1,1.8,3.7,0,4.7 l-8.6,4.9C317.4,208.3,314.5,208.3,312.2,207z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st26",
  d: "M312.2,205.9l-11-6.3c-1.5-0.9-1.5-3.1,0-4l10.4-6c1.7-1,3.7-1,5.3,0l11.5,6.6c1.8,1.1,1.8,3.7,0,4.7 l-8.6,4.9C317.4,207.2,314.5,207.2,312.2,205.9z"
}));

var _ref44 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st33",
  d: "M299.6,213.3c0,0,1.3,2.5-0.2,3.6c-1.7,2-9.4-3.6-10.3-4.5c-0.9-0.9-0.1-4.4,6.1-1.8 C295.7,210.7,299.6,213.3,299.6,213.3z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st26",
  d: "M314.7,168.6c0,1.5,5.8,0.6,5.8-0.9c0-2.1-0.8-5.6,0-9c0.8-3.4-7,4.8-7,4.8S314.7,164.7,314.7,168.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st26",
  d: "M309.2,154c0,0,0,5.1,0,6.7s1.4,4.6,4.9,3.7c3.5-0.9,4-3.3,5.8-4.6s2.2-2.8,2.2-4.3 c0-1.4-2.1-5.9-6.2-5.9S309.2,152.2,309.2,154z"
})), /*#__PURE__*/React.createElement("path", {
  className: "st34",
  d: "M301.8,188.6c0-3,2.1-5.3,5.6-4.3c3.5,1,7.9,3.6,7.9,3.6l-3.1,4.6l-3.7,0.8L301.8,188.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st35",
  d: "M312,192.6c0,0-8.8-4.1-10.6-4.7c-1.8-0.7-6.7-0.3-6.7,3.9c0,4.2,0,20.4,0,21.2c0,2.7,5.2,2,5.2,0.3 c0-1.8,0-14,0-15s0-2.4,0-2.4s8.9,5.7,13.9,7c5,1.3,14-1.2,12-9.7C323.9,184.6,312,192.6,312,192.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st36",
  d: "M314.7,167.3c1.1,1,5.8,0,5.8-1.6c2.7-1,4.9,1.4,5.3,4.5c0.5,4.6,0.1,15.1,0.4,22.3 c-0.9,2.4-5.1,4.4-8.4,4.4c-3.2,0-6.5-1.9-6.4-2.9c0-1,0.3-11-0.4-13.8c-0.8-2.8-1.5-9.2,0.2-10.8 C312.7,167.9,314.7,167.3,314.7,167.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st27",
  d: "M313.5,170.2c-0.4-1.2-2.5-1.8-4.4-0.4c-2,1.4-9,6.8-10,6.6c-1-0.2-5.7-2.9-6.4-3.3 c-0.8-0.4-3.5,1.7-2.8,3.7c0.7,2,8.3,4.6,10.5,4.9c2.2,0.3,7.8-3.8,10.7-5.3C313.8,174.8,314.2,172.2,313.5,170.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st37",
  d: "M311.5,158.8c-0.4-0.4,0.4-1.5-0.2-2.7c-0.6-1.2-1.8-1.8-2.2-2.9c-0.4-1,1-2.6,2.7-3.4 c1.7-0.7,4.7-1.1,7.9,0.7c0.9,0.5,2.3,2.2,2.4,5.9c-0.1,3,0,2.8-0.9,5.1c-0.8,1.9-2.9,2.9-2.9,4.8c-0.6-2-3.7-1.3-4.5-2.6 c-0.8-1.3-1.9-4.1-1.9-4.1L311.5,158.8z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st38",
  d: "M311.2,160.7c0,0,0.1,0.8,0.6,0.8c0.4,0,0.7-0.6,1.5-2c0.8-1.4-0.3-2.4-1.5-1.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "st26",
  d: "M311.2,160.3c0,0,0.1,0.8,0.6,0.8c0.4,0,0.7-0.6,1.5-2c0.8-1.4-0.3-2.4-1.5-1.5"
})), /*#__PURE__*/React.createElement("path", {
  className: "st39",
  d: "M314.7,167c0,0-0.2,0.1-0.3,0.4c0.1,0.4,1.6,1.5,4.9,0.4c1.7-0.7,1.6-2.1,1.2-2.5c0,0,0.1,1.2-1.4,1.7 C317.6,167.6,316.5,167.8,314.7,167z"
}));

var _ref45 = /*#__PURE__*/React.createElement("path", {
  className: "st40",
  d: "M318.3,178.9l11.4-6.6c1.2-0.7,2.7,0.2,2.7,1.6v15.6c0,1.7-0.9,3.3-2.4,4.2l-11.2,6.5 c-1.3,0.7-2.8-0.2-2.8-1.6v-15.6C316,181.3,316.9,179.7,318.3,178.9z"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  className: "st41",
  d: "M319.4,179.5l11.4-6.6c1.2-0.7,2.7,0.2,2.7,1.6v15.6c0,1.7-0.9,3.3-2.4,4.2l-11.2,6.5 c-1.3,0.7-2.8-0.2-2.8-1.6v-15.6C317,181.9,317.9,180.3,319.4,179.5z"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  className: "st42",
  d: "M329.9,183.2c-1-0.6-2.1-0.6-3.1,0l-1,0.6c-2.5,1.4-4,4.1-4,6.9V206c0,0.6-0.3,1.2-0.9,1.6 c-0.6,0.3-1.2,0.3-1.8,0l-0.2-0.1v0c-0.6,0.2-1.2,0.4-1.8,0.5l1.4,0.8c0.5,0.3,1,0.4,1.6,0.4c0.5,0,1.1-0.1,1.6-0.4 c1-0.6,1.6-1.6,1.6-2.7v-15.3c0-2.4,1.3-4.5,3.3-5.7l1-0.6c0.5-0.3,1.2-0.3,1.7,0c0.5,0.3,0.9,0.9,0.9,1.5v15.3 c0,0.6-0.3,1.2-0.9,1.6c-0.6,0.3-1.2,0.3-1.8,0l-0.2-0.1l-1.4,0.8l0.9,0.5c1,0.6,2.2,0.6,3.2,0c1-0.6,1.6-1.6,1.6-2.7v-15.3 C331.4,184.8,330.8,183.8,329.9,183.2z"
});

var _ref48 = /*#__PURE__*/React.createElement("polygon", {
  className: "st43",
  points: "153.6,117.9 228.1,74.8 228.1,139.4 153.6,182.4  "
});

var _ref49 = /*#__PURE__*/React.createElement("polygon", {
  className: "st44",
  points: "155.2,118.5 226.6,77.2 226.6,138.7 155.2,180  "
});

var _ref50 = /*#__PURE__*/React.createElement("polygon", {
  className: "st45",
  points: "153.6,182.4 152.1,181.5 152.1,117 153.6,117.9  "
});

var _ref51 = /*#__PURE__*/React.createElement("polygon", {
  className: "st46",
  points: "152.1,117 226.6,74 228.1,74.8 153.6,117.9  "
});

var _ref52 = /*#__PURE__*/React.createElement("polygon", {
  className: "st47",
  points: "226.6,138.7 155.2,180 155.2,179.4 226.1,138.4  "
});

var _ref53 = /*#__PURE__*/React.createElement("polygon", {
  className: "st48",
  points: "226.6,138.7 226.6,77.2 226.1,77.5 226.1,138.4  "
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  className: "st49",
  d: "M148.5,130.1c0,1.7-1.3,3.1-3,3.1c-1.6,0-3-1.4-3-3.1c0-1.7,1.3-3.1,3-3.1 C147.2,126.9,148.5,128.3,148.5,130.1z"
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  className: "st50",
  d: "M144.3,131c0,0.9,0.3,1.6,0.9,2.2c0.1,0,0.3,0,0.4,0c1.6,0,3-1.4,3-3.1c0-0.9-0.3-1.6-0.9-2.2 c-0.1,0-0.3,0-0.4,0C145.6,127.8,144.3,129.2,144.3,131z"
});

var _ref56 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st43",
  d: "M186.4,143.5c-0.9,0.5-1.4,0.6-2.6,0.6c-4.1,1.7-3.2,1.4-3.2,1.4l-1.4-1.2c0,0-0.5,0.1,1.9-1.7 c0,0,2.6-1.2,3-1.3c1.2,0.6,1.4-1.2,2.2-1.4c0.2-0.1,0.9,0.2,1,0.4c0.1,0.2,0.2,1.9,0.1,2.2 C187.3,142.9,186.7,143.4,186.4,143.5z"
}));

var _ref57 = /*#__PURE__*/React.createElement("path", {
  className: "st51",
  d: "M168.5,150.8c-0.1,0-0.1,0-0.2,0c-1.3,0-13.5-3.9-14.7-4.2c-1.5-0.3-2.8-1.2-2.6-2.7 c0.2-1.2,2.2-2.7,4.5-2.5c2.3,0.2,12.5,5.2,13.1,5.3c0,0,11.9-4.7,12.8-4.5l1.4,2.8L168.5,150.8z"
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  className: "st52",
  d: "M182,145.2c-0.1,0-0.3,0-0.3-0.2c-0.1-0.4-0.2-1.2-0.3-1.4l0.3-0.4l-0.5-0.2c0,0-0.1-0.4-0.2-0.9 c0-0.1,0-0.3,0.1-0.3c0.3-0.1,0.7-0.2,0.9-0.2c0,0,0.1,0,0.1,0c0.4,0.3,0.5,2,0.8,2.9c0.1,0.1,0,0.3-0.1,0.3L182,145.2z"
});

var _ref59 = /*#__PURE__*/React.createElement("path", {
  className: "st43",
  d: "M159.2,218.8c0-0.7-1.6-2.7-1.8-4.6c0-0.4-0.1-1-0.1-1.6c-0.6,0.6-2.6,0.5-3.2,0c0,0.4-0.1,0.8-0.2,1.1 c0,0,0,0.5,0,0.6c0,0.1,0.5,1.7,0.5,1.7s1.8,3.4,1.8,3.5c0,0.1,0.8,0.2,1,0.2C157.4,219.8,159.3,219.5,159.2,218.8z"
});

var _ref60 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st53",
  d: "M153.9,218.1L153.9,218.1c-0.2,0-0.3-0.1-0.3-0.3V215h0.5v2.9C154,218,153.9,218.1,153.9,218.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st54",
  d: "M154.1,212.5c0,0-1,0.1-1,2.1c0,1.9,1,1.6,1.3,2.5c0.3,0.9,1.1,2.7,2.5,3.1s2.7,1,3.7,0.8 c0.4-0.1,0.1-0.8-0.1-0.9c-0.2-0.1-1.1-1.6-1.3-2c0,0-0.1,0-0.1,0c-0.1,0.2-0.6,0.9-1.5,1.1c-0.4,0.1-1.6,0.5-3.5-6 L154.1,212.5z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st53",
  d: "M159.1,218.1C159.1,218.1,159.1,218.1,159.1,218.1C159.1,218.1,159.1,218.1,159.1,218.1 C159.1,218.1,159.1,218.1,159.1,218.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st53",
  d: "M157.2,219.9c-1.4-0.5-2.2-2.2-2.5-3.1c-0.3-0.9-1.3-0.5-1.3-2.5c0-0.8,0.2-1.3,0.4-1.6 c-0.3,0.2-0.7,0.7-0.7,1.9c0,1.9,1,1.6,1.3,2.5c0.3,0.9,1.1,2.7,2.5,3.1s2.7,1,3.7,0.8c0.2,0,0.2-0.2,0.2-0.3 C159.9,220.8,158.6,220.3,157.2,219.9z"
})));

var _ref61 = /*#__PURE__*/React.createElement("path", {
  className: "st43",
  d: "M147.9,215.8c-0.4,4.4-0.9,5.4,0.1,6.5c0.7,0.8,2.3,1.6,2.9,0.4c0.2-0.5,0-2.1,0-2.9 c0-1.8-0.5-1.5-0.3-4.8C150.4,213.6,147.9,215.8,147.9,215.8z"
});

var _ref62 = /*#__PURE__*/React.createElement("path", {
  className: "st54",
  d: "M147.9,215.8c0,0-0.4,3.6,0.1,5.5c0.4,1.4,2,1.6,2.7,0.6c0.3-0.5,0.1-1.6,0.2-2.5c0.1-0.4,0.3,1.6,0.3,2.7 c0,0.4,0,0.8-0.1,1.1l-0.5,2.1c-0.1,0.4-0.4,0.6-0.8,0.6h-0.4c-0.3,0-0.6-0.2-0.7-0.4l-1.1-2c-0.4-0.8-0.6-1.6-0.5-2.5 c0.1-1.3,0.6-0.4-0.2-2.2C146.7,218,147.4,215.9,147.9,215.8z"
});

var _ref63 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st53",
  d: "M150.1,225.6h-0.4c-0.3,0-0.6-0.2-0.7-0.4l-1.1-2c-0.4-0.8-0.6-1.6-0.5-2.5c0.1-1.3,0.6-0.4-0.2-2.2 c-0.3-0.6,0-1.9,0.5-2.6c-0.5,0.4-1.1,2.2-0.7,2.9c0.7,1.9,0.2,0.9,0.2,2.2c-0.1,0.9,0.1,1.7,0.5,2.5l1.1,2 c0.1,0.3,0.4,0.4,0.7,0.4h0.4c0.3,0,0.6-0.2,0.7-0.5C150.4,225.6,150.3,225.6,150.1,225.6z"
}));

var _ref64 = /*#__PURE__*/React.createElement("path", {
  className: "st55",
  d: "M154,212.4c0.1,0.9,3.4,1.3,3.5,0.1c0-5.9,1.6-17.8,1.3-18.7c4.6-17.4,0.5-28.5,0.5-28.5 c-1.2-0.4-5.4-0.7-5.4-0.7s-2.3,4.2-2.2,9.9c0.1,5.7,1.5,18.2,1.5,18.2C152.5,197.2,154.6,206.4,154,212.4z"
});

var _ref65 = /*#__PURE__*/React.createElement("path", {
  className: "st56",
  d: "M159.3,165.4c-1.2-0.4-5.4-0.7-5.4-0.7s-0.1,0.2-0.3,0.7c1.3,0.1,3.6,0.3,4.4,0.6c0,0,4.1,11.1-0.5,28.5 c0.3,0.9-1.3,12.8-1.3,18.7c0,0,0,0.1,0,0.1c0.7,0,1.3-0.3,1.3-0.7c0-5.9,1.6-17.8,1.3-18.7 C163.4,176.4,159.3,165.4,159.3,165.4z"
});

var _ref66 = /*#__PURE__*/React.createElement("path", {
  className: "st57",
  d: "M146.4,167.2c-1.7,1.1-2.6,3.8-2.3,6.8c0.4,4.8,5.3,14.6,4.3,19.1c-2.4,7.2,0.4,16.5-0.7,22.8 c0.7,2,2.8,2.1,2.9,0.4c0,0,1.9-12.7,3.3-23.2c0.4-12.1,2.4-13,0.5-24.9C154.1,166.3,146.4,167.2,146.4,167.2z"
});

var _ref67 = /*#__PURE__*/React.createElement("path", {
  className: "st56",
  d: "M154.5,168.3c-0.1-0.8-1.4-1.1-2.8-1.2c0.6,0.2,1,0.5,1.1,1c1.8,12.1-0.1,13.1-0.5,25.4 c-1.3,10.7-3.2,23.8-3.2,23.8c0,0.1,0,0.1,0,0.2c0.8,0.3,1.6-0.1,1.7-1c0,0,1.9-12.7,3.3-23.2 C154.3,181.1,156.3,180.2,154.5,168.3z"
});

var _ref68 = /*#__PURE__*/React.createElement("path", {
  className: "st58",
  d: "M150.6,142c-0.6,0.2-2.5,1.3-4.1,2.1c-1.6,0.8-2.2,2.7-2.2,4.5c0.1,3.3,0.8,6.5,2.9,9.8 c1.2,1.9,1.1,5.5-0.8,8.8c1.5,1.9,5.1,2.4,7.5,2.2c4.3-0.4,6.3-2.8,5.8-4.7c0,0-0.8-4.1-1-6.6c-0.1-2.2,0.3-4.5,0.6-5.5 c1.4-0.3,3-2.3,0.9-6c-0.1-1.2-0.1-5.2-3.3-5.8c-2.6,0.7-5.4,1.3-6.1,1.5C150.6,142.2,150.7,142,150.6,142z"
});

var _ref69 = /*#__PURE__*/React.createElement("path", {
  className: "st43",
  d: "M150.1,143.6l-0.9,0.5l2.8,4c0.8,1.2,2.4,1.6,3.7,0.9l0.5-0.3c0.9-0.5,1.2-1.6,0.7-2.4l-2.1-3.7 L150.1,143.6z"
});

var _ref70 = /*#__PURE__*/React.createElement("path", {
  className: "st43",
  d: "M154.9,144.2l0.3,2.7c0.1,1-1.1,1.6-1.8,0.8l-3.4-4c0,0,1.5,0.7,1.5,0.7c0.5-0.5,1.8-0.3,1.8-0.3 L154.9,144.2z"
});

var _ref71 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st43",
  d: "M150.4,139.2c0,0,0.2,2.2-0.3,4.4c0.9,1.5,4.2,2.3,4.8,0.5c0,0-0.2-1.5,0.5-2.6 C156,140.5,150.4,139.2,150.4,139.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st59",
  d: "M150.4,139.2c0,0,0.1,0.7,0,1.6c0.3,0.3,0.5,0.6,0.5,0.6c1.2,1.6,2.6,2.3,3.9,2.5c0-0.4,0-1.6,0.5-2.4 C156,140.5,150.4,139.2,150.4,139.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st43",
  d: "M157,131.2c0,0,1.2,2.2,1.2,4.5c-0.1,0.3,0.4,0.9,0.3,2.2c-0.1,0.9-0.3,2.9-0.4,3.9c0,0.4-0.3,0.7-0.7,0.7 c-1.9,0.3-5,0.5-7.2-2.5c0,0-1.1-1.3-1.6-1.4c-0.5-0.2-2.4-2.6-2.4-4.7c0-2.1,1.2-5.4,5.6-5.4C155.5,128.6,157,131.2,157,131.2z "
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st60",
  d: "M158.3,135.7c0-2.4-1.2-4.5-1.2-4.5s-0.6-1-1.9-1.8c0.7,0.6,1.1,1.2,1.1,1.2s1.8,2.3,1.8,4.6 c-0.1,0.3,0.4,0.7,0.3,2c-0.1,0.9-0.6,3-0.7,4c0,0.4-0.3,0.7-0.7,0.7c-1.4,0.2-3.6,0.3-5.4-0.7c2,1.7,4.4,1.5,6,1.2 c0.4-0.1,0.6-0.4,0.7-0.7c0.1-1,0.3-2.9,0.4-3.9C158.7,136.6,158.2,136,158.3,135.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st61",
  d: "M148.4,138.3c0.1,0.1,0.2,0.2,0.3,0.3C148.6,138.5,148.5,138.4,148.4,138.3z"
})));

var _ref72 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st43",
  d: "M145.6,171.3c0,0,0.1,4.8,0.7,7.3c-0.4,0.5-2.4,1.5-2.5,0.8c-0.6-4.2-1.1-8.1-1.1-8.1L145.6,171.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st43",
  d: "M143.8,179.4c0,0,0.3,3.6,0.5,3.7c0.6,0.3,0.9,0.5,1.9,0.8c1.5,0.4,1.9-0.3,1.9-0.3s-0.1-1.4-0.1-2.2 c0.1-0.8-1.3-0.9-1.7-2.5c-0.4-1.7-2.5,0-2.5,0L143.8,179.4z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st62",
  d: "M148.1,182.8c-0.4-0.1-0.7-0.3-1-0.6c-0.3-0.3-0.5-0.6-0.5-1c0.2,0.3,0.4,0.6,0.7,0.8 C147.5,182.3,147.8,182.5,148.1,182.8z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st62",
  d: "M146.5,181.6c0.1-0.4,0.2-0.6,0.4-0.9C147,181,146.9,181.5,146.5,181.6z"
}))));

var _ref73 = /*#__PURE__*/React.createElement("path", {
  className: "st63",
  d: "M141.4,162.7c0-0.1,0-0.5,0-0.6c0.1-1.3,1.7-13.8,2.1-14.9c0.4-1.4,1.4-2.7,2.9-2.4 c1.2,0.3,2.5,2.4,2.1,4.7c-0.4,2.3-2.9,13.1-3,13.7c0,0,0.9,14.3,0.7,15.3l-2.6,1.1L141.4,162.7z"
});

var _ref74 = /*#__PURE__*/React.createElement("path", {
  className: "st64",
  d: "M143.3,178.9c0-0.1,0-0.2,0.2-0.3c0.3-0.1,1-0.2,1.2-0.3l0.3,0.3l0.2-0.5c0,0,0.9-0.2,1.3-0.3 c0.1,0,0.2,0,0.3,0.1c0.1,0.3,0.1,0.7,0.2,0.8c0,0,0,0.1,0,0.1c-0.2,0.3-2.3,0.6-3,0.9c-0.1,0.1-0.3,0-0.3-0.1L143.3,178.9z"
});

var _ref75 = /*#__PURE__*/React.createElement("path", {
  className: "st49",
  d: "M151.6,133.4c-0.9,0.9-0.3,3.9-1.5,4c0,0,0.6,1.9,0.3,3.4c-0.5-1.3-2-2.1-3.4-3.9c-0.7-0.9-1.6-1.6-1.6-2.9 c0-0.8,0.3-3.6,1.5-4.8c0.1-1.4,5.6-2.9,9.1,0c1.5,1.4,1.4,2.5,1.4,2.5C155.3,129.3,152.4,131.1,151.6,133.4z"
});

var _ref76 = /*#__PURE__*/React.createElement("path", {
  className: "st65",
  d: "M145.6,132.5c-0.1,0.7-0.2,1.2-0.2,1.6c0,1.4,0.8,2,1.6,2.9c1.5,1.8,2.9,2.6,3.4,3.9 c0.2-1.5-0.3-3.4-0.3-3.4l-0.7,0.5C148.6,137.6,146.2,134.3,145.6,132.5z"
});

var _ref77 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st66",
  d: "M149.7,137.1c-0.8-0.9-1.9-0.1-1.2,0.9c0.1,0.2,0.5,0.3,0.6,0.6c0.1,0.1,0.1,0.2,0.2,0.3 c0.2,0.2,0.4,0.4,0.6,0.5c0.2,0.1,0.3,0,0.5-0.2L149.7,137.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st43",
  d: "M150.4,137.1c-0.5-1.1-1.7-0.7-1.4,0.5c0.1,0.3,0.3,0.5,0.4,0.7c0.2,1.1,0.6,1.3,1,1"
}));

var _ref78 = /*#__PURE__*/React.createElement("path", {
  className: "st67",
  d: "M150.1,139.3c0,0.2-0.1,0.3-0.3,0.3c-0.2,0-0.3-0.1-0.3-0.3c0-0.2,0.1-0.3,0.3-0.3 C150,139,150.1,139.2,150.1,139.3z"
});

var _ref79 = /*#__PURE__*/React.createElement("path", {
  className: "st43",
  d: "M183.3,141.7c0.4-0.9,1.5-0.6,1.9-1.4c0.4-0.8,0.2-0.4,0.2-0.5s0.9,0.1,0.3,1c-0.5,0.7-0.7,0.6-0.8,1.1 c-0.1,0.5-1.3,0-1.3,0L183.3,141.7z"
});

var _ref80 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M207.7,265.9c0.8,0,1.5-0.4,1.5-1l0-1.9l-2.9,0.1l0,1.9C206.2,265.5,206.9,265.9,207.7,265.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st12",
  d: "M207.6,262.1c-0.8,0-1.5,0.4-1.5,1c0,0.5,0.7,0.9,1.5,0.9c0.8,0,1.5-0.4,1.5-1 C209.1,262.5,208.5,262.1,207.6,262.1z"
}));

var _ref81 = /*#__PURE__*/React.createElement("path", {
  className: "st68",
  d: "M207.7,263.7c0.7,0,1.3-0.4,1.3-0.8l0-27.3l-2.5,0.1l0,27.3C206.4,263.4,207,263.7,207.7,263.7z"
});

var _ref82 = /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M207.6,234.8c-0.7,0-1.3,0.4-1.3,0.8s0.6,0.8,1.3,0.8c0.7,0,1.3-0.4,1.3-0.8 C208.9,235.1,208.3,234.8,207.6,234.8z"
});

var _ref83 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M254.3,239.5c0.8,0,1.5-0.4,1.5-1l0-1.9l-2.9,0.1l0,1.9C252.8,239.1,253.5,239.5,254.3,239.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st12",
  d: "M254.3,235.7c-0.8,0-1.5,0.4-1.5,1s0.7,0.9,1.5,0.9c0.8,0,1.5-0.4,1.5-1 C255.8,236.1,255.1,235.7,254.3,235.7z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st15",
  d: "M254.3,237.3c0.7,0,1.3-0.4,1.3-0.8l0-27.3l-2.5,0.1l0,27.3C253,236.9,253.6,237.3,254.3,237.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M254.3,208.3c-0.7,0-1.3,0.4-1.3,0.8s0.6,0.8,1.3,0.8c0.7,0,1.3-0.4,1.3-0.8 C255.6,208.7,255,208.3,254.3,208.3z"
})));

var _ref84 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M185.4,253.2c0.8,0,1.5-0.4,1.5-1l0-1.9l-2.9,0.1l0,1.9C184,252.8,184.6,253.3,185.4,253.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st12",
  d: "M185.4,249.5c-0.8,0-1.5,0.4-1.5,1c0,0.5,0.7,0.9,1.5,0.9c0.8,0,1.5-0.4,1.5-1 C186.9,249.9,186.2,249.4,185.4,249.5z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st15",
  d: "M185.4,251.1c0.7,0,1.3-0.4,1.3-0.8l0-27.3l-2.5,0.1l0,27.3C184.2,250.7,184.7,251.1,185.4,251.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M185.4,222.1c-0.7,0-1.3,0.4-1.3,0.8c0,0.4,0.6,0.8,1.3,0.8c0.7,0,1.3-0.4,1.3-0.8 C186.7,222.5,186.1,222.1,185.4,222.1z"
})));

var _ref85 = /*#__PURE__*/React.createElement("path", {
  className: "st69",
  d: "M257.9,209L257.9,209l0-2.1l-2.8,2.1l-18.3-10.6c-2.6-1.5-5.9-1.5-8.5,0l-43.2,24.9 c-0.3-0.8-0.6-1.6-0.7-1.7c-0.2,0-2-0.7-2-0.7v2.1c0,1,0.5,2.1,1.5,2.7l19.5,11.2c3.1,1.8,6.8,1.8,9.9,0l42.8-24.7 C257.4,211.5,258,210.2,257.9,209z"
});

var _ref86 = /*#__PURE__*/React.createElement("path", {
  className: "st70",
  d: "M183.9,218.2l44.3-25.6c2.6-1.5,5.9-1.5,8.5,0l19.3,11.2c2.4,1.4,2.4,4.9,0,6.3l-42.8,24.7 c-3.1,1.8-6.8,1.8-9.9,0l-19.5-11.2C181.9,222.4,181.9,219.4,183.9,218.2z"
});

var _ref87 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st19",
  d: "M237.7,211L237.7,211l-12.7-7.3l-18.3,10.5l-3-0.2v0.4l15.2,8.8l10.2-5.9c0,0,1.7,0,2.3-1.3l8.7-5.1 v-0.4L237.7,211z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st20",
  d: "M203.8,214l15.2,8.8l10.2-5.9c0,0,1.4-0.1,2.3-1.3l8.7-5.1l-15.2-8.8L203.8,214z"
}));

var _ref88 = /*#__PURE__*/React.createElement("path", {
  className: "st21",
  d: "M229.9,215"
});

var _ref89 = /*#__PURE__*/React.createElement("path", {
  className: "st22",
  d: "M238,209.8l-0.5,0.2l0,0.1l-12.8-7.4l-8.3,4.8l13.5,7.5c0,0,0.4-0.5,1.3,0.3l8.2-4.7v-0.8H238z"
});

var _ref90 = /*#__PURE__*/React.createElement("path", {
  className: "st71",
  d: "M229.8,214.9c0.5-3,7.5-3.7,9.5-5.2l-15.1-8.6c-2.3,2.1-9.4,2.8-9.6,5.3L229.8,214.9z"
});

var _ref91 = /*#__PURE__*/React.createElement("path", {
  className: "st22",
  d: "M229.3,214.7l-3.1-0.3l-0.6,0.4l-11-6.4l-8.3,4.8l0.1-0.4l-1.2-0.3l-0.5,0.1v1l14.6,8.5l9.6-5.6 c0.3-1.6,0.9-1.6,0.9-1.6L229.3,214.7z"
});

var _ref92 = /*#__PURE__*/React.createElement("path", {
  className: "st72",
  d: "M229.9,215c-3.5-1.4-6.8,4.6-10.6,6.2l-14.6-8.5c0,0,6.5-8,9.9-6.2L229.9,215z"
});

var _ref93 = /*#__PURE__*/React.createElement("path", {
  className: "st26",
  d: "M238.6,204.7l-1.1-1.6c0,0-1.2-1.3-2.5-1.7c-0.8-0.2-1.7,0.3-2.2,0.9c-0.3,0.4-0.2,1,0.3,1.1 c1,0.4,1.9,1.1,2,1.6c0,0-0.4,0.1-1.1-0.2c-0.7-0.3-1.1,0.2-0.9,0.5c0.1,0.1,0.3,0.3,0.8,0.6c0.5,0.3,1.7,0.1,2.1,0.1 s1.3,0.8,1.3,0.8c0.9,0.5,5,3.9,7.4,5.5c2.4,1.6,6.8,2.6,7.5,1.7c0.7-0.9-12-8.5-12-8.5L238.6,204.7z"
});

var _ref94 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M257.2,262.7c0.6,0,1-0.3,1-0.7l0-1.4l-2.1,0l0,1.4C256.1,262.4,256.6,262.7,257.2,262.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st12",
  d: "M257.2,260c-0.6,0-1,0.3-1,0.7c0,0.4,0.5,0.7,1.1,0.7c0.6,0,1-0.3,1-0.7 C258.2,260.2,257.7,260,257.2,260z"
}));

var _ref95 = /*#__PURE__*/React.createElement("path", {
  className: "st73",
  d: "M257.2,261.1c0.5,0,0.9-0.3,0.9-0.6l0-17.5l-1.8,0l0,17.5C256.3,260.9,256.7,261.1,257.2,261.1z"
});

var _ref96 = /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M257.2,242.4c-0.5,0-0.9,0.3-0.9,0.6c0,0.3,0.4,0.6,0.9,0.6c0.5,0,0.9-0.3,0.9-0.6 C258.1,242.7,257.7,242.4,257.2,242.4z"
});

var _ref97 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M243.9,254.8c0.6,0,1-0.3,1-0.7l0-1.4l-2.1,0l0,1.4C242.8,254.5,243.3,254.8,243.9,254.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st12",
  d: "M243.8,252.1c-0.6,0-1,0.3-1,0.7s0.5,0.7,1.1,0.7c0.6,0,1-0.3,1-0.7 C244.9,252.4,244.4,252.1,243.8,252.1z"
}));

var _ref98 = /*#__PURE__*/React.createElement("path", {
  className: "st74",
  d: "M243.9,253.3c0.5,0,0.9-0.3,0.9-0.6l0-16.6l-1.8,0l0,16.5C242.9,253,243.3,253.3,243.9,253.3z"
});

var _ref99 = /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M243.8,235.5c-0.5,0-0.9,0.3-0.9,0.6c0,0.3,0.4,0.6,0.9,0.6c0.5,0,0.9-0.3,0.9-0.6 C244.7,235.8,244.3,235.5,243.8,235.5z"
});

var _ref100 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M245.3,269.3c0.6,0,1-0.3,1-0.7l0-1.4l-2.1,0l0,1.4C244.3,269,244.7,269.3,245.3,269.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st12",
  d: "M245.3,266.6c-0.6,0-1,0.3-1,0.7c0,0.4,0.5,0.7,1.1,0.7c0.6,0,1-0.3,1-0.7 C246.4,266.9,245.9,266.6,245.3,266.6z"
}));

var _ref101 = /*#__PURE__*/React.createElement("path", {
  className: "st75",
  d: "M245.3,267.7c0.5,0,0.9-0.3,0.9-0.6l0-19.8l-1.8,0l0,19.8C244.4,267.5,244.8,267.7,245.3,267.7z"
});

var _ref102 = /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M245.3,246.8c-0.5,0-0.9,0.3-0.9,0.6c0,0.3,0.4,0.6,0.9,0.6c0.5,0,0.9-0.3,0.9-0.6 C246.2,247.1,245.8,246.8,245.3,246.8z"
});

var _ref103 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M232,261.4c0.6,0,1-0.3,1-0.7l0-1.4l-2.1,0l0,1.4C230.9,261.2,231.4,261.5,232,261.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st12",
  d: "M232,258.7c-0.6,0-1,0.3-1,0.7c0,0.4,0.5,0.7,1.1,0.7c0.6,0,1-0.3,1-0.7C233,259,232.6,258.7,232,258.7 z"
}));

var _ref104 = /*#__PURE__*/React.createElement("path", {
  className: "st76",
  d: "M232,259.9c0.5,0,0.9-0.3,0.9-0.6l0-16.6l-1.8,0l0,16.5C231.1,259.6,231.5,259.9,232,259.9z"
});

var _ref105 = /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M232,242.2c-0.5,0-0.9,0.3-0.9,0.6c0,0.3,0.4,0.6,0.9,0.6c0.5,0,0.9-0.3,0.9-0.6S232.5,242.2,232,242.2 z"
});

var _ref106 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st32",
  d: "M241.9,251.7l-11-6.3c-1.5-0.9-1.5-3.1,0-4l10.4-6c1.7-1,3.7-1,5.3,0l11.5,6.6c1.8,1.1,1.8,3.7,0,4.7 l-8.6,4.9C247.1,253.1,244.2,253.1,241.9,251.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st26",
  d: "M241.9,250.6l-11-6.3c-1.5-0.9-1.5-3.1,0-4l10.4-6c1.7-1,3.7-1,5.3,0l11.5,6.6c1.8,1.1,1.8,3.7,0,4.7 l-8.6,4.9C247.1,252,244.2,252,241.9,250.6z"
}));

var _ref107 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st33",
  d: "M229.3,258c0,0,1.3,2.5-0.2,3.6c-1.7,2-9.4-3.6-10.3-4.5c-0.9-0.9-0.1-4.4,6.1-1.8 C225.4,255.4,229.3,258,229.3,258z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st26",
  d: "M244.4,213.3c0,1.5,5.8,0.6,5.8-0.9c0-2.1-0.8-5.6,0-9c0.8-3.4-7,4.8-7,4.8S244.4,209.4,244.4,213.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st26",
  d: "M238.9,198.7c0,0,0,5.1,0,6.7s1.4,4.6,4.9,3.7c3.5-0.9,4-3.3,5.8-4.6c1.8-1.2,2.2-2.8,2.2-4.3 c0-1.4-2.1-5.9-6.2-5.9C241.6,194.4,238.9,197,238.9,198.7z"
})), /*#__PURE__*/React.createElement("path", {
  className: "st34",
  d: "M231.5,233.3c0-3,2.1-5.3,5.6-4.3c3.5,1,7.9,3.6,7.9,3.6l-3.1,4.6l-3.7,0.8L231.5,233.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st35",
  d: "M241.7,237.3c0,0-8.8-4.1-10.6-4.7c-1.8-0.7-6.7-0.3-6.7,3.9c0,4.2,0,20.4,0,21.2c0,2.7,5.2,2,5.2,0.3 s0-14,0-15s0-2.4,0-2.4s8.9,5.7,13.9,7c5,1.3,14-1.2,12-9.7C253.6,229.3,241.7,237.3,241.7,237.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st36",
  d: "M244.4,212c1.1,1,5.8,0,5.8-1.6c2.7-1,4.9,1.4,5.3,4.5c0.5,4.6,0.1,15.1,0.4,22.3 c-0.9,2.4-5.1,4.4-8.4,4.4c-3.2,0-6.5-1.9-6.4-2.9c0-1,0.3-11-0.4-13.8c-0.8-2.8-1.5-9.2,0.2-10.8 C242.4,212.6,244.4,212,244.4,212z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st26",
  d: "M229.5,221.3c0.7,0.2,5.9-3.8,7.3-4.8c1.4-1,2.9-0.6,3.2,0.3c0.5,1.5,0.3,3.4-1.9,4.5 c-2.1,1.1-6.2,4.1-7.8,3.9c-1.6-0.2-8.9-5.2-8.9-5.2s-1.2-0.7-1.6-0.9c-0.5-0.2-1.7,0.1-2.4-0.6c-0.6-0.6-2-1.5-1.9-2 c0.1-0.5,0.9-3.3,2-3c1,0.3,1.4,0.6,1.8,0.9c-0.1-0.5,0.5-0.6,0.8-0.1c0.3,0.4,0.4,0.9,0.8,1.7c0.4,0.8,1.2,1.3,1.2,1.3 S228.8,221.1,229.5,221.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st39",
  d: "M244.4,211.8c0,0-0.2,0.1-0.3,0.4c0.1,0.4,1.6,1.5,4.9,0.4c1.7-0.7,1.6-2.1,1.2-2.5c0,0,0.1,1.2-1.4,1.7 C247.3,212.3,246.2,212.5,244.4,211.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st77",
  d: "M238.6,197.4c0,0,0.8,4,3.1,4.6c0.5,0.2,0.6,0.3,0.9,1c0.3,0.7,0.6,4,1.2,4.4c0,0-0.4,1.1,0.4,1.5 c0,0,0.6,0.7,1.6,0.6c0,0,1.7,0.1,2.3-0.9c0,0,0.7-0.2,1.4-0.6c0.7-0.4,0.8-0.5,0.8-1.6c0.1-1.1,0.5-1.1,0.8-1.7 s0.2-2.1,0.6-2.3c0.4-0.2,1.1-0.6,0.9-1.6c-0.2-1-0.9-1.9-0.9-2.3c0.1-0.4,0.2-1.1-0.5-1.8c-0.7-0.8-0.9-0.6-1.1-1.4 c-0.2-0.8-0.3-1.3-1.1-1.3s-1.1,0.2-1.7-0.2c-0.6-0.4-0.6-0.7-1.6-0.4c-1,0.2-1.6,0.4-2.2,0.3c-0.6,0-1.5,0.1-1.8,0.4 c-0.3,0.3-0.4,0.3-1.5,0.5C239.2,194.8,238.2,195.9,238.6,197.4z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st38",
  d: "M240.9,205.5c0,0,0.1,0.8,0.6,0.8c0.4,0,0.7-0.6,1.5-2c0.8-1.4-0.3-2.4-1.5-1.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "st26",
  d: "M240.9,205c0,0,0.1,0.8,0.6,0.8c0.4,0,0.7-0.6,1.5-2c0.8-1.4-0.3-2.4-1.5-1.5"
})));

var _ref108 = /*#__PURE__*/React.createElement("path", {
  className: "st78",
  d: "M248,223.6l11.4-6.6c1.2-0.7,2.7,0.2,2.7,1.6v15.6c0,1.7-0.9,3.3-2.4,4.2l-11.2,6.5 c-1.3,0.7-2.8-0.2-2.8-1.6v-15.6C245.7,226,246.6,224.4,248,223.6z"
});

var _ref109 = /*#__PURE__*/React.createElement("path", {
  className: "st79",
  d: "M249.1,224.2l11.4-6.6c1.2-0.7,2.7,0.2,2.7,1.6v15.6c0,1.7-0.9,3.3-2.4,4.2l-11.2,6.5 c-1.3,0.7-2.8-0.2-2.8-1.6v-15.6C246.8,226.6,247.6,225.1,249.1,224.2z"
});

var _ref110 = /*#__PURE__*/React.createElement("path", {
  className: "st80",
  d: "M259.6,228c-1-0.6-2.1-0.6-3.1,0l-1,0.6c-2.5,1.4-4,4.1-4,6.9v15.3c0,0.6-0.3,1.2-0.9,1.6 c-0.6,0.3-1.2,0.3-1.8,0l-0.2-0.1v0c-0.6,0.2-1.2,0.4-1.8,0.5l1.4,0.8c0.5,0.3,1,0.4,1.6,0.4c0.5,0,1.1-0.1,1.6-0.4 c1-0.6,1.6-1.6,1.6-2.7v-15.3c0-2.4,1.3-4.5,3.3-5.7l1-0.6c0.5-0.3,1.2-0.3,1.7,0c0.5,0.3,0.9,0.9,0.9,1.5V246 c0,0.6-0.3,1.2-0.9,1.6c-0.6,0.3-1.2,0.3-1.8,0l-0.2-0.1l-1.4,0.8l0.9,0.5c1,0.6,2.2,0.6,3.2,0c1-0.6,1.6-1.6,1.6-2.7v-15.3 C261.1,229.5,260.6,228.5,259.6,228z"
});

var _ref111 = /*#__PURE__*/React.createElement("path", {
  className: "st27",
  d: "M233.6,218.3c0,0-1.4,5.1,1.2,6.2c0,0,6.3-3.4,7.4-4.2s2.2-3.1,1-5.3c-1.2-2.2-2.7-1.7-4.4-0.4 C237.1,215.8,233.6,218.3,233.6,218.3z"
});

var _ref112 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M309.9,282.4c0.8,0,1.5-0.4,1.5-1l0-1.9l-2.9,0.1l0,1.9C308.4,282,309.1,282.4,309.9,282.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st12",
  d: "M309.8,278.6c-0.8,0-1.5,0.4-1.5,1c0,0.5,0.7,0.9,1.5,0.9c0.8,0,1.5-0.4,1.5-1 C311.3,279,310.7,278.6,309.8,278.6z"
}));

var _ref113 = /*#__PURE__*/React.createElement("path", {
  className: "st81",
  d: "M309.9,280.2c0.7,0,1.3-0.4,1.3-0.8l0-27.3l-2.5,0.1l0,27.3C308.6,279.9,309.2,280.2,309.9,280.2z"
});

var _ref114 = /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M309.8,251.3c-0.7,0-1.3,0.4-1.3,0.8c0,0.4,0.6,0.8,1.3,0.8c0.7,0,1.3-0.4,1.3-0.8 C311.1,251.6,310.6,251.3,309.8,251.3z"
});

var _ref115 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M356.5,256c0.8,0,1.5-0.4,1.5-1l0-1.9l-2.9,0.1l0,1.9C355,255.6,355.7,256,356.5,256z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st12",
  d: "M356.5,252.2c-0.8,0-1.5,0.4-1.5,1c0,0.5,0.7,0.9,1.5,0.9c0.8,0,1.5-0.4,1.5-1 C358,252.6,357.3,252.2,356.5,252.2z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st15",
  d: "M356.5,253.8c0.7,0,1.3-0.4,1.3-0.8l0-27.3l-2.5,0.1l0,27.3C355.2,253.5,355.8,253.8,356.5,253.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M356.5,224.9c-0.7,0-1.3,0.4-1.3,0.8c0,0.4,0.6,0.8,1.3,0.8c0.7,0,1.3-0.4,1.3-0.8 C357.8,225.2,357.2,224.9,356.5,224.9z"
})));

var _ref116 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M287.6,269.8c0.8,0,1.5-0.4,1.5-1l0-1.9l-2.9,0.1l0,1.9C286.2,269.4,286.8,269.8,287.6,269.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st12",
  d: "M287.6,266c-0.8,0-1.5,0.4-1.5,1c0,0.5,0.7,0.9,1.5,0.9c0.8,0,1.5-0.4,1.5-1 C289.1,266.4,288.4,266,287.6,266z"
}));

var _ref117 = /*#__PURE__*/React.createElement("path", {
  className: "st82",
  d: "M287.6,267.6c0.7,0,1.3-0.4,1.3-0.8l0-27.3l-2.5,0.1l0,27.3C286.4,267.2,286.9,267.6,287.6,267.6z"
});

var _ref118 = /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M287.6,238.6c-0.7,0-1.3,0.4-1.3,0.8c0,0.4,0.6,0.8,1.3,0.8c0.7,0,1.3-0.4,1.3-0.8 C288.9,239,288.3,238.6,287.6,238.6z"
});

var _ref119 = /*#__PURE__*/React.createElement("path", {
  className: "st83",
  d: "M360.1,225.5L360.1,225.5l0-2.1l-2.8,2.1L339,214.9c-2.6-1.5-5.9-1.5-8.5,0l-43.2,24.9 c-0.3-0.8-0.6-1.6-0.7-1.7c-0.2,0-2-0.7-2-0.7v2.1c0,1,0.5,2.1,1.5,2.7l19.5,11.2c3.1,1.8,6.8,1.8,9.9,0l42.8-24.7 C359.6,228,360.2,226.7,360.1,225.5z"
});

var _ref120 = /*#__PURE__*/React.createElement("path", {
  className: "st84",
  d: "M286.1,234.8l44.3-25.6c2.6-1.5,5.9-1.5,8.5,0l19.3,11.2c2.4,1.4,2.4,4.9,0,6.3l-42.8,24.7 c-3.1,1.8-6.8,1.8-9.9,0l-19.5-11.2C284.1,238.9,284.1,236,286.1,234.8z"
});

var _ref121 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st19",
  d: "M339.9,227.5L339.9,227.5l-12.7-7.3L309,230.7l-3-0.2v0.4l15.2,8.8l10.2-5.9c0,0,1.7,0,2.3-1.3l8.7-5.1 V227L339.9,227.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st20",
  d: "M306,230.5l15.2,8.8l10.2-5.9c0,0,1.4-0.1,2.3-1.3l8.7-5.1l-15.2-8.8L306,230.5z"
}));

var _ref122 = /*#__PURE__*/React.createElement("path", {
  className: "st21",
  d: "M332.1,231.5"
});

var _ref123 = /*#__PURE__*/React.createElement("path", {
  className: "st22",
  d: "M340.2,226.3l-0.5,0.2l0,0.1l-12.8-7.4l-8.3,4.8l13.5,7.5c0,0,0.4-0.5,1.3,0.3l8.2-4.7v-0.8H340.2z"
});

var _ref124 = /*#__PURE__*/React.createElement("path", {
  className: "st85",
  d: "M332.1,231.5c0.5-3,7.5-3.7,9.5-5.2l-15.1-8.6c-2.3,2.1-9.4,2.8-9.6,5.3L332.1,231.5z"
});

var _ref125 = /*#__PURE__*/React.createElement("path", {
  className: "st22",
  d: "M331.5,231.2l-3.1-0.3l-0.6,0.4l-11-6.4l-8.3,4.8l0.1-0.4l-1.2-0.3l-0.5,0.1v1l14.6,8.5l9.6-5.6 c0.3-1.6,0.9-1.6,0.9-1.6L331.5,231.2z"
});

var _ref126 = /*#__PURE__*/React.createElement("path", {
  className: "st86",
  d: "M332.1,231.5c-3.5-1.4-6.8,4.6-10.6,6.2l-14.6-8.5c0,0,6.5-8,9.9-6.2L332.1,231.5z"
});

var _ref127 = /*#__PURE__*/React.createElement("path", {
  className: "st25",
  d: "M339.5,223.2c0,0-0.9-0.8-1.3-0.8c-0.4,0-1.6,0.2-2.1-0.1c-0.5-0.3-0.7-0.4-0.8-0.6 c-0.2-0.3,0.1-0.8,0.9-0.5s1.1,0.2,1.1,0.2c-0.1-0.5-0.9-1.2-2-1.6c-0.5-0.2-0.6-0.8-0.3-1.1c0.5-0.6,1.4-1.1,2.2-0.9 c1.3,0.4,2.5,1.7,2.5,1.7l1.1,1.6c0,0,0,1.8,0,1.9C340.7,223.1,339.5,223.2,339.5,223.2z"
});

var _ref128 = /*#__PURE__*/React.createElement("path", {
  className: "st26",
  d: "M322.9,237.6c0,0-1.1-1-1.6-1.3c-0.5-0.3-1.8,0.2-2.4-0.5c-0.6-0.7-2-1.7-1.9-2.3c0.1-0.6,0.9-3.9,2-3.5 c1,0.3,1.4,0.7,1.8,1.1c-0.1-0.6,0.5-0.7,0.8-0.1c0.3,0.5,0.4,1.1,0.8,2c0.4,0.9,1.4,2.5,1.4,2.5L322.9,237.6z"
});

var _ref129 = /*#__PURE__*/React.createElement("path", {
  className: "st27",
  d: "M349.8,230.7c0,0-9.6-5.6-10.6-6.6c-1-1-0.3-3.6,2.3-3.2s11.2,6.6,11.2,6.6L349.8,230.7z"
});

var _ref130 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st33",
  d: "M335.7,267.4c-0.5-0.3-3-0.6-4.1-1c-1.1-0.4-2.9,0.8-1.4,2.2c1,1,3.5,3.2,5.6,4c0.9,0.3,2,0.1,2.3-0.1 c1.3-0.9,0.2-3,0.2-3L335.7,267.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st26",
  d: "M346.9,247.2c-2.3-1-4.7-2.1-5.6-2.4c-1.8-0.7-6.7-0.3-6.7,3.9c0,4.2,0.7,19.8,0.7,20.6 c0,1.6,2.9,1.8,2.9,0s1.6-12.1,1.6-13.1c0-1,0.1-3.4,0.1-3.4s2.3,1.5,5.3,3.1L346.9,247.2z"
}));

var _ref131 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M359.4,279.2c0.6,0,1-0.3,1-0.7l0-1.4l-2.1,0l0,1.4C358.3,278.9,358.8,279.2,359.4,279.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st12",
  d: "M359.4,276.5c-0.6,0-1,0.3-1,0.7c0,0.4,0.5,0.7,1.1,0.7c0.6,0,1-0.3,1-0.7 C360.4,276.8,359.9,276.5,359.4,276.5z"
}));

var _ref132 = /*#__PURE__*/React.createElement("path", {
  className: "st87",
  d: "M359.4,277.6c0.5,0,0.9-0.3,0.9-0.6l0-17.5l-1.8,0l0,17.5C358.5,277.4,358.9,277.6,359.4,277.6z"
});

var _ref133 = /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M359.4,259c-0.5,0-0.9,0.3-0.9,0.6c0,0.3,0.4,0.6,0.9,0.6c0.5,0,0.9-0.3,0.9-0.6 C360.3,259.2,359.9,259,359.4,259z"
});

var _ref134 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M346.1,271.3c0.6,0,1-0.3,1-0.7l0-1.4l-2.1,0l0,1.4C345,271,345.5,271.3,346.1,271.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st12",
  d: "M346,268.6c-0.6,0-1,0.3-1,0.7c0,0.4,0.5,0.7,1.1,0.7c0.6,0,1-0.3,1-0.7 C347.1,268.9,346.6,268.6,346,268.6z"
}));

var _ref135 = /*#__PURE__*/React.createElement("path", {
  className: "st88",
  d: "M346.1,269.8c0.5,0,0.9-0.3,0.9-0.6l0-16.6l-1.8,0l0,16.5C345.1,269.5,345.6,269.8,346.1,269.8z"
});

var _ref136 = /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M346,252.1c-0.5,0-0.9,0.3-0.9,0.6c0,0.3,0.4,0.6,0.9,0.6c0.5,0,0.9-0.3,0.9-0.6 C346.9,252.3,346.5,252.1,346,252.1z"
});

var _ref137 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M347.5,285.8c0.6,0,1-0.3,1-0.7l0-1.4l-2.1,0l0,1.4C346.5,285.5,346.9,285.8,347.5,285.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st12",
  d: "M347.5,283.1c-0.6,0-1,0.3-1,0.7c0,0.4,0.5,0.7,1.1,0.7c0.6,0,1-0.3,1-0.7 C348.6,283.4,348.1,283.1,347.5,283.1z"
}));

var _ref138 = /*#__PURE__*/React.createElement("path", {
  className: "st89",
  d: "M347.5,284.3c0.5,0,0.9-0.3,0.9-0.6l0-19.8l-1.8,0l0,19.8C346.6,284,347,284.3,347.5,284.3z"
});

var _ref139 = /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M347.5,263.3c-0.5,0-0.9,0.3-0.9,0.6c0,0.3,0.4,0.6,0.9,0.6c0.5,0,0.9-0.3,0.9-0.6 C348.4,263.6,348,263.3,347.5,263.3z"
});

var _ref140 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M334.2,278c0.6,0,1-0.3,1-0.7l0-1.4l-2.1,0l0,1.4C333.1,277.7,333.6,278,334.2,278z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st12",
  d: "M334.2,275.3c-0.6,0-1,0.3-1,0.7c0,0.4,0.5,0.7,1.1,0.7c0.6,0,1-0.3,1-0.7 C335.2,275.5,334.8,275.2,334.2,275.3z"
}));

var _ref141 = /*#__PURE__*/React.createElement("path", {
  className: "st90",
  d: "M334.2,276.4c0.5,0,0.9-0.3,0.9-0.6l0-16.6l-1.8,0l0,16.5C333.3,276.2,333.7,276.4,334.2,276.4z"
});

var _ref142 = /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M334.2,258.7c-0.5,0-0.9,0.3-0.9,0.6c0,0.3,0.4,0.6,0.9,0.6c0.5,0,0.9-0.3,0.9-0.6 C335.1,258.9,334.7,258.7,334.2,258.7z"
});

var _ref143 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st32",
  d: "M344.1,268.2l-11-6.3c-1.5-0.9-1.5-3.1,0-4l10.4-6c1.7-1,3.7-1,5.3,0l11.5,6.6c1.8,1.1,1.8,3.7,0,4.7 l-8.6,4.9C349.3,269.6,346.4,269.6,344.1,268.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st26",
  d: "M344.1,267.1l-11-6.3c-1.5-0.9-1.5-3.1,0-4l10.4-6c1.7-1,3.7-1,5.3,0l11.5,6.6c1.8,1.1,1.8,3.7,0,4.7 l-8.6,4.9C349.3,268.5,346.4,268.5,344.1,267.1z"
}));

var _ref144 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st33",
  d: "M327.6,271.3c-0.5-0.3-3-0.6-4.1-1c-1.1-0.4-2.9,0.8-1.4,2.2c1,1,3.5,3.2,5.6,4c0.9,0.3,2,0.1,2.3-0.1 c1.3-0.9,0.2-3,0.2-3L327.6,271.3z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st26",
  d: "M346.6,229.8c0,1.5,5.8,0.6,5.8-0.9c0-2.1-0.8-5.6,0-9c0.8-3.4-7,4.8-7,4.8S346.6,226,346.6,229.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st26",
  d: "M341.1,215.2c0,0,0,5.1,0,6.7c0,1.7,1.6,4,5.1,3.6c3.5-0.9,3.8-3.2,5.6-4.5c1.8-1.2,2.2-2.8,2.2-4.3 c0-1.4-2.1-5.9-6.2-5.9C343.8,210.9,341.1,213.5,341.1,215.2z"
})), /*#__PURE__*/React.createElement("path", {
  className: "st26",
  d: "M343.9,253.8c0,0-8.8-4.1-10.6-4.7c-1.8-0.7-6.7-0.3-6.7,3.9c0,4.2,0.7,19.8,0.7,20.6 c0,1.6,2.9,1.8,2.9,0c0-1.8,1.6-12.1,1.6-13.1c0-1,0.1-3.4,0.1-3.4s8.9,5.7,13.9,7c5,1.3,14-1.2,12-9.7 C355.8,245.8,343.9,253.8,343.9,253.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st35",
  d: "M357.7,254.3c0,0,2.8,7.7-7.1,9.8c-3.7,0.7-7.8-0.4-18.5-6.9c-2.1-5.4,5.1-9.8,11.1-10.3 c5.9-0.4,14,5.1,14,5.1L357.7,254.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st36",
  d: "M346.6,228.6c1.1,1,5.8,0,5.8-1.6c2.7-1,4.9,1.4,5.3,4.5c0.5,4.6-2.9,10.2,0.4,22.3 c-0.5,3.8-5.1,4.4-8.4,4.4c-3.2,0-6.5-1.9-6.4-2.9c2.5-7.8-0.9-10.7-1.6-13.5c-0.8-2.8-0.3-9.4,1.4-11 C344.6,229.1,346.6,228.6,346.6,228.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st27",
  d: "M345.4,231.4c-0.4-1.2-2.5-1.8-4.4-0.4c-2,1.4-9,6.8-10,6.6c-1-0.2-5.7-2.9-6.4-3.3 c-0.8-0.4-3.5,1.7-2.8,3.7c0.7,2,8.3,4.6,10.5,4.9c2.2,0.3,7.8-3.8,10.7-5.3C345.8,236.1,346.1,233.5,345.4,231.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st91",
  d: "M353.1,222.8c0.9-2.4,0.8-2.1,0.9-5.1c-0.1-3.8-1.5-5.7-2.4-6.2c-2.6-1.8-6.1-1.2-7.9-0.5 c-1.7,0.7-3.1,2.3-2.7,3.4c0.4,1,1.6,1.7,2.2,2.9c0.6,1.2-0.2,2.4,0.2,2.7l0.4,0.9c0,0,1.1,2.8,1.9,4.1 C348.4,225.9,350.4,228.8,353.1,222.8z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st38",
  d: "M343.1,222c0,0,0.1,0.8,0.6,0.8c0.4,0,0.7-0.6,1.5-2c0.8-1.4-0.3-2.4-1.5-1.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "st26",
  d: "M343.1,221.6c0,0,0.1,0.8,0.6,0.8c0.4,0,0.7-0.6,1.5-2c0.8-1.4-0.3-2.4-1.5-1.5"
})), /*#__PURE__*/React.createElement("path", {
  className: "st39",
  d: "M346.6,228.3c0,0-0.2,0.1-0.3,0.4c0.1,0.4,1.6,1.5,4.9,0.4c1.7-0.7,1.6-2.1,1.2-2.5c0,0,0.1,1.2-1.4,1.7 C349.5,228.8,348.4,229,346.6,228.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st35",
  d: "M352.8,222.5c0.2,0.9-0.4,1.7-1.3,1.8c-0.9,0.2-1.7-0.4-1.8-1.3c-0.2-0.9,0.4-1.7,1.3-1.8 C351.8,221,352.6,221.6,352.8,222.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st91",
  d: "M350.8,223.9c-1.5,4.6,6.2,13.2,6.8,16.4c-0.3-8.3-1.3-14.7-5.1-17.4C352,222.6,351,223,350.8,223.9z"
}));

var _ref145 = /*#__PURE__*/React.createElement("path", {
  className: "st92",
  d: "M350.2,240.1l11.4-6.6c1.2-0.7,2.7,0.2,2.7,1.6v15.6c0,1.7-0.9,3.3-2.4,4.2l-11.2,6.5 c-1.3,0.7-2.8-0.2-2.8-1.6v-15.6C347.9,242.5,348.8,241,350.2,240.1z"
});

var _ref146 = /*#__PURE__*/React.createElement("path", {
  className: "st93",
  d: "M351.3,240.7l11.4-6.6c1.2-0.7,2.7,0.2,2.7,1.6v15.6c0,1.7-0.9,3.3-2.4,4.2l-11.2,6.5 c-1.3,0.7-2.8-0.2-2.8-1.6v-15.6C349,243.1,349.8,241.6,351.3,240.7z"
});

var _ref147 = /*#__PURE__*/React.createElement("path", {
  className: "st94",
  d: "M361.8,244.5c-1-0.6-2.1-0.6-3.1,0l-1,0.6c-2.5,1.4-4,4.1-4,6.9v15.3c0,0.6-0.3,1.2-0.9,1.6 s-1.2,0.3-1.8,0l-0.2-0.1v0c-0.6,0.2-1.2,0.4-1.8,0.5l1.4,0.8c0.5,0.3,1,0.4,1.6,0.4c0.5,0,1.1-0.1,1.6-0.4 c1-0.6,1.6-1.6,1.6-2.7V252c0-2.4,1.3-4.5,3.3-5.7l1-0.6c0.5-0.3,1.2-0.3,1.7,0c0.5,0.3,0.9,0.9,0.9,1.5v15.3 c0,0.6-0.3,1.2-0.9,1.6c-0.6,0.3-1.2,0.3-1.8,0l-0.2-0.1l-1.4,0.8l0.9,0.5c1,0.6,2.2,0.6,3.2,0c1-0.6,1.6-1.6,1.6-2.7v-15.3 C363.3,246,362.8,245,361.8,244.5z"
});

var _ref148 = /*#__PURE__*/React.createElement("path", {
  className: "st95",
  d: "M192.6,210.6c-48.5-14.3-82.2-45.8-82.2-82.4v89.5c0,36.6,33.7,68.1,82.2,82.4V210.6z"
});

var _ref149 = /*#__PURE__*/React.createElement("g", {
  className: "st9"
}, /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M110.5,148.1c0-0.2,0-0.3,0-0.3c0,0.1,0,2.7,0,2.9C110.5,150.5,110.5,148.8,110.5,148.1 M110.5,141.4 c0-0.8,0-0.9-0.1-1c0,0.1,0,0.1,0,1.2c0,0.5,0,1.2,0,1.7c0-0.4,0-0.4,0-0.5c0.2,1.1,0,2.2,0,3.3v0.5l0.1,1.5 c0-0.8,0.1-1.6,0.1-2.3C110.6,144.4,110.5,142.6,110.5,141.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M111.6,150.5l-0.3-1.4l-0.4,0.2l0.1,2l0.2-0.2c0,2,0,4.7,0,6.7l0.3,1.4 C111.6,156.6,111.8,153.1,111.6,150.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M113.4,164.8c-0.4-1.5-0.5-5.9-0.2-5.9c0.5,0.5,0.8,6.1,0.3,6.2C113.6,165.1,113.5,165,113.4,164.8  M113.4,157.5c-0.2-0.6-0.3-0.8-0.5-0.8c-0.4,0.4-0.3,4.7-0.2,6.4c0.3,3,0.9,4.4,1.1,4.3C114.5,167.2,114.5,160.8,113.4,157.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M110.9,167.3c-0.1-0.9-0.1-2.5-0.1-2.7c0,0,0,0,0,0c0.1,0.2,0.3,2.7,0.2,3c0,0,0,0,0,0 C110.9,167.6,110.9,167.6,110.9,167.3 M110.9,163.7c-0.1-0.4-0.1-0.6-0.1-0.7c0,0,0,0,0,0c-0.2,0.6,0,5.8,0.3,6.2c0,0,0,0,0,0 C111.3,168.7,111.1,165.4,110.9,163.7 M110.4,158.2c0-0.9,0-2.5,0-2.7c0,0.1,0.1,2.7,0.1,3 C110.5,158.5,110.5,158.5,110.4,158.2 M110.4,154.6c0-0.5,0-0.6,0-0.7c-0.1,0.4,0,5.8,0.1,6.3 C110.6,159.9,110.5,156.6,110.4,154.6 M110.8,158.4c-0.2,3.2-0.3,3.3-0.3,5l0,1.3c0.2-3.1,0.2-3.2,0.4-4.9L110.8,158.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M112.2,165.3c-0.6,2.5-0.3,7.9,0,10.9l0,0.1c0.1,0.1,0.2,0.2,0.3,0.2c-0.5-6.3-0.3-8.4,0-9.5L112.2,165.3 "
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M113.8,170.4c-0.1-0.1-0.2-0.2-0.3-0.2c0.5,4.3,0.6,7.4,0,9.5l0.3,1.7 C114.4,179.4,114.4,176.1,113.8,170.4L113.8,170.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M110.5,174.7c-0.1-1.3-0.1-3.3-0.1-3.5c0.1,0.1,0.2,3.6,0.1,3.9C110.6,175.1,110.5,175.1,110.5,174.7  M110.5,165.7l-0.1-1.5c0,2.7,0,6.3,0,8.9c0,0.1,0,0.3,0,0.4l0,1.4v-0.8c0,1,0.1,2.7,0.2,3.3c0,0,0,0,0.1-0.1 c0.2-1.4-0.1-7.2-0.2-7.7c0,0,0,0.1,0,0.1l0,0V165.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M111.6,178c-0.1-0.7-0.2-0.9-0.3-1c-0.5,0.4,0.1,7.6,0.6,8.2c0,0,0,0,0.1,0c-0.1-0.7-0.1-1.6-0.2-2.2 c0,0,0,0,0,0c-0.3-0.2-0.4-3.5-0.3-3.8c0.1,0.1,0.2,0.9,0.3,1.6C112,180.4,112.1,180.3,111.6,178"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M113.3,189.2c-0.2-0.8-0.4-2.7-0.1-2.5c0,0,0,0,0.1,0c0.1,0.9,0.3,2,0.4,2.9 C113.5,189.7,113.4,189.7,113.3,189.2 M113.4,185.3c-0.3-2-0.2-2.1-0.1-2.1c0.2,0.1,0.5,2.1,0.2,2.1 C113.4,185.3,113.4,185.3,113.4,185.3 M113.4,182c-0.3-0.9-0.4-0.9-0.5-0.9c-0.2,0.3-0.2,1.6,0.1,3.8c-0.1-0.2-0.2-0.2-0.2-0.2 c-0.6,0.8,0.4,7.4,1.1,7.1c0,0,0.1,0,0.1-0.1l0.2,1.4l0.7,1.8l-0.6-3.5l0.5-1.1l-0.6-1.6l-0.2,0.5c-0.1-0.6-0.2-1.4-0.3-2.1 c0.6,0.5,0.4-2.1,0.2-3.3C113.8,183.5,113.6,182.7,113.4,182"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st10",
  points: "110.6,134.9 110.4,132.4 110.4,133.9 110.6,136.3 110.6,134.9  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M111.3,140.7l-0.2-3.7c0.1,0.6,0.2,1.1,0.3,1.7l0.1,1.8l0.1-0.6c0.1,0.5,0.2,1.1,0.3,1.6l-0.3,1.1l0.4,5 l-0.4-1.7l-0.2-3l-0.2,0.9l-0.3-1.7L111.3,140.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M113.8,148c0.1,0.3,0.2,0.6,0.3,0.9c-0.2,1.3-0.5,3.1-0.6,4.4l-0.3-1.2 C113.4,150.9,113.6,149.2,113.8,148"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M110.5,196.9c0-0.2,0-0.3,0-0.3c0,0.1,0,2.7,0,2.9C110.5,199.4,110.5,197.6,110.5,196.9 M110.5,190.3 c0-0.8,0-0.9-0.1-1c0,0.1,0,0.1,0,1.2c0,0.5,0,1.2,0,1.7c0-0.4,0-0.4,0-0.5c0.2,1.1,0,2.2,0,3.3v0.5l0.1,1.5 c0-0.8,0.1-1.6,0.1-2.3C110.6,193.3,110.5,191.5,110.5,190.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M111.6,199.4l-0.3-1.4l-0.4,0.2l0.1,2l0.2-0.2c0,2,0,4.7,0,6.7l0.3,1.4 C111.6,205.5,111.8,202,111.6,199.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M113.4,213.7c-0.4-1.5-0.5-5.9-0.2-5.9c0.5,0.5,0.8,6.1,0.3,6.2C113.6,213.9,113.5,213.9,113.4,213.7  M113.4,206.3c-0.2-0.6-0.3-0.8-0.5-0.8c-0.4,0.4-0.3,4.7-0.2,6.4c0.3,3,0.9,4.4,1.1,4.3C114.5,216.1,114.5,209.7,113.4,206.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M110.9,216.2c-0.1-0.9-0.1-2.5-0.1-2.7c0,0,0,0,0,0c0.1,0.2,0.3,2.7,0.2,3c0,0,0,0,0,0 C110.9,216.5,110.9,216.5,110.9,216.2 M110.9,212.6c-0.1-0.4-0.1-0.6-0.1-0.7c0,0,0,0,0,0c-0.2,0.6,0,5.8,0.3,6.2c0,0,0,0,0,0 C111.3,217.6,111.1,214.3,110.9,212.6 M110.4,207.1c0-0.9,0-2.5,0-2.7c0,0.1,0.1,2.7,0.1,3 C110.5,207.4,110.5,207.4,110.4,207.1 M110.4,203.5c0-0.5,0-0.6,0-0.7c-0.1,0.4,0,5.8,0.1,6.3 C110.6,208.8,110.5,205.5,110.4,203.5 M110.8,207.3c-0.2,3.2-0.3,3.3-0.3,5l0,1.3c0.2-3.1,0.2-3.2,0.4-4.9L110.8,207.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M112.2,214.1c-0.6,2.5-0.3,7.9,0,10.9l0,0.1c0.1,0.1,0.2,0.2,0.3,0.2c-0.5-6.3-0.3-8.4,0-9.5L112.2,214.1 "
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M113.8,219.3c-0.1-0.1-0.2-0.2-0.3-0.2c0.5,4.3,0.6,7.4,0,9.5l0.3,1.7C114.4,228.3,114.4,225,113.8,219.3 L113.8,219.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M110.5,220.3c0-0.2,0-0.2,0-0.3c0,0.1,0.1,1.4,0.1,2.6c-0.1-0.8-0.1-1.5-0.1-2.3 C110.5,220.4,110.5,220.3,110.5,220.3 M110.4,213.1c0,1.8,0,4.1,0,5.9c0,1.7,0.2,3.5,0.3,5.2l0-0.1c-0.1-3.7-0.3-5.5-0.3-5.5 c0,0,0,0,0,0v-4L110.4,213.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M111.1,226.7c0-0.9,0.1-0.9,0.1-0.9c0.1,0.1,0.2,0.3,0.3,1c0.3,1.4,0.4,2.5,0.4,2.5 c0,0.1-0.1,0.2-0.2,0.3c0-0.5-0.1-1.4-0.3-1.6c0,0,0,0,0,0c0,0.1,0,0.1,0,0.4c-0.1-0.5-0.2-1-0.3-1.5 C111.1,226.9,111.1,226.8,111.1,226.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M113.2,235.6C113.2,235.6,113.2,235.6,113.2,235.6l0.1,0.5C113.2,235.9,113.2,235.8,113.2,235.6 C113.1,235.6,113.2,235.6,113.2,235.6 M113.4,234.2c-0.3-2-0.2-2.1-0.1-2.1c0.2,0.1,0.5,2.1,0.2,2.1 C113.4,234.2,113.4,234.2,113.4,234.2 M114.2,237.6L114,238c0.2,0.5,0.4,1.1,0.6,1.6l0.2-0.4L114.2,237.6 M112.6,233.8 C112.6,233.8,112.6,233.8,112.6,233.8c0.4,1.4,0.8,2.7,1.3,4.1l-0.3-1.8c0.6,0.5,0.4-2.1,0.2-3.3c-0.2-1.1-0.5-1.9-0.6-2.2 c-0.2-0.4-0.2-0.5-0.3-0.6c-0.2,0.1-0.4,0.7,0,3.8c-0.1-0.2-0.1-0.2-0.2-0.2C112.7,233.6,112.6,233.7,112.6,233.8"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st10",
  points: "110.6,183.7 110.4,181.3 110.4,182.8 110.6,185.2 110.6,183.7  "
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st10",
  points: "112,190.2 111.6,188.6 111.4,189.4 111.3,187 111,185.2 111.3,189.6 111,191 111.2,192.7  111.4,191.8 111.6,194.8 112,196.5 111.6,191.5 112,190.2  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M113.9,195.6c-0.2,1.6-0.5,3.8-0.8,5.4l0.3,1.2c0.2-1.6,0.5-3.8,0.8-5.4L113.9,195.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M115.4,153.2l0.9,1.9v-1.1c0.2,0.4,0.4,0.8,0.5,1.1v1.1l1,1.9v1.6l-1-1.9v2.6l-0.5-1.1v-2.6l-0.9-1.9 V153.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M116,170.8c-0.2-0.3-0.3-0.4-0.3-0.1c-0.2,0.7,0.3,2.9,0.6,2.7C116.5,173.1,116.4,171.5,116,170.8  M116.3,164.9l-0.6-1.4c0,1.8,0,4.1,0,5.9l0.6,1.4C116.3,169,116.7,166.6,116.3,164.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M119.4,177.2c-0.3-0.4-0.4-0.2-0.4-0.1c-0.2,0.8,0.4,2.8,0.8,2.6C120,179.5,119.8,177.9,119.4,177.2  M119.4,170.5c-0.3-0.4-0.9-1.5-1.2-0.3c0,0.2-0.1,0.5-0.1,0.7c0.2,0.4,0.5,1.1,0.8,1.5c0-0.5,0.1-0.7,0.3-0.5 c0.1,0.1,1.1,1.9,0.1,2.3c-0.4,0.2-0.4,0.2-0.4,0.9v0.5l0.8,1.3c0-0.7,0-0.8,0.3-0.9c0.4-0.1,0.6-0.4,0.6-1.6 C120.5,173,119.9,171.4,119.4,170.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M124.6,178.5l-0.9-1.2l-1.4,0.4l0.5,1.9l0.9-0.3c0,2,0,4.7,0,6.7l0.9,1.2 C124.6,184.7,125.5,181,124.6,178.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M129.8,191.9c-1.2-1.5-1-5.8-0.4-5.9c0.2,0,0.8,0.5,1.1,2.1c0.2,1.1,0.2,3.5-0.2,3.9 C130.3,192.1,130.1,192.2,129.8,191.9 M129.8,184.5c-0.5-0.5-1.9-1.9-1.9,2.4c0,5.4,2.5,8.1,3.4,7.1 C132.1,192.9,132.1,187.1,129.8,184.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M116,182.7l0.1-1.4l0.4,0.9l-0.1,1.4L116,182.7 M117.1,179.9l-0.4-0.9l-0.1,2.2l-0.4-0.9l0.1-2.2 l-0.4-0.9l-0.1,2.2l-0.4-0.9v1.1l0.3,0.8l-0.1,1.4l-0.4-0.9v1.1l0.3,0.8l-0.1,2.2l0.4,0.9l0.1-2.2l0.4,0.9l-0.1,2.2l0.4,0.9 l0.1-2.2l0.4,0.9v-1.1l-0.4-0.8l0.1-1.4l0.4,0.9v-1.1l-0.4-0.8L117.1,179.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M122,195.9c-0.6-1-0.7-2.8-0.3-2.6c0.6,0.2,1.1,2.6,0.7,2.9C122.3,196.2,122.1,196,122,195.9 M122,192.3 c-0.8-1.1-1-0.3-1.1,0.1c-0.4,2,1,5.9,1.9,5.3C123.6,197.2,123.1,193.8,122,192.3 M119.3,187.4c-0.6-1-0.6-2.8-0.2-2.6 c0.5,0.2,1,2.8,0.5,2.9C119.5,187.6,119.4,187.6,119.3,187.4 M119.3,183.7c-0.6-0.9-0.8-0.6-0.9-0.1c-0.4,1.8,0.8,6.1,1.6,5.5 C120.7,188.7,120.2,185.3,119.3,183.7 M121.5,187.1c-1.4,3.4-1.5,3.6-2.2,5.5l0.4,1.2c1.4-3.4,1.4-3.5,2.3-5.4L121.5,187.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M126.6,192.9c-0.5,0.8-2,3.2,0,10.9l0,0.1c0.2,0,0.5,0.1,0.7,0.1c-1.2-4.8-1.2-7.5,0-9.5L126.6,192.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M130.5,197.4c-0.2,0-0.5-0.1-0.8-0.1c1.3,4.8,1.3,7.5,0,9.5l0.8,1.6C131.5,207,132.5,204.3,130.5,197.4 L130.5,197.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M116.1,196.7c-0.3-0.8-0.4-1.7-0.2-1.6c0.1,0,0.4,0.6,0.5,0.8l0.2,0.3c0,0.6,0,1.1-0.3,0.8 C116.2,197,116.2,196.9,116.1,196.7 M116.2,191.9c-0.5-1.1-0.7-1-0.9-1c0.1,0.5,0.2,1.2,0.3,1.8c0.4-0.3,0.9,1.2,0.9,2.4 c-0.6-1.2-1.1-2.3-1.3-1.7c-0.4,1.1,0.6,5.2,1.2,4.9c0,0,0.1-0.1,0.1-0.1l0,0v0.8l0.6,1.3C117.1,195,117.1,194,116.2,191.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M119.9,203.7c-0.8-1.4-0.8-3.5-0.4-3.4c0.7,0.1,1.4,3.4,0.9,3.8C120.3,204.1,120.1,203.9,119.9,203.7  M119.4,194.8l-0.8-1.3c0,2.7,0,6.3,0,8.9c0,0.1,0,0.3,0,0.4l0.7,1.2v-0.8c0.9,3.8,1.8,2.8,1.8,2.8c1.1-1.4-0.7-7.4-1.6-7.4 c-0.1,0-0.1,0.1-0.2,0.1l0,0V194.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M124.7,206c-1.2-1.5-1.6-0.5-1.7,0.2c-0.3,2.9,1.7,7.3,2.8,6.7c-0.2-0.6-0.5-1.5-0.7-2.1 c-0.5,0.4-1.4-1.6-1.2-3c0.1-0.6,0.3-0.7,0.7-0.3c0.3,0.3,0.5,0.8,0.6,1.2c0.2-0.1,0.5-0.3,0.7-0.5 C125.5,207.1,125,206.3,124.7,206"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M129.4,216.4c-0.5-0.6-0.7-1.5-0.7-1.7c0-0.8,0.2-0.7,0.6-0.7c0.3,0.8,0.6,1.9,0.9,2.7 C130,216.7,129.8,216.8,129.4,216.4 M129.6,212.4c-0.9-2.3-0.2-2-0.1-2c0.5,0.2,1.1,1.7,0.5,2 C129.8,212.4,129.7,212.4,129.6,212.4 M129.7,209.1c-1.3-1.4-1.6-0.5-1.6,0.4c0,0.9,0.3,1.8,0.6,2.6c-1.3-0.6-1.3,1.7-0.6,3.5 c0.5,1.3,1.8,3.6,2.9,3l0.4,1.3l1.5,1.5l-1.2-3.3l1.2-1.3l-1.4-1.4l-0.5,0.6c-0.2-0.6-0.5-1.3-0.7-1.9c1.5,0.2,1.2-2.6-0.1-4.5 C130,209.5,129.8,209.3,129.7,209.1"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st10",
  points: "120.5,163.7 119.2,161.6 119.2,163.1 120.5,165.2 120.5,163.7  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M123.7,169l-0.8-3.6c0.4,0.5,0.7,1,1.1,1.5l0.4,1.8l0.4-0.7c0.4,0.5,0.7,0.9,1.1,1.4l-0.9,1.2l1.2,4.8 l-1.2-1.5l-0.7-2.9l-0.7,1l-1.1-1.5L123.7,169"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M130.6,174.9c0.3,0.3,0.5,0.5,0.8,0.8c-0.4,1.4-1,3.3-1.5,4.7l-0.7-1.1 C129.6,178,130.2,176.3,130.6,174.9"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st10",
  points: "116.8,202.5 116.2,201.4 116.2,204 115.4,202.1 115.4,203.6 116.2,205.6 116.2,208.2  116.8,209.3 116.8,206.7 117.7,208.6 117.7,207.1 116.8,205.2 116.8,202.5  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M116,219.7c-0.2-0.3-0.3-0.4-0.3-0.1c-0.2,0.7,0.3,2.9,0.6,2.7C116.5,222,116.4,220.4,116,219.7  M116.3,213.8l-0.6-1.4c0,1.8,0,4.1,0,5.9l0.6,1.4C116.3,217.9,116.7,215.5,116.3,213.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M119.4,226.1c-0.3-0.4-0.4-0.2-0.4-0.1c-0.2,0.8,0.4,2.8,0.8,2.6C120,228.4,119.8,226.8,119.4,226.1  M119.4,219.4c-0.3-0.4-0.9-1.5-1.2-0.3c0,0.2-0.1,0.5-0.1,0.7c0.2,0.4,0.5,1,0.8,1.5c0-0.5,0.1-0.7,0.3-0.5 c0.1,0.1,1.1,1.9,0.1,2.3c-0.4,0.2-0.4,0.2-0.4,0.9v0.5l0.8,1.3c0-0.7,0-0.8,0.3-0.9c0.4-0.1,0.6-0.4,0.6-1.6 C120.5,221.9,119.9,220.3,119.4,219.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M124.6,227.4l-0.9-1.2l-1.4,0.4l0.5,1.9l0.9-0.3c0,2,0,4.7,0,6.7l0.9,1.2 C124.6,233.5,125.5,229.9,124.6,227.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M129.8,240.8c-1.2-1.5-1-5.8-0.4-5.9c0.2,0,0.8,0.5,1.1,2.1c0.2,1.1,0.2,3.5-0.2,3.9 C130.3,241,130.1,241.1,129.8,240.8 M129.8,233.4c-0.5-0.5-1.9-1.9-1.9,2.4c0,5.5,2.5,8.1,3.4,7.1 C132.1,241.8,132.1,236,129.8,233.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M116,231.6l0.1-1.4l0.4,0.9l-0.1,1.4L116,231.6 M117.1,228.8l-0.4-0.9l-0.1,2.2l-0.4-0.9l0.1-2.2 l-0.4-0.9l-0.1,2.2l-0.4-0.9v1.1l0.3,0.8l-0.1,1.4l-0.4-0.9v1.1l0.3,0.8l-0.1,2.2l0.4,0.9l0.1-2.2l0.4,0.9l-0.1,2.2l0.4,0.9 l0.1-2.2l0.4,0.9v-1.1l-0.4-0.8l0.1-1.4l0.4,0.9v-1.1L117,231L117.1,228.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M122,244.8c-0.6-1-0.7-2.8-0.3-2.6c0.6,0.2,1.1,2.6,0.7,2.9C122.3,245.1,122.1,244.9,122,244.8  M122,241.1c-0.8-1.1-1-0.3-1.1,0.1c-0.4,2,1,5.9,1.9,5.3C123.6,246.1,123.1,242.7,122,241.1 M119.3,236.2 c-0.6-1-0.6-2.8-0.2-2.6c0.5,0.2,1,2.8,0.5,2.9C119.5,236.5,119.4,236.5,119.3,236.2 M119.3,232.6c-0.6-0.9-0.8-0.6-0.9-0.1 c-0.4,1.8,0.8,6.1,1.6,5.5C120.7,237.6,120.2,234.2,119.3,232.6 M121.5,236c-1.4,3.4-1.5,3.6-2.2,5.5l0.4,1.2 c1.4-3.4,1.4-3.5,2.3-5.4L121.5,236"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M126.6,241.8c-0.5,0.8-2,3.2,0,10.9l0,0.1c0.2,0,0.5,0.1,0.7,0.1c-1.2-4.7-1.2-7.6,0-9.5L126.6,241.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M130.5,246.3c-0.2,0-0.5-0.1-0.8-0.1c1.3,4.8,1.3,7.5,0,9.5l0.8,1.6C131.5,255.8,132.5,253.2,130.5,246.3 L130.5,246.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M115.4,239.8C115.4,239.8,115.3,239.8,115.4,239.8c0,0.6,0.1,1.3,0.2,1.8c0.3-0.3,0.9,1,0.9,2.4 c-0.4-0.8-0.7-1.4-0.9-1.7c0.5,1.1,1,2.2,1.5,3.3l0-0.3c-0.1-1.7-0.3-3-1.1-4.7C115.9,240.3,115.6,239.8,115.4,239.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M119.4,249.4c0.1-0.4,0.3-0.4,0.5,0c0.2,0.3,0.6,1,0.7,2.2c-0.4-0.7-0.8-1.4-1.2-2 C119.3,249.5,119.4,249.4,119.4,249.4 M118.6,242.4c0,1.8,0,4.1,0,5.9c0.9,1.6,1.8,3.1,2.8,4.6l0-0.1c-0.4-3.8-1.6-5.5-2-5.1 c0,0,0,0,0,0v-4L118.6,242.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M123.1,255.1c0.1-0.7,0.4-1.7,1.7-0.2c0.5,0.7,0.8,1.3,1.1,2.3c-0.2,0.1-0.5,0.3-0.7,0.5 c-0.3-1.1-0.9-1.7-1.1-1.3c0,0.1-0.1,0.2-0.1,0.3c-0.3-0.4-0.6-0.9-0.9-1.3C123.1,255.2,123.1,255.2,123.1,255.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M129.1,262.8c0.1,0,0.1,0,0.2,0l0.1,0.4C129.3,263.1,129.2,262.9,129.1,262.8 C129.1,262.8,129.1,262.8,129.1,262.8 M129.6,261.3c-0.9-2.3-0.2-2-0.1-2c0.4,0.2,1.1,1.7,0.5,2 C129.8,261.3,129.7,261.3,129.6,261.3 M131.4,264.3l-0.5,0.5c0.4,0.5,0.9,0.9,1.3,1.4l0.5-0.5L131.4,264.3 M127.8,261.2 C127.7,261.2,127.7,261.3,127.8,261.2c1,1.2,2,2.4,3.1,3.5l-0.6-1.7c1.6,0.2,1-3-0.3-4.7c-0.2-0.2-0.4-0.5-0.6-0.7 c-1.3-1-1.4,0.2-1.2,1.4c0.1,0.6,0.3,1.2,0.5,2C128.4,260.9,128,260.7,127.8,261.2"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st10",
  points: "120.5,212.6 119.2,210.4 119.2,211.9 120.5,214.1 120.5,212.6  "
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st10",
  points: "125.9,218 124.8,216.6 124.3,217.6 123.8,215.2 122.7,213.7 123.7,217.9 122.5,219.4  123.6,220.9 124.3,219.9 124.9,222.8 126.1,224.3 124.9,219.5 125.9,218  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M131,222.5c-0.5,1.7-1.2,4-1.8,5.7l0.7,1.1c0.5-1.7,1.3-4,1.8-5.8L131,222.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M134,179.5l1.7,1.6v-1.1c0.3,0.3,0.7,0.6,1.1,1v1.1l1.8,1.6v1.6l-1.8-1.6v2.6l-1.1-1v-2.6l-1.7-1.6V179.5 "
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M135.4,196.8c-0.6-0.5-0.8,0.1-0.8,0.6c0.1,1.1,1,2.3,1.4,1.8C136.3,198.8,136,197.4,135.4,196.8  M136,190.9l-1.2-1.2c0,1.8,0,4.1,0,5.9l1.2,1.2C136,195,136,192.6,136,190.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M141.5,202.1c-0.6-0.5-0.9,0-0.8,0.7c0.1,1.1,1.1,2.1,1.5,1.6C142.6,204,142.2,202.7,141.5,202.1  M141.6,195.5c-1.8-1.3-2.1-0.2-2.2,0.9c0.4,0.4,1,0.9,1.4,1.3c0.1-1.2,1.1-0.2,1.1-0.2c0.3,0.4,1,1.4-0.2,1.9 c-0.7,0.3-0.8,0.3-0.8,1.1v0.5l1.4,1.1c0-0.6,0-0.8,0.4-0.9c0.6-0.2,1.3-0.4,1.1-1.8C143.6,197.5,142.5,196.2,141.6,195.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M150.3,201.9l-1.4-0.9l-2.3,0.8l0.8,1.8l1.4-0.6c0,2,0,4.7,0,6.7l1.4,1 C150.3,208.1,150.3,204.6,150.3,201.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M158.1,213.9c-1.7-1.2-1.4-5.6-0.5-5.8c0,0,1.1-0.1,1.6,1.8c0.2,0.9,0.3,3.2-0.2,3.8 C158.8,214.1,158.5,214.1,158.1,213.9 M158.1,206.6c-4.2-2.1-2.4,5.8-2.4,5.8c0.9,3,3.9,4.7,4.9,2.8 C161.2,213.8,161.5,208.5,158.1,206.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M135.3,208.8l0.1-1.4l0.8,0.8l-0.1,1.4L135.3,208.8 M137.5,205.6l-0.8-0.7l-0.2,2.3l-0.8-0.8l0.2-2.3 l-0.8-0.7l-0.2,2.3l-0.8-0.7v1.1l0.7,0.7l-0.1,1.4l-0.8-0.7v1.1l0.7,0.7l-0.2,2.3l0.8,0.7l0.2-2.3l0.8,0.8l-0.2,2.3l0.8,0.7 l0.2-2.3l0.8,0.7v-1.1l-0.7-0.6l0.1-1.4l0.8,0.7v-1.1l-0.7-0.6L137.5,205.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M146.1,220.1c-1-0.8-1.2-2.4-0.5-2.6c0.8-0.1,1.8,1.9,1.3,2.6C146.7,220.3,146.4,220.3,146.1,220.1  M146.1,216.4c-1.5-1-2.1,0.2-1.8,1.9c0.5,2.4,2.7,4.3,3.5,3C148.5,220.1,147.6,217.5,146.1,216.4 M141.4,212.3 c-0.9-0.8-1.1-2.5-0.5-2.6c0.8-0.1,1.7,1.9,1.2,2.6C141.9,212.6,141.7,212.6,141.4,212.3 M141.4,208.7c-1.3-1-1.9,0-1.7,1.5 c0.3,2.4,2.3,4.6,3.2,3.5C143.7,212.7,142.8,209.9,141.4,208.7 M145.2,211.4c-2.5,4-2.5,4-3.8,6.1l0.7,1.1 c2.3-3.7,2.5-3.9,3.9-6L145.2,211.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M153.3,215.8c-0.7,0.9-3,3.7,0,10.9l0,0.1c0.3,0,0.8-0.1,1.1-0.1c-1.8-4.5-1.8-7.2,0-9.5L153.3,215.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M159.1,219.2c-0.3,0-0.8,0.1-1.1,0.1c1.9,4.5,1.9,7.2,0,9.5l1.1,1.4C160.5,228.6,162,225.6,159.1,219.2 L159.1,219.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M135.4,222.7c-0.7-0.6-0.7-1.5-0.4-1.6c0.3,0,0.8,0.5,1,0.6l0.3,0.3c0,0.6,0,0.8-0.2,0.9 C135.9,223.2,135.6,222.9,135.4,222.7 M135.7,217.9c-1-0.9-1.5-0.8-1.7-0.7c0.2,0.5,0.5,1.1,0.6,1.6c0.7-0.5,1.8,0.8,1.8,2 c-1.1-1-2.8-2.6-2.7-0.2c0.1,2,1.9,4,2.6,3.3c0,0,0,0,0.1-0.1l0,0v0.8l1.2,1C137.5,220.6,137.5,219.7,135.7,217.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M142.6,228.4c-1.3-1.1-1.3-3.2-0.7-3.3c1.1-0.1,2.3,2.4,1.6,3.4C143.4,228.7,143.1,228.9,142.6,228.4  M141.6,219.8l-1.4-1.1c0,2.7,0,6.3,0,8.9c0,0.1,0,0.3,0,0.4l1.2,1v-0.8c1.4,3.1,3.1,2.9,3.5,1.7c0.9-2.5-1.9-7.1-3.2-6.3 c0,0-0.1,0.1-0.1,0.1l0,0V219.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M150.4,229.4c-2.7-1.6-2.9,0.9-2.6,2.4c0.6,2.8,3.1,4.9,4.3,4.2c-0.3-0.6-0.7-1.4-1-1.9 c-0.8,0.6-2.1-1.3-1.9-2.7c0.2-1.1,1.2-0.6,1.7,0.1c0.2,0.2,0.2,0.4,0.3,0.5c0.3-0.2,0.7-0.4,1-0.6 C151.6,230.2,150.8,229.6,150.4,229.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M157.5,238.5c-0.9-0.6-1.5-2.1-0.5-2.4c0.1,0,0.2,0,0.3,0c0.4,0.7,0.9,1.7,1.4,2.5 C158.4,238.7,158,238.8,157.5,238.5 M157.8,234.5c-1.4-2.2-0.1-2-0.1-2c0.7,0.2,1.4,1.4,0.7,1.8 C158.1,234.4,157.9,234.5,157.8,234.5 M157.9,231.2c-2.7-1.4-2.5,0.9-2.2,1.8c0.2,0.5,0.4,1.1,0.7,1.5c-2-0.3-2,2.3-0.6,4.2 c0,0,2.1,2.7,3.9,1.7l0.6,1.2l2.2,1.1l-1.8-3l1.7-1.6l-1.9-1l-0.8,0.7c-0.3-0.5-0.7-1.2-1-1.8c2.1-0.1,1.8-2.7,0-4.3 C158.5,231.5,158.2,231.3,157.9,231.2"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st10",
  points: "143.5,188.3 141.3,186.6 141.3,188 143.5,189.8 143.5,188.3  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M148.7,192.7l-1.4-3.3c0.6,0.4,1.1,0.8,1.7,1.2l0.6,1.6l0.6-0.8c0.6,0.4,1.1,0.7,1.7,1.1l-1.4,1.5 l1.9,4.4l-1.8-1.2l-1.1-2.7l-1.1,1.2l-1.7-1.2L148.7,192.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M159.2,196.8c0.4,0.2,0.7,0.4,1.1,0.6c-0.6,1.5-1.5,3.5-2.1,5.1l-1-0.9 C157.8,200.1,158.6,198.2,159.2,196.8"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st10",
  points: "136.8,228.3 135.8,227.4 135.8,230 134,228.4 134,229.9 135.8,231.6 135.8,234.2 136.8,235.1  136.8,232.5 138.6,234.1 138.6,232.5 136.8,231 136.8,228.3  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M135.4,245.7c-0.6-0.5-0.8,0.1-0.8,0.6c0.1,1.1,1,2.3,1.4,1.8C136.3,247.6,136,246.3,135.4,245.7  M136,239.7l-1.2-1.1c0,1.8,0,4.1,0,5.9l1.2,1.2C136,243.8,136,241.5,136,239.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M141.5,251c-0.7-0.5-0.9,0.1-0.8,0.7c0.1,1.1,1.1,2.1,1.5,1.6C142.6,252.9,142.2,251.6,141.5,251  M141.6,244.3c-1.8-1.3-2.1-0.2-2.2,0.9c0.4,0.4,1,0.9,1.4,1.3c0.1-1.2,1.1-0.2,1.1-0.2c0.3,0.4,1,1.4-0.2,1.9 c-0.7,0.3-0.8,0.3-0.8,1.1v0.5l1.4,1.1c0-0.6,0-0.8,0.4-0.9c0.6-0.2,1.3-0.4,1.1-1.8C143.6,246.4,142.5,245.1,141.6,244.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M150.3,250.8l-1.4-0.9l-2.3,0.8l0.8,1.8l1.4-0.6c0,2,0,4.7,0,6.7l1.4,1 C150.3,256.9,150.3,253.4,150.3,250.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M158.1,262.8c-1.7-1.2-1.4-5.6-0.5-5.8c0,0,1.1-0.1,1.6,1.8c0.2,0.9,0.3,3.2-0.2,3.8 C158.8,263,158.5,263,158.1,262.8 M158.1,255.4c-4.2-2.1-2.4,5.8-2.4,5.8c0.9,3,3.9,4.7,4.9,2.8 C161.2,262.6,161.5,257.4,158.1,255.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M135.3,257.7l0.1-1.4l0.8,0.8l-0.1,1.4L135.3,257.7 M137.5,254.4l-0.8-0.7l-0.2,2.3l-0.8-0.8l0.2-2.3 l-0.8-0.7l-0.2,2.3l-0.8-0.7v1.1l0.7,0.7l-0.1,1.4l-0.8-0.7v1.1l0.7,0.7l-0.2,2.3l0.8,0.7l0.2-2.3l0.8,0.8l-0.2,2.3l0.8,0.7 l0.2-2.3l0.8,0.7v-1.1l-0.7-0.6l0.1-1.4l0.8,0.7v-1.1l-0.7-0.6L137.5,254.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M146.1,268.9c-1-0.8-1.2-2.4-0.5-2.6c0.8-0.1,1.8,1.9,1.3,2.6C146.7,269.2,146.4,269.2,146.1,268.9  M146.1,265.3c-1.5-1-2.1,0.2-1.8,1.9c0.5,2.4,2.7,4.3,3.5,3C148.5,269,147.6,266.3,146.1,265.3 M141.4,261.2 c-0.9-0.8-1.1-2.5-0.5-2.6c0.8-0.1,1.7,1.9,1.2,2.6C141.9,261.5,141.7,261.4,141.4,261.2 M141.4,257.6c-1.3-1-1.9,0-1.7,1.5 c0.3,2.4,2.3,4.6,3.2,3.5C143.7,261.6,142.8,258.7,141.4,257.6 M145.2,260.3c-2.5,4-2.5,4-3.8,6.1l0.7,1.1 c2.3-3.7,2.5-3.9,3.9-6L145.2,260.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M153.3,264.7c-0.7,0.9-3,3.7,0,10.9l0,0.1c0.3,0,0.8-0.1,1.1-0.1c-1.8-4.5-1.8-7.2,0-9.5L153.3,264.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M159.1,268.1c-0.3,0-0.8,0.1-1.1,0.1c1.9,4.5,1.9,7.1,0,9.5l1.1,1.4C160.5,277.4,162,274.5,159.1,268.1 L159.1,268.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M134.1,266.1c-0.1,0-0.1,0-0.2,0.1c0.2,0.5,0.5,1.1,0.6,1.6c0.7-0.4,1.7,0.7,1.8,2 c-0.6-0.6-1.3-1.2-1.8-1.4c1,0.9,2,1.8,3,2.7l0-0.3c-0.1-1.7-0.5-2.9-2.1-4.3C135.1,266.4,134.6,266,134.1,266.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M141.5,274.4c0.3-0.9,1.4,0,1.8,1c0.2,0.3,0.2,0.6,0.3,0.8c-0.7-0.5-1.4-1.1-2.1-1.7 C141.5,274.4,141.5,274.4,141.5,274.4 M140.2,267.6c0,1.8,0,4.1,0,5.9c1.6,1.3,3.2,2.5,4.8,3.8l0-0.1c-0.6-3.9-2.8-4.9-3.5-4.4 c0,0,0,0,0,0v-4L140.2,267.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M147.8,278.9c0.1-0.8,0.7-1.9,2.6-0.7c0.8,0.5,1.3,1.1,1.8,1.9c-0.3,0.2-0.7,0.4-1,0.6 c-0.5-1.1-1.6-1.6-1.9-0.8c0,0,0,0.1,0,0.1c-0.5-0.3-1-0.7-1.5-1C147.8,279.1,147.8,279,147.8,278.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M157.1,285c0.1,0,0.2,0,0.3,0l0.2,0.4C157.4,285.2,157.2,285.1,157.1,285C157,285,157,285,157.1,285  M157.8,283.4c-1.4-2.2-0.1-2-0.1-2c0.7,0.2,1.4,1.4,0.7,1.8C158.1,283.3,157.9,283.4,157.8,283.4 M160.5,285.9l-0.7,0.7 c0.6,0.3,1.3,0.7,1.9,1l0.7-0.7L160.5,285.9 M155,283.8C155,283.8,155,283.8,155,283.8c1.5,1,3,1.8,4.6,2.7l-0.9-1.6 c2.2-0.2,1.6-2.9,0-4.3c-0.5-0.4-1-0.7-1.3-0.8c-2.8-1-1.8,2.2-1.4,2.9c0.1,0.2,0.2,0.5,0.3,0.6 C156,283.3,155.4,283.2,155,283.8"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st10",
  points: "143.5,237.2 141.3,235.4 141.3,236.9 143.5,238.7 143.5,237.2  "
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st10",
  points: "152.3,241.1 150.5,240 149.7,241.1 148.9,238.8 147.1,237.6 148.7,241.5 146.8,243.4  148.5,244.6 149.7,243.4 150.7,246.1 152.6,247.3 150.6,242.8 152.3,241.1  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M159.8,244.2c-0.8,1.9-1.8,4.3-2.6,6.2l1,0.9c0.8-1.9,1.8-4.3,2.6-6.2L159.8,244.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M164.2,200.5l2.4,1.2v-1.1c0.5,0.2,1,0.5,1.5,0.7v1.1l2.5,1.1v1.6l-2.5-1.1v2.6l-1.5-0.7v-2.6l-2.4-1.2 V200.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M166,217.5c-0.9-0.4-1.2,0.4-0.9,1.2c0.4,1,1.6,1.5,1.9,0.8C167.3,218.9,166.8,217.8,166,217.5  M166.9,211.3l-1.7-0.8c0,1.8,0,4.1,0,5.9l1.7,0.8C166.9,215.4,166.9,213.1,166.9,211.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M174.5,221.3c-1-0.4-1.3,0.5-1,1.3c0.5,1.1,1.8,1.5,2.1,0.7C175.7,222.6,175.2,221.6,174.5,221.3  M174.6,214.6c-2.4-0.9-2.9,0.4-3,1.4c0.6,0.3,1.3,0.6,1.9,0.9c0.1-1.2,1.4-0.7,1.8-0.1c0.7,0.9-0.1,1.3-0.7,1.6 c-0.9,0.4-1,0.5-1,1.3v0.5l1.8,0.8c0-0.6,0-0.8,0.5-1c0.8-0.3,1.7-0.7,1.5-2.1C177.2,216.2,175.8,215.1,174.6,214.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M185.9,219.1l-1.8-0.6l-2.9,1.4l1.1,1.6l1.8-0.9c0,2,0,4.7,0,6.7l1.9,0.6 C185.9,225.2,185.9,221.7,185.9,219.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M166,229.4l0.2-1.5l1.1,0.6l-0.2,1.5L166,229.4 M168.9,225.7l-1.1-0.5l-0.3,2.3l-1.1-0.6l0.3-2.3 l-1.1-0.5l-0.3,2.3l-1.1-0.6v1.1l1,0.5l-0.2,1.5l-1.1-0.6v1.1l1,0.5l-0.3,2.3l1.1,0.6l0.3-2.3l1.1,0.6l-0.3,2.3l1.1,0.5 l0.3-2.3l1.1,0.5V231l-1-0.5l0.2-1.5l1.1,0.5v-1.1l-1-0.5L168.9,225.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M180.5,238.1c-1.2-0.5-1.6-2-0.8-2.4c0.9-0.4,2.3,1,1.9,2C181.5,238.2,181,238.3,180.5,238.1  M180.5,234.5c-2.4-0.8-2.9,1.4-2,3c1.2,2.2,3.8,2.8,4.4,1C183.4,237.2,182.2,235.1,180.5,234.5 M174.3,231.5 c-1.2-0.6-1.5-2.1-0.7-2.4c0.9-0.4,2.2,1,1.8,2C175.2,231.6,174.8,231.7,174.3,231.5 M174.3,227.9c-2.2-0.8-2.8,1.1-2.1,2.7 c1,2.4,3.8,3.2,4.4,1.4C177,230.6,175.9,228.6,174.3,227.9 M179.4,229.7c-3,4.2-3.3,4.6-5,7l0.9,0.9c3.3-4.4,3.3-4.4,5.1-7 L179.4,229.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M189.8,232.2c-0.9,1.1-3.8,4.4,0,10.9l0,0.1c0.4-0.1,1-0.2,1.4-0.3c-2.3-4.1-2.3-6.8,0-9.5L189.8,232.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M166.1,243.4c-0.9-0.5-1-1.4-0.5-1.5c0.4-0.1,1.1,0.3,1.4,0.4l0.4,0.2c0,0.6,0,0.8-0.2,1 C166.8,243.7,166.4,243.5,166.1,243.4 M166.4,238.5c-1.3-0.6-2-0.4-2.5-0.3c0.3,0.4,0.6,1,0.9,1.5c1-0.7,2.5,0.4,2.5,1.6 c-1.3-0.6-2.4-1.1-3.2-0.9c-0.6,0.2-0.7,1.2-0.4,2c0.6,1.5,2.7,2.9,3.6,1.9l0,0v0.8l1.6,0.8C169,240.7,169,239.7,166.4,238.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M175.8,247.3c-1.8-0.8-1.7-2.8-1-3.1c1.1-0.5,3,1.4,2.4,2.8C177,247.5,176.5,247.6,175.8,247.3  M174.5,238.9l-1.8-0.8c0,2.7,0,6.3,0,8.9c0,0.1,0,0.3,0,0.4l1.7,0.7v-0.8c2,2.9,4.4,2.3,4.8,0.4c0.6-3.2-3-6.1-4.5-5 c0,0-0.1,0-0.1,0.1l0,0V238.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M186.1,246.5c-3.7-1.1-4.1,2-2.9,4c1.1,1.9,3.7,3.1,5.1,2.2c-0.4-0.5-0.9-1.2-1.3-1.7 c-1,0.8-2.7-0.8-2.5-2.2c0.2-1.2,1.8-0.9,2.4,0c0,0,0,0,0,0.1c0.4-0.3,0.9-0.6,1.3-0.9C187.5,247.1,186.6,246.6,186.1,246.5"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st10",
  points: "177.1,207 174.1,205.8 174.1,207.3 177.1,208.5 177.1,207  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M183.9,210.1l-1.8-3c0.7,0.3,1.5,0.5,2.2,0.8l0.8,1.5l0.8-0.9c0.7,0.2,1.4,0.5,2.1,0.7l-1.7,1.8l2.4,4 l-2.3-0.8l-1.4-2.5l-1.5,1.5l-2.2-0.8L183.9,210.1"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st10",
  points: "168,248.6 166.6,247.9 166.6,250.5 164.2,249.3 164.2,250.9 166.6,252.1 166.6,254.7 168,255.4  168,252.8 170.5,253.9 170.5,252.4 168,251.2 168,248.6  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M166,266.3c-0.9-0.4-1.2,0.4-0.9,1.2c0.4,1,1.6,1.5,1.9,0.8C167.3,267.8,166.8,266.7,166,266.3  M166.9,260.2l-1.7-0.8c0,1.8,0,4.1,0,5.9l1.7,0.8C166.9,264.3,166.9,262,166.9,260.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M174.5,270.2c-1-0.4-1.3,0.5-1,1.3c0.5,1.1,1.8,1.5,2.1,0.7C175.7,271.5,175.2,270.5,174.5,270.2  M174.6,263.5c-2.4-0.9-2.9,0.4-3,1.4c0.6,0.3,1.3,0.6,1.9,0.9c0.1-1.2,1.4-0.7,1.8-0.1c0.7,0.9-0.1,1.3-0.7,1.6 c-0.9,0.4-1,0.5-1,1.3v0.5l1.8,0.8c0-0.6,0-0.8,0.5-1c0.8-0.3,1.7-0.7,1.5-2.1C177.2,265.1,175.8,264,174.6,263.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M185.9,267.9l-1.8-0.6l-2.9,1.4l1.1,1.6l1.8-0.9c0,2,0,4.7,0,6.7l1.9,0.6 C185.9,274.1,185.9,270.6,185.9,267.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M166,278.3l0.2-1.5l1.1,0.6l-0.2,1.5L166,278.3 M168.9,274.5l-1.1-0.5l-0.3,2.3l-1.1-0.6l0.3-2.3 l-1.1-0.5l-0.3,2.3l-1.1-0.6v1.1l1,0.5l-0.2,1.5l-1.1-0.6v1.1l1,0.5l-0.3,2.3l1.1,0.6l0.3-2.3l1.1,0.6l-0.3,2.3l1.1,0.5 l0.3-2.3l1.1,0.5v-1.1l-1-0.5l0.2-1.5l1.1,0.5v-1.1l-1-0.5L168.9,274.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M180.5,287c-1.2-0.5-1.6-2-0.8-2.4c0.9-0.4,2.3,1,1.9,2C181.5,287,181,287.2,180.5,287 M180.5,283.4 c-2.4-0.8-2.9,1.4-2,3c1.2,2.2,3.8,2.8,4.4,1C183.4,286,182.2,284,180.5,283.4 M174.3,280.4c-1.2-0.6-1.5-2.1-0.7-2.4 c0.9-0.4,2.2,1,1.8,2C175.2,280.5,174.8,280.6,174.3,280.4 M174.3,276.8c-2.2-0.8-2.8,1.1-2.1,2.7c1,2.4,3.8,3.2,4.4,1.4 C177,279.5,175.9,277.4,174.3,276.8 M179.4,278.6c-2.2,3.1-3.3,4.6-5,7l0.9,0.9c3.3-4.4,3.3-4.4,5.1-7L179.4,278.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M189.8,281.1c-0.9,1.1-3.8,4.4,0,10.9l0,0.1c0.4-0.1,1-0.2,1.4-0.3c-2.3-4.1-2.3-6.8,0-9.5L189.8,281.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M164.2,287c-0.1,0-0.2,0.1-0.2,0.1c0.3,0.4,0.6,1,0.9,1.5c1-0.6,2.4,0.3,2.5,1.6 c-0.8-0.4-1.8-0.9-2.6-0.9c1.4,0.7,2.8,1.4,4.2,2l0-0.3c-0.2-1.9-1-2.9-2.9-3.8C165.7,287.1,164.9,286.8,164.2,287"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M174.5,293.5c0.4-1,2.2-0.2,2.7,1c0,0.1,0.1,0.2,0.1,0.3c-0.9-0.4-1.9-0.8-2.8-1.2 C174.4,293.6,174.5,293.5,174.5,293.5 M172.7,287c0,1.8,0,4.1,0,5.9c2.1,0.9,4.3,1.8,6.4,2.6l0-0.1c-0.8-3.7-3.8-4.3-4.6-3.6 c0,0,0,0,0,0v-4L172.7,287"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M182.7,296.6c0.1-0.6,0.8-2.1,3.4-1.3c1,0.4,1.6,0.8,2.2,1.5c-0.4,0.3-0.9,0.6-1.3,0.9 c-0.7-1-2.1-1.3-2.4-0.2c-0.7-0.2-1.3-0.5-1.9-0.7C182.7,296.8,182.7,296.7,182.7,296.6"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st10",
  points: "177.1,255.9 174.1,254.6 174.1,256.1 177.1,257.4 177.1,255.9  "
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st10",
  points: "188.4,257.8 186.3,257 185.2,258.3 184.1,256.3 181.8,255.5 183.9,259 181.4,261.4 183.7,262.2  185.1,260.7 186.5,263.1 188.8,263.9 186.4,259.9 188.4,257.8  "
}));

var _ref150 = /*#__PURE__*/React.createElement("rect", {
  y: 376.8,
  className: "st96",
  width: 500,
  height: 123.2
});

var _ref151 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st97",
  d: "M21.4,425.9c0-1.7,0.4-3.1,1.2-4.1c0.8-1,2-1.5,3.6-1.5c1.1,0,2,0.3,2.7,1c0.8-0.7,1.8-1,2.7-1 c1.3,0,2.5,0.4,3.4,1.3c0.9,0.9,1.4,2.2,1.4,3.9c0,1.6-0.5,2.9-1.4,3.9c-0.9,1-2.1,1.5-3.3,1.5c-1.2,0-2.3-0.5-3.3-1.4 s-1.4-2.2-1.4-3.9c0-0.9,0.3-1.8,0.8-2.7c-0.6-0.2-1-0.3-1.5-0.3c-0.7,0-1.2,0.3-1.7,0.8c-0.4,0.5-0.7,1.4-0.7,2.7 c0,1.2,0.2,2.3,0.7,3.2c0.4,1,1.2,1.9,2.4,2.9c2.1,0.2,3.7,0.5,4.7,1.1c1,0.5,1.7,1.4,1.9,2.6h-3.4c0-0.4-0.2-0.8-0.7-1 c-0.5-0.2-1.5-0.4-3-0.4c-1.4,0-2.7,0.1-3.8,0.3v-2.2l1.4-0.2C22.2,430.3,21.4,428.2,21.4,425.9z M29.3,425.5 c0,1.1,0.2,1.9,0.7,2.4s1,0.7,1.6,0.7c0.6,0,1.1-0.3,1.6-0.8s0.7-1.3,0.7-2.4c0-1-0.2-1.8-0.6-2.3c-0.4-0.5-1-0.8-1.7-0.8 c-0.6,0-1.1,0.3-1.6,0.8S29.3,424.5,29.3,425.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st97",
  d: "M38.6,429.7c0-1.2,0.3-2.3,0.8-3.3l2.3,0.8c-0.4,1.2-0.6,2.1-0.6,2.7c0,1.3,0.2,2.3,0.6,2.8 c0.4,0.5,1,0.8,1.6,0.8c0.9,0,1.6-0.4,1.9-1.1c0.3-0.7,0.5-1.6,0.5-2.6c0-1.7-0.7-3.2-2.1-4.5c-1.4-1.3-2.1-2.9-2.1-4.9h2.4 c0,1.3,0.7,2.7,2.1,4.1c1.4,1.4,2.1,3.2,2.1,5.4c0,1.6-0.4,2.9-1.3,4.1s-2,1.8-3.6,1.8c-1.4,0-2.6-0.6-3.4-1.8 C39.1,432.7,38.6,431.3,38.6,429.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st97",
  d: "M50.4,431c0-0.8,0.2-1.6,0.7-2.5l2.2,1.1c-0.3,0.7-0.4,1.3-0.4,1.9c0,0.6,0.2,1.1,0.6,1.4 c0.4,0.3,0.9,0.5,1.5,0.5c0.9,0,1.5-0.2,1.9-0.6c0.4-0.4,0.6-1.1,0.6-2.2v-6.6c0-0.5-0.2-0.9-0.6-1.1c-0.4-0.3-0.9-0.4-1.6-0.4 c-0.8,0-1.4,0.2-1.6,0.5c-0.3,0.3-0.4,0.7-0.4,1.1c0,0.5,0.1,1,0.4,1.4l-2.1,1c-0.5-0.8-0.8-1.6-0.8-2.4c0-1,0.4-1.9,1.2-2.6 c0.8-0.8,1.9-1.2,3.2-1.2c1.5,0,2.7,0.4,3.5,1.1s1.2,1.6,1.2,2.7v6.6c0,1.8-0.5,3.1-1.4,3.9c-0.9,0.8-2.1,1.2-3.5,1.2 c-1.1,0-2.1-0.3-3.1-1C50.9,434,50.4,432.8,50.4,431z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st97",
  d: "M62.1,430.8c0-1.6,0.4-2.8,1.2-3.8c0.8-1,2-1.5,3.5-1.5c0.9,0,1.6,0.3,2.4,0.8v-2.1c0-0.5-0.1-0.9-0.5-1.2 s-0.9-0.4-1.6-0.4c-0.8,0-1.3,0.1-1.6,0.4c-0.3,0.2-0.5,0.7-0.5,1.3h-2.4c0-1.3,0.4-2.3,1.2-2.9s1.9-0.9,3.3-0.9 c1.3,0,2.3,0.4,3.2,1.1c0.9,0.7,1.3,1.6,1.3,2.7v6.7c0,1.4-0.5,2.5-1.4,3.5c-0.9,0.9-2.1,1.4-3.4,1.4c-1.4,0-2.5-0.5-3.4-1.4 C62.5,433.2,62.1,432.1,62.1,430.8z M64.5,430.8c0,0.8,0.2,1.5,0.6,2c0.4,0.5,1,0.7,1.6,0.7c0.7,0,1.3-0.2,1.8-0.7 c0.4-0.5,0.7-1.1,0.7-1.9c0-1.1-0.2-1.9-0.7-2.4c-0.5-0.5-1-0.7-1.7-0.7c-0.7,0-1.2,0.2-1.6,0.7C64.7,428.8,64.5,429.6,64.5,430.8 z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st97",
  d: "M73.8,429.7c0-1.2,0.3-2.3,0.8-3.3l2.3,0.8c-0.4,1.2-0.6,2.1-0.6,2.7c0,1.3,0.2,2.3,0.6,2.8 c0.4,0.5,1,0.8,1.6,0.8c0.9,0,1.6-0.4,1.9-1.1c0.3-0.7,0.5-1.6,0.5-2.6c0-1.7-0.7-3.2-2.1-4.5c-1.4-1.3-2.1-2.9-2.1-4.9h2.4 c0,1.3,0.7,2.7,2.1,4.1c1.4,1.4,2.1,3.2,2.1,5.4c0,1.6-0.4,2.9-1.3,4.1s-2,1.8-3.6,1.8c-1.4,0-2.6-0.6-3.4-1.8 C74.2,432.7,73.7,431.3,73.8,429.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st97",
  d: "M85.5,428.3c0-2.6,0.6-4.4,1.8-5.4s2.2-1.6,3.2-1.8c0-0.2-0.1-0.3-0.1-0.4s-0.1-0.2-0.1-0.3h2.5l-0.2,0.7 c0.9,0.1,2,0.7,3.1,1.6c1.1,1,1.8,2.9,1.9,5.6c0,2.3-0.6,4-1.6,5.3c-1.1,1.3-2.6,2-4.4,2c-2,0-3.5-0.7-4.5-2.1 C86,432.2,85.5,430.4,85.5,428.3z M87.9,428.4c0,1.5,0.3,2.7,0.9,3.7c0.6,1,1.5,1.4,2.7,1.4c1.3-0.1,2.2-0.6,2.7-1.5 c0.5-0.9,0.8-2.1,0.8-3.7c0-1.8-0.3-3-0.8-3.8c-0.5-0.7-1.1-1.3-1.9-1.6l0.2,7.2h-2.4l0.1-7.2c-0.7,0.3-1.2,0.8-1.7,1.5 C88.2,425.3,87.9,426.6,87.9,428.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st97",
  d: "M99.8,431c0-0.8,0.2-1.6,0.7-2.5l2.2,1.1c-0.3,0.7-0.4,1.3-0.4,1.9c0,0.6,0.2,1.1,0.6,1.4 c0.4,0.3,0.9,0.5,1.5,0.5c0.9,0,1.5-0.2,1.9-0.6c0.4-0.4,0.6-1.1,0.6-2.2v-6.6c0-0.5-0.2-0.9-0.6-1.1c-0.4-0.3-0.9-0.4-1.6-0.4 c-0.8,0-1.4,0.2-1.6,0.5c-0.3,0.3-0.4,0.7-0.4,1.1c0,0.5,0.1,1,0.4,1.4l-2.1,1c-0.5-0.8-0.8-1.6-0.8-2.4c0-1,0.4-1.9,1.2-2.6 c0.8-0.8,1.9-1.2,3.2-1.2c1.5,0,2.7,0.4,3.5,1.1s1.2,1.6,1.2,2.7v6.6c0,1.8-0.5,3.1-1.4,3.9c-0.9,0.8-2.1,1.2-3.5,1.2 c-1.1,0-2.1-0.3-3.1-1C100.3,434,99.8,432.8,99.8,431z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st97",
  d: "M117.5,430.7c0-1,0.2-2,0.5-2.9l2.1,0.9c-0.2,0.7-0.3,1.4-0.2,1.9c0,1.2,0.2,1.9,0.6,2.3s1,0.6,1.6,0.5 c0.9,0,1.5-0.2,1.8-0.7c0.3-0.5,0.5-1.1,0.5-1.9c0-1.3-0.2-2.2-0.5-2.6c-0.3-0.5-0.8-0.7-1.3-0.7h-1.1v-2.2h0.8 c0.6,0,1-0.1,1.2-0.3s0.3-0.7,0.3-1.4c0-0.7-0.8-1.8-2.3-3.3h3.1c1.1,1,1.6,2.1,1.6,3.3c0,1.2-0.4,2.1-1.1,2.9 c1.2,1.1,1.7,2.5,1.7,4.4c0,1.6-0.4,2.8-1.3,3.6c-0.9,0.8-2,1.3-3.5,1.3c-1.3,0-2.4-0.4-3.3-1.2S117.5,432.4,117.5,430.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st97",
  d: "M129.2,425.8c0-1.7,0.5-3.1,1.3-4.1c0.9-1,2-1.5,3.2-1.5c1.2,0,2.1,0.5,2.7,1.4c0.6-0.9,1.5-1.4,2.6-1.4 c1.1,0,2,0.5,2.7,1.4c0.3-0.5,0.7-0.9,1.1-1.1c0.5-0.2,1-0.3,1.6-0.3c1.3,0,2.3,0.5,3.2,1.4c0.9,0.9,1.3,2.3,1.3,4.2 c0,1.3-0.5,2.9-1.6,4.5l-3.1,0c1.5-1.8,2.3-3.3,2.3-4.5c0-1.4-0.2-2.3-0.6-2.7c-0.4-0.4-0.9-0.6-1.5-0.6c-1.1,0-1.6,0.8-1.6,2.5 v2.5h-2.3V425c0-1.6-0.5-2.5-1.4-2.5c-1,0-1.5,0.8-1.5,2.5v2.5h-2.3V425c0-1.7-0.5-2.5-1.5-2.5c-0.5,0-1,0.2-1.4,0.7 c-0.5,0.5-0.7,1.3-0.7,2.7c0,2.2,1.4,4.2,4.2,5.9c3.2,0.1,5.5,0.4,6.9,0.9c1.4,0.5,2.2,1.5,2.4,2.9h-3.1c-0.3-0.8-0.9-1.2-2-1.4 c-1-0.2-2.2-0.3-3.5-0.3c-2.5,0-4.4,0.2-5.7,0.6v-2.2l1.6-0.2C130.3,430.3,129.2,428.2,129.2,425.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st97",
  d: "M151.2,429.7c0-1.2,0.3-2.3,0.8-3.3l2.3,0.8c-0.4,1.2-0.6,2.1-0.6,2.7c0,1.3,0.2,2.3,0.6,2.8 c0.4,0.5,1,0.8,1.6,0.8c0.9,0,1.6-0.4,1.9-1.1c0.3-0.7,0.5-1.6,0.5-2.6c0-1.7-0.7-3.2-2.1-4.5c-1.4-1.3-2.1-2.9-2.1-4.9h2.4 c0,1.3,0.7,2.7,2.1,4.1c1.4,1.4,2.1,3.2,2.1,5.4c0,1.6-0.4,2.9-1.3,4.1s-2,1.8-3.6,1.8c-1.4,0-2.6-0.6-3.4-1.8 C151.6,432.7,151.2,431.3,151.2,429.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st97",
  d: "M163.1,430.5v-10.2h2.4v10.1c0,1,0.2,1.7,0.7,2.2c0.4,0.5,1,0.8,1.6,0.8c0.7,0,1.2-0.2,1.7-0.7 c0.4-0.5,0.7-1.2,0.7-2.1c0-1.2-0.3-2.2-0.9-3c-0.6-0.7-0.9-2.1-0.9-4h2.4c0,1.6,0.3,2.8,0.9,3.5s0.9,1.9,1,3.5 c0,1.4-0.5,2.6-1.4,3.6s-2.1,1.4-3.4,1.4c-1.4,0-2.6-0.5-3.5-1.5C163.4,433.1,163,431.9,163.1,430.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st97",
  d: "M174.8,430.5c0-1.6,0.5-2.9,1.3-3.7c0.9-0.8,2-1.3,3.5-1.3c0.8,0,1.5,0.3,2.3,0.8V423c0-0.3-0.4-0.5-1.2-0.5 c-0.6,0-0.9,0.2-0.9,0.5v1.2h-2.3V423c0-0.3-0.4-0.5-1.3-0.5h-1.3v-2.2h1.4c1.2,0,2,0.4,2.5,1.2c0.6-0.8,1.5-1.2,2.9-1.2 c0.9,0,1.5,0.2,2,0.7c0.5,0.5,0.7,1.1,0.7,1.8v7.6c0,1.7-0.5,3-1.4,3.9c-1,0.9-2.1,1.3-3.3,1.3c-1.4,0-2.5-0.4-3.4-1.3 S174.8,432.1,174.8,430.5z M177.2,430.5c0,1,0.2,1.8,0.6,2.2c0.4,0.5,1,0.7,1.7,0.7c0.7,0,1.2-0.2,1.7-0.7 c0.4-0.5,0.6-1.2,0.6-2.2c0-0.9-0.2-1.7-0.6-2.1c-0.4-0.5-1-0.7-1.7-0.7c-0.7,0-1.2,0.2-1.7,0.7 C177.5,428.9,177.2,429.6,177.2,430.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st97",
  d: "M186.5,427.5c0-2.2,0.4-3.9,1.3-5.3c0.8-1.3,2-2,3.5-2c1.5,0,2.7,0.7,3.5,2s1.2,3.1,1.2,5.3 c0,1.9-0.3,4.6-1,7.9h-2.7c0.9-3,1.3-5.7,1.3-8.1c0-1.7-0.2-2.9-0.7-3.7c-0.5-0.8-1-1.2-1.7-1.2c-0.6,0-1.2,0.4-1.6,1.2 c-0.4,0.8-0.7,2-0.7,3.7c0,2.4,0.5,5.1,1.4,8.1h-2.8C186.8,432.1,186.5,429.5,186.5,427.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st97",
  d: "M204.2,425.9c0-1.7,0.4-3.1,1.2-4.1c0.8-1,2-1.5,3.6-1.5c1.1,0,2,0.3,2.7,1c0.8-0.7,1.8-1,2.7-1 c1.3,0,2.5,0.4,3.4,1.3c0.9,0.9,1.4,2.2,1.4,3.9c0,1.6-0.5,2.9-1.4,3.9c-0.9,1-2.1,1.5-3.3,1.5c-1.2,0-2.3-0.5-3.3-1.4 s-1.4-2.2-1.4-3.9c0-0.9,0.3-1.8,0.8-2.7c-0.6-0.2-1-0.3-1.5-0.3c-0.7,0-1.2,0.3-1.7,0.8c-0.4,0.5-0.7,1.4-0.7,2.7 c0,1.2,0.2,2.3,0.7,3.2c0.4,1,1.2,1.9,2.4,2.9c2.1,0.2,3.7,0.5,4.7,1.1c1,0.5,1.7,1.4,1.9,2.6h-3.4c0-0.4-0.2-0.8-0.7-1 c-0.5-0.2-1.5-0.4-3-0.4c-1.4,0-2.7,0.1-3.8,0.3v-2.2l1.4-0.2C205.1,430.3,204.2,428.2,204.2,425.9z M212.1,425.5 c0,1.1,0.2,1.9,0.7,2.4s1,0.7,1.6,0.7c0.6,0,1.1-0.3,1.6-0.8s0.7-1.3,0.7-2.4c0-1-0.2-1.8-0.6-2.3c-0.4-0.5-1-0.8-1.7-0.8 c-0.6,0-1.1,0.3-1.6,0.8S212.1,424.5,212.1,425.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st97",
  d: "M221.5,429.7c0-1.2,0.3-2.3,0.8-3.3l2.3,0.8c-0.4,1.2-0.6,2.1-0.6,2.7c0,1.3,0.2,2.3,0.6,2.8 c0.4,0.5,1,0.8,1.6,0.8c0.9,0,1.6-0.4,1.9-1.1c0.3-0.7,0.5-1.6,0.5-2.6c0-1.7-0.7-3.2-2.1-4.5c-1.4-1.3-2.1-2.9-2.1-4.9h2.4 c0,1.3,0.7,2.7,2.1,4.1c1.4,1.4,2.1,3.2,2.1,5.4c0,1.6-0.4,2.9-1.3,4.1s-2,1.8-3.6,1.8c-1.4,0-2.6-0.6-3.4-1.8 C221.9,432.7,221.5,431.3,221.5,429.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st97",
  d: "M239.2,430.5c0-1.6,0.5-2.9,1.3-3.7c0.9-0.8,2-1.3,3.5-1.3c0.8,0,1.5,0.3,2.3,0.8V423c0-0.3-0.4-0.5-1.2-0.5 c-0.6,0-0.9,0.2-0.9,0.5v1.2h-2.3V423c0-0.3-0.4-0.5-1.3-0.5h-1.3v-2.2h1.4c1.2,0,2,0.4,2.5,1.2c0.6-0.8,1.5-1.2,2.9-1.2 c0.9,0,1.5,0.2,2,0.7c0.5,0.5,0.7,1.1,0.7,1.8v7.6c0,1.7-0.5,3-1.4,3.9c-1,0.9-2.1,1.3-3.3,1.3c-1.4,0-2.5-0.4-3.4-1.3 S239.2,432.1,239.2,430.5z M241.7,430.5c0,1,0.2,1.8,0.6,2.2c0.4,0.5,1,0.7,1.7,0.7c0.7,0,1.2-0.2,1.7-0.7 c0.4-0.5,0.6-1.2,0.6-2.2c0-0.9-0.2-1.7-0.6-2.1c-0.4-0.5-1-0.7-1.7-0.7c-0.7,0-1.2,0.2-1.7,0.7 C241.9,428.9,241.7,429.6,241.7,430.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st97",
  d: "M250.9,431c0-0.8,0.2-1.6,0.7-2.5l2.2,1.1c-0.3,0.7-0.4,1.3-0.4,1.9c0,0.6,0.2,1.1,0.6,1.4 c0.4,0.3,0.9,0.5,1.5,0.5c0.9,0,1.5-0.2,1.9-0.6c0.4-0.4,0.6-1.1,0.6-2.2v-6.6c0-0.5-0.2-0.9-0.6-1.1s-0.9-0.4-1.6-0.4 c-0.8,0-1.4,0.2-1.6,0.5c-0.3,0.3-0.4,0.7-0.4,1.1c0,0.5,0.1,1,0.4,1.4l-2.1,1c-0.5-0.8-0.8-1.6-0.8-2.4c0-1,0.4-1.9,1.2-2.6 c0.8-0.8,1.9-1.2,3.2-1.2c1.5,0,2.7,0.4,3.5,1.1s1.2,1.6,1.2,2.7v6.6c0,1.8-0.5,3.1-1.4,3.9c-0.9,0.8-2.1,1.2-3.5,1.2 c-1.1,0-2.1-0.3-3.1-1C251.4,434,250.9,432.8,250.9,431z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st97",
  d: "M262.6,429.7c0-1.2,0.3-2.3,0.8-3.3l2.3,0.8c-0.4,1.2-0.6,2.1-0.6,2.7c0,1.3,0.2,2.3,0.6,2.8 c0.4,0.5,1,0.8,1.6,0.8c0.9,0,1.6-0.4,1.9-1.1c0.3-0.7,0.5-1.6,0.5-2.6c0-1.7-0.7-3.2-2.1-4.5c-1.4-1.3-2.1-2.9-2.1-4.9h2.4 c0,1.3,0.7,2.7,2.1,4.1c1.4,1.4,2.1,3.2,2.1,5.4c0,1.6-0.4,2.9-1.3,4.1s-2,1.8-3.6,1.8c-1.4,0-2.6-0.6-3.4-1.8 C263,432.7,262.6,431.3,262.6,429.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st97",
  d: "M274.5,430.5v-10.2h2.4v10.1c0,1,0.2,1.7,0.7,2.2c0.4,0.5,1,0.8,1.6,0.8c0.7,0,1.2-0.2,1.7-0.7 c0.4-0.5,0.7-1.2,0.7-2.1c0-1.2-0.3-2.2-0.9-3c-0.6-0.7-0.9-2.1-0.9-4h2.4c0,1.6,0.3,2.8,0.9,3.5s0.9,1.9,1,3.5 c0,1.4-0.5,2.6-1.4,3.6c-0.9,1-2.1,1.4-3.4,1.4c-1.4,0-2.6-0.5-3.5-1.5C274.8,433.1,274.4,431.9,274.5,430.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st97",
  d: "M286.2,429.2c0-1.4,0.2-2.6,0.7-3.7s1.1-2,2.1-2.9c1.8-1.6,4.2-2.4,7.3-2.4v2.2c-3.6,0.2-5.8,0.8-6.5,1.9 l1.6-0.4c0.9,0,1.7,0.5,2.5,1.4c0.8-1,1.7-1.4,2.8-1.4c1.4,0,2.5,0.4,3.4,1.3c0.9,0.9,1.3,2.2,1.3,4c0,2.2-0.7,4.2-2.1,6.2h-3.4 c2.1-2,3.1-4.1,3.1-6.2c0-1.1-0.2-1.9-0.7-2.4s-1-0.8-1.7-0.8c-1,0-1.5,0.6-1.5,1.9v3.5h-2.4V428c0-1.2-0.5-1.9-1.4-1.9 c-1.6,0-2.4,1-2.4,3.1c0,2.2,1.1,4.3,3.2,6.3h-3.5C286.9,433.5,286.2,431.4,286.2,429.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st97",
  d: "M303.4,421.8l0.9-2.1c0.6,0.4,1,0.6,1.3,0.6h1c0.6,0,1.2,0.4,1.7,1.3c0.6-0.9,1.3-1.3,2.3-1.3 c0.7,0,1.4,0.3,2.1,0.8c0.6,0.6,1,1.2,1,2v6.9c0,2-0.4,3.5-1.2,4.4c-0.8,0.9-2,1.3-3.5,1.3c-1.4,0-2.5-0.4-3.4-1.2 c-0.9-0.8-1.4-1.9-1.4-3.5c0-0.7,0.2-1.5,0.6-2.5l2.4,0.9c-0.3,0.6-0.5,1.4-0.5,2.2c0,0.6,0.2,1,0.6,1.4c0.4,0.4,1,0.5,1.7,0.5 c0.9,0,1.5-0.2,1.8-0.5c0.3-0.4,0.5-1.3,0.5-2.9v-6.9c0-0.5-0.3-0.7-0.9-0.7c-0.6,0-1,0.2-1,0.5v3.3H307V423 c0-0.4-0.2-0.5-0.5-0.5h-1.1C304.8,422.5,304.1,422.3,303.4,421.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st97",
  d: "M315.8,425.8c0-1.7,0.5-3.1,1.3-4.1c0.9-1,2-1.5,3.2-1.5c1.2,0,2.1,0.5,2.7,1.4c0.6-0.9,1.5-1.4,2.6-1.4 c1.1,0,2,0.5,2.7,1.4c0.3-0.5,0.7-0.9,1.1-1.1s1-0.3,1.6-0.3c1.3,0,2.3,0.5,3.2,1.4c0.9,0.9,1.3,2.3,1.3,4.2 c0,1.3-0.5,2.9-1.6,4.5l-3.1,0c1.5-1.8,2.3-3.3,2.3-4.5c0-1.4-0.2-2.3-0.6-2.7c-0.4-0.4-0.9-0.6-1.5-0.6c-1.1,0-1.6,0.8-1.6,2.5 v2.5h-2.3V425c0-1.6-0.5-2.5-1.4-2.5c-1,0-1.5,0.8-1.5,2.5v2.5h-2.3V425c0-1.7-0.5-2.5-1.5-2.5c-0.5,0-1,0.2-1.4,0.7 c-0.5,0.5-0.7,1.3-0.7,2.7c0,2.2,1.4,4.2,4.2,5.9c3.2,0.1,5.5,0.4,6.9,0.9c1.4,0.5,2.2,1.5,2.4,2.9h-3.1c-0.3-0.8-0.9-1.2-2-1.4 c-1-0.2-2.2-0.3-3.5-0.3c-2.5,0-4.4,0.2-5.7,0.6v-2.2l1.6-0.2C316.9,430.3,315.8,428.2,315.8,425.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st97",
  d: "M337.8,431c0-0.8,0.2-1.6,0.7-2.5l2.2,1.1c-0.3,0.7-0.4,1.3-0.4,1.9c0,0.6,0.2,1.1,0.6,1.4 c0.4,0.3,0.9,0.5,1.5,0.5c0.9,0,1.5-0.2,1.9-0.6c0.4-0.4,0.6-1.1,0.6-2.2v-6.6c0-0.5-0.2-0.9-0.6-1.1s-0.9-0.4-1.6-0.4 c-0.8,0-1.4,0.2-1.6,0.5c-0.3,0.3-0.4,0.7-0.4,1.1c0,0.5,0.1,1,0.4,1.4l-2.1,1c-0.5-0.8-0.8-1.6-0.8-2.4c0-1,0.4-1.9,1.2-2.6 c0.8-0.8,1.9-1.2,3.2-1.2c1.5,0,2.7,0.4,3.5,1.1s1.2,1.6,1.2,2.7v6.6c0,1.8-0.5,3.1-1.4,3.9c-0.9,0.8-2.1,1.2-3.5,1.2 c-1.1,0-2.1-0.3-3.1-1C338.3,434,337.8,432.8,337.8,431z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st97",
  d: "M21.4,454.7c0-1.6,0.4-2.8,1.2-3.8c0.8-1,2-1.5,3.5-1.5c0.9,0,1.6,0.3,2.4,0.8v-2.1c0-0.5-0.1-0.9-0.5-1.2 s-0.9-0.4-1.6-0.4c-0.8,0-1.3,0.1-1.6,0.4c-0.3,0.2-0.5,0.7-0.5,1.3h-2.4c0-1.3,0.4-2.3,1.2-2.9s1.9-0.9,3.3-0.9 c1.3,0,2.3,0.4,3.2,1.1c0.9,0.7,1.3,1.6,1.3,2.7v6.7c0,1.4-0.5,2.5-1.4,3.5c-0.9,0.9-2.1,1.4-3.4,1.4c-1.4,0-2.5-0.5-3.4-1.4 C21.8,457.2,21.4,456.1,21.4,454.7z M23.8,454.8c0,0.8,0.2,1.5,0.6,2c0.4,0.5,1,0.7,1.6,0.7c0.7,0,1.3-0.2,1.8-0.7 c0.4-0.5,0.7-1.1,0.7-1.9c0-1.1-0.2-1.9-0.7-2.4c-0.5-0.5-1-0.7-1.7-0.7c-0.7,0-1.2,0.2-1.6,0.7C24,452.8,23.8,453.6,23.8,454.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st97",
  d: "M33.1,453.7c0-1.2,0.3-2.3,0.8-3.3l2.3,0.8c-0.4,1.2-0.6,2.1-0.6,2.7c0,1.3,0.2,2.3,0.6,2.8 c0.4,0.5,1,0.8,1.6,0.8c0.9,0,1.6-0.4,1.9-1.1c0.3-0.7,0.5-1.6,0.5-2.6c0-1.7-0.7-3.2-2.1-4.5c-1.4-1.3-2.1-2.9-2.1-4.9h2.4 c0,1.3,0.7,2.7,2.1,4.1c1.4,1.4,2.1,3.2,2.1,5.4c0,1.6-0.4,2.9-1.3,4.1s-2,1.8-3.6,1.8c-1.4,0-2.6-0.6-3.4-1.8 C33.5,456.7,33.1,455.3,33.1,453.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st97",
  d: "M45,454.5v-10.2h2.4v10.1c0,1,0.2,1.7,0.7,2.2c0.4,0.5,1,0.8,1.6,0.8c0.7,0,1.2-0.2,1.7-0.7 c0.4-0.5,0.7-1.2,0.7-2.1c0-1.2-0.3-2.2-0.9-3c-0.6-0.7-0.9-2.1-0.9-4h2.4c0,1.6,0.3,2.8,0.9,3.5s0.9,1.9,1,3.5 c0,1.4-0.5,2.6-1.4,3.6s-2.1,1.4-3.4,1.4c-1.4,0-2.6-0.5-3.5-1.5C45.3,457.1,44.9,455.9,45,454.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st97",
  d: "M56.7,454.5v-7.6c0-0.7,0.2-1.3,0.7-1.8c0.5-0.5,1.2-0.7,2-0.7c1.3,0,2.3,0.4,2.9,1.2 c0.5-0.8,1.3-1.2,2.5-1.2h1.4v2.2h-1.3c-0.9,0-1.3,0.2-1.3,0.5v1.2h-2.3V447c0-0.3-0.3-0.5-0.9-0.5c-0.8,0-1.2,0.2-1.2,0.5v3.3 c0.8-0.5,1.5-0.8,2.3-0.8c1.4,0,2.6,0.4,3.5,1.3c0.9,0.9,1.3,2.1,1.3,3.7c0,1.6-0.5,2.9-1.4,3.8c-0.9,0.9-2.1,1.3-3.4,1.3 c-1.2,0-2.3-0.4-3.3-1.3S56.7,456.2,56.7,454.5z M59.1,454.5c0,1,0.2,1.7,0.6,2.2c0.4,0.5,1,0.7,1.7,0.7c0.7,0,1.3-0.2,1.7-0.7 c0.4-0.5,0.6-1.2,0.6-2.2c0-1-0.2-1.7-0.7-2.1c-0.4-0.5-1-0.7-1.7-0.7c-0.7,0-1.2,0.2-1.7,0.7C59.3,452.9,59.1,453.6,59.1,454.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st97",
  d: "M68.4,453.7c0-1.2,0.3-2.3,0.8-3.3l2.3,0.8c-0.4,1.2-0.6,2.1-0.6,2.7c0,1.3,0.2,2.3,0.6,2.8 c0.4,0.5,1,0.8,1.6,0.8c0.9,0,1.6-0.4,1.9-1.1c0.3-0.7,0.5-1.6,0.5-2.6c0-1.7-0.7-3.2-2.1-4.5c-1.4-1.3-2.1-2.9-2.1-4.9h2.4 c0,1.3,0.7,2.7,2.1,4.1c1.4,1.4,2.1,3.2,2.1,5.4c0,1.6-0.4,2.9-1.3,4.1s-2,1.8-3.6,1.8c-1.4,0-2.6-0.6-3.4-1.8 C68.8,456.7,68.4,455.3,68.4,453.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st97",
  d: "M80.1,455c0-0.6,0.2-1.4,0.5-2.3l2.4,0.6c-0.3,0.6-0.5,1.3-0.5,2.2c0,0.5,0.2,1,0.6,1.4 c0.4,0.4,1,0.6,1.7,0.6c0.7,0,1.3-0.2,1.7-0.5c0.4-0.3,0.6-0.7,0.6-1.2v-1.5c0-0.6-0.1-1.1-0.3-1.5c-0.2-0.4-0.6-0.6-1.1-0.6h-1.2 V450h1.2c0.4,0,0.7-0.2,0.9-0.4c0.2-0.3,0.3-0.8,0.3-1.4c0-0.5-0.2-0.9-0.5-1.2c-0.3-0.4-0.8-0.5-1.4-0.5c-0.9,0-1.4,0.2-1.7,0.5 c-0.3,0.3-0.4,0.6-0.4,0.9c0,0.3,0.1,0.7,0.3,1.1l-2.3,0.8c-0.2-0.7-0.4-1.3-0.4-1.9c0-0.9,0.4-1.7,1.3-2.5 c0.9-0.7,1.9-1.1,3.2-1.1c1.3,0,2.4,0.4,3.2,1.2c0.8,0.8,1.2,1.7,1.2,2.8c0,1.2-0.5,2.2-1.5,2.9c1.1,0.9,1.7,2.1,1.7,3.5 c0,1.5-0.4,2.7-1.2,3.6c-0.8,0.9-2,1.3-3.5,1.3c-1.5,0-2.7-0.4-3.5-1.2C80.5,457.6,80.1,456.5,80.1,455z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st97",
  d: "M91.8,449.8c0-1.7,0.5-3.1,1.3-4.1c0.9-1,2-1.5,3.2-1.5c1.2,0,2.1,0.5,2.7,1.4c0.6-0.9,1.5-1.4,2.6-1.4 c1.1,0,2,0.5,2.7,1.4c0.3-0.5,0.7-0.9,1.1-1.1c0.5-0.2,1-0.3,1.6-0.3c1.3,0,2.3,0.5,3.2,1.4c0.9,0.9,1.3,2.3,1.3,4.2 c0,1.3-0.5,2.9-1.6,4.5l-3.1,0c1.5-1.8,2.3-3.3,2.3-4.5c0-1.4-0.2-2.3-0.6-2.7c-0.4-0.4-0.9-0.6-1.5-0.6c-1.1,0-1.6,0.8-1.6,2.5 v2.5h-2.3V449c0-1.6-0.5-2.5-1.4-2.5c-1,0-1.5,0.8-1.5,2.5v2.5h-2.3V449c0-1.7-0.5-2.5-1.5-2.5c-0.5,0-1,0.2-1.4,0.7 c-0.5,0.5-0.7,1.3-0.7,2.7c0,2.2,1.4,4.2,4.2,5.9c3.2,0.1,5.5,0.4,6.9,0.9c1.4,0.5,2.2,1.5,2.4,2.9h-3.1c-0.3-0.8-0.9-1.2-2-1.4 c-1-0.2-2.2-0.3-3.5-0.3c-2.5,0-4.4,0.2-5.7,0.6v-2.2l1.6-0.2C92.9,454.3,91.8,452.2,91.8,449.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st97",
  d: "M113.8,455c0-0.8,0.2-1.6,0.7-2.5l2.2,1.1c-0.3,0.7-0.4,1.3-0.4,1.9c0,0.6,0.2,1.1,0.6,1.4 c0.4,0.3,0.9,0.5,1.5,0.5c0.9,0,1.5-0.2,1.9-0.6c0.4-0.4,0.6-1.1,0.6-2.2V448c0-0.5-0.2-0.9-0.6-1.1c-0.4-0.3-0.9-0.4-1.6-0.4 c-0.8,0-1.4,0.2-1.6,0.5c-0.3,0.3-0.4,0.7-0.4,1.1c0,0.5,0.1,1,0.4,1.4l-2.1,1c-0.5-0.8-0.8-1.6-0.8-2.4c0-1,0.4-1.9,1.2-2.6 c0.8-0.8,1.9-1.2,3.2-1.2c1.5,0,2.7,0.4,3.5,1.1s1.2,1.6,1.2,2.7v6.6c0,1.8-0.5,3.1-1.4,3.9c-0.9,0.8-2.1,1.2-3.5,1.2 c-1.1,0-2.1-0.3-3.1-1C114.3,457.9,113.8,456.7,113.8,455z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st97",
  d: "M125.5,454.3c0-1.3,0.4-2.4,1.1-3.3s1.6-1.4,2.7-1.5l0.2-1.2c0.1-0.7-0.4-1.3-1.3-1.6 c-0.9-0.4-1.4-1.1-1.4-2.3h2.5c0,0.5,0.4,1,1.3,1.4s1.3,1.2,1.1,2.5l-0.3,1.4c0.9,0.1,1.6,0.6,2.4,1.5s1.1,2,1.1,3.3 c0,1.6-0.5,2.9-1.4,3.9c-0.9,1-2,1.5-3.4,1.5c-1.4,0-2.5-0.5-3.4-1.4C125.9,457.3,125.5,455.9,125.5,454.3z M127.9,454.4 c0,1.2,0.2,2,0.7,2.4c0.5,0.5,1,0.7,1.6,0.7c0.7,0,1.3-0.2,1.7-0.7c0.4-0.4,0.6-1.3,0.6-2.4c0-0.9-0.2-1.6-0.7-2 c-0.4-0.5-0.9-0.7-1.5-0.7c-0.8,0-1.4,0.2-1.8,0.7C128.2,452.8,127.9,453.5,127.9,454.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st97",
  d: "M137.2,449.8c0-1.7,0.5-3.1,1.3-4.1c0.9-1,2-1.5,3.2-1.5c1.2,0,2.1,0.5,2.7,1.4c0.6-0.9,1.5-1.4,2.6-1.4 c1.1,0,2,0.5,2.7,1.4c0.3-0.5,0.7-0.9,1.1-1.1c0.5-0.2,1-0.3,1.6-0.3c1.3,0,2.3,0.5,3.2,1.4c0.9,0.9,1.3,2.3,1.3,4.2 c0,1.3-0.5,2.9-1.6,4.5l-3.1,0c1.5-1.8,2.3-3.3,2.3-4.5c0-1.4-0.2-2.3-0.6-2.7c-0.4-0.4-0.9-0.6-1.5-0.6c-1.1,0-1.6,0.8-1.6,2.5 v2.5h-2.3V449c0-1.6-0.5-2.5-1.4-2.5c-1,0-1.5,0.8-1.5,2.5v2.5h-2.3V449c0-1.7-0.5-2.5-1.5-2.5c-0.5,0-1,0.2-1.4,0.7 c-0.5,0.5-0.7,1.3-0.7,2.7c0,2.2,1.4,4.2,4.2,5.9c3.2,0.1,5.5,0.4,6.9,0.9c1.4,0.5,2.2,1.5,2.4,2.9h-3.1c-0.3-0.8-0.9-1.2-2-1.4 c-1-0.2-2.2-0.3-3.5-0.3c-2.5,0-4.4,0.2-5.7,0.6v-2.2l1.6-0.2C138.3,454.3,137.2,452.2,137.2,449.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st97",
  d: "M159.2,451.5c0-2.2,0.4-3.9,1.3-5.3c0.8-1.3,2-2,3.5-2c1.5,0,2.7,0.7,3.5,2s1.2,3.1,1.2,5.3 c0,1.9-0.3,4.6-1,7.9H165c0.9-3,1.3-5.7,1.3-8.1c0-1.7-0.2-2.9-0.7-3.7c-0.5-0.8-1-1.2-1.7-1.2c-0.6,0-1.2,0.4-1.6,1.2 c-0.4,0.8-0.7,2-0.7,3.7c0,2.4,0.5,5.1,1.4,8.1h-2.8C159.6,456.1,159.2,453.5,159.2,451.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st97",
  d: "M171.1,454.5v-10.2h2.4v10.1c0,1,0.2,1.7,0.7,2.2c0.4,0.5,1,0.8,1.6,0.8c0.7,0,1.2-0.2,1.7-0.7 c0.4-0.5,0.7-1.2,0.7-2.1c0-1.2-0.3-2.2-0.9-3c-0.6-0.7-0.9-2.1-0.9-4h2.4c0,1.6,0.3,2.8,0.9,3.5s0.9,1.9,1,3.5 c0,1.4-0.5,2.6-1.4,3.6s-2.1,1.4-3.4,1.4c-1.4,0-2.6-0.5-3.5-1.5C171.4,457.1,170.9,455.9,171.1,454.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st97",
  d: "M182.8,454.1c0-1.3,0.4-2.4,1.4-3.5c1-1.1,2.3-1.6,3.9-1.6h0.7c0.3-0.4,0.5-0.9,0.4-1.5 c0-0.3-0.1-0.6-0.3-0.8c-0.2-0.2-0.7-0.2-1.3-0.2c-0.7,0-1.1,0.1-1.3,0.4c-0.2,0.2-0.3,0.6-0.3,1.1l-2.4,0c0-1.3,0.4-2.2,1.2-2.8 s1.7-0.8,2.8-0.8c1.1,0,2,0.2,2.8,0.7s1.2,1.3,1.2,2.3c0,0.9-0.2,1.6-0.6,2.3c1.7,1.3,2.5,2.8,2.5,4.5c0,1.7-0.5,3-1.5,4 c-1,1-2.3,1.5-3.8,1.5c-1.6,0-3-0.5-3.9-1.6C183.2,457,182.8,455.7,182.8,454.1z M185.3,454.1c0,1.3,0.3,2.2,0.9,2.7 c0.6,0.5,1.3,0.7,2,0.7c0.7,0,1.3-0.2,2-0.7c0.6-0.4,1-1.3,1-2.7c0-0.7-0.3-1.3-0.8-2c-0.5-0.6-1.2-1-2.2-1c-0.8,0-1.5,0.3-2,1 C185.5,452.8,185.3,453.5,185.3,454.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st97",
  d: "M195.7,453.7c0-1.2,0.3-2.3,0.8-3.3l2.3,0.8c-0.4,1.2-0.6,2.1-0.6,2.7c0,1.3,0.2,2.3,0.6,2.8 c0.4,0.5,1,0.8,1.6,0.8c0.9,0,1.6-0.4,1.9-1.1c0.3-0.7,0.5-1.6,0.5-2.6c0-1.7-0.7-3.2-2.1-4.5c-1.4-1.3-2.1-2.9-2.1-4.9h2.4 c0,1.3,0.7,2.7,2.1,4.1c1.4,1.4,2.1,3.2,2.1,5.4c0,1.6-0.4,2.9-1.3,4.1s-2,1.8-3.6,1.8c-1.4,0-2.6-0.6-3.4-1.8 C196.2,456.7,195.7,455.3,195.7,453.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st97",
  d: "M207.5,454.4v-6.8c0-1.1,0.4-2,1.1-2.5c0.7-0.6,1.5-0.8,2.3-0.8h5.4v2.2l-5.2,0c-0.8,0-1.2,0.3-1.2,1v3 c0.8-0.7,1.6-1.1,2.4-1.1c1.3,0,2.4,0.4,3.3,1.2c0.9,0.8,1.3,2.1,1.3,3.8c0,1.7-0.4,2.9-1.3,3.8c-0.9,0.9-2,1.4-3.3,1.4 c-1.5,0-2.6-0.5-3.5-1.6C207.9,457.1,207.5,455.9,207.5,454.4z M209.9,454.4c0,1.2,0.2,2,0.7,2.4c0.5,0.4,1.1,0.6,1.7,0.6 c0.6,0,1.2-0.2,1.6-0.6c0.4-0.4,0.6-1.2,0.6-2.4c0-0.9-0.2-1.6-0.6-2.1s-0.9-0.7-1.6-0.7c-0.7,0-1.3,0.2-1.7,0.7 S209.9,453.5,209.9,454.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st97",
  d: "M225.3,454.1c0-1.3,0.4-2.4,1.4-3.5c1-1.1,2.3-1.6,3.9-1.6h0.7c0.3-0.4,0.5-0.9,0.4-1.5 c0-0.3-0.1-0.6-0.3-0.8c-0.2-0.2-0.7-0.2-1.3-0.2c-0.7,0-1.1,0.1-1.3,0.4c-0.2,0.2-0.3,0.6-0.3,1.1l-2.4,0c0-1.3,0.4-2.2,1.2-2.8 s1.7-0.8,2.8-0.8c1.1,0,2,0.2,2.8,0.7s1.2,1.3,1.2,2.3c0,0.9-0.2,1.6-0.6,2.3c1.7,1.3,2.5,2.8,2.5,4.5c0,1.7-0.5,3-1.5,4 c-1,1-2.3,1.5-3.8,1.5c-1.6,0-3-0.5-3.9-1.6C225.7,457,225.2,455.7,225.3,454.1z M227.7,454.1c0,1.3,0.3,2.2,0.9,2.7 c0.6,0.5,1.3,0.7,2,0.7c0.7,0,1.3-0.2,2-0.7c0.6-0.4,1-1.3,1-2.7c0-0.7-0.3-1.3-0.8-2c-0.5-0.6-1.2-1-2.2-1c-0.8,0-1.5,0.3-2,1 C228,452.8,227.7,453.5,227.7,454.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st97",
  d: "M238.2,453.7c0-1.2,0.3-2.3,0.8-3.3l2.3,0.8c-0.4,1.2-0.6,2.1-0.6,2.7c0,1.3,0.2,2.3,0.6,2.8 c0.4,0.5,1,0.8,1.6,0.8c0.9,0,1.6-0.4,1.9-1.1c0.3-0.7,0.5-1.6,0.5-2.6c0-1.7-0.7-3.2-2.1-4.5c-1.4-1.3-2.1-2.9-2.1-4.9h2.4 c0,1.3,0.7,2.7,2.1,4.1c1.4,1.4,2.1,3.2,2.1,5.4c0,1.6-0.4,2.9-1.3,4.1s-2,1.8-3.6,1.8c-1.4,0-2.6-0.6-3.4-1.8 C238.6,456.7,238.2,455.3,238.2,453.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st97",
  d: "M249.9,454.7c0-1.6,0.4-2.8,1.2-3.8c0.8-1,2-1.5,3.5-1.5c0.9,0,1.6,0.3,2.4,0.8v-2.1c0-0.5-0.1-0.9-0.5-1.2 s-0.9-0.4-1.6-0.4c-0.8,0-1.3,0.1-1.6,0.4c-0.3,0.2-0.5,0.7-0.5,1.3h-2.4c0-1.3,0.4-2.3,1.2-2.9s1.9-0.9,3.3-0.9 c1.3,0,2.3,0.4,3.2,1.1c0.9,0.7,1.3,1.6,1.3,2.7v6.7c0,1.4-0.5,2.5-1.4,3.5c-0.9,0.9-2.1,1.4-3.4,1.4c-1.4,0-2.5-0.5-3.4-1.4 C250.3,457.2,249.9,456.1,249.9,454.7z M252.3,454.8c0,0.8,0.2,1.5,0.6,2c0.4,0.5,1,0.7,1.6,0.7c0.7,0,1.3-0.2,1.8-0.7 c0.4-0.5,0.7-1.1,0.7-1.9c0-1.1-0.2-1.9-0.7-2.4c-0.5-0.5-1-0.7-1.7-0.7c-0.7,0-1.2,0.2-1.6,0.7 C252.6,452.8,252.3,453.6,252.3,454.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st97",
  d: "M261.6,451.7c0-2.6,0.5-4.5,1.4-5.6c0.9-1.2,2-1.8,3.3-1.8c1.1,0,2.1,0.6,2.8,1.8c0.7-1.2,1.6-1.8,2.8-1.8 c1.3,0,2.4,0.6,3.3,1.8c0.9,1.2,1.4,3,1.4,5.6c0,2.5-0.8,5.1-2.3,7.8H271c2-2.8,3.1-5.4,3.1-8c0-1.8-0.2-3.1-0.6-3.8 c-0.4-0.7-1-1.1-1.8-1.1c-1.1,0-1.6,0.7-1.6,2.2l0,4.9h-2.3v-4.9c0-1.5-0.5-2.2-1.5-2.2c-0.8,0-1.4,0.4-1.8,1.1s-0.5,2-0.5,3.8 c0,2.6,1,5.3,3.1,8h-3.3C262.4,456.7,261.6,454.2,261.6,451.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st97",
  d: "M278.8,454.1c0-1.3,0.4-2.4,1.4-3.5c1-1.1,2.3-1.6,3.9-1.6h0.7c0.3-0.4,0.5-0.9,0.4-1.5 c0-0.3-0.1-0.6-0.3-0.8c-0.2-0.2-0.7-0.2-1.3-0.2c-0.7,0-1.1,0.1-1.3,0.4c-0.2,0.2-0.3,0.6-0.3,1.1l-2.4,0c0-1.3,0.4-2.2,1.2-2.8 s1.7-0.8,2.8-0.8c1.1,0,2,0.2,2.8,0.7c0.8,0.5,1.2,1.3,1.2,2.3c0,0.9-0.2,1.6-0.6,2.3c1.7,1.3,2.5,2.8,2.5,4.5c0,1.7-0.5,3-1.5,4 c-1,1-2.3,1.5-3.8,1.5c-1.6,0-3-0.5-3.9-1.6S278.8,455.7,278.8,454.1z M281.3,454.1c0,1.3,0.3,2.2,0.9,2.7c0.6,0.5,1.3,0.7,2,0.7 c0.7,0,1.3-0.2,2-0.7c0.6-0.4,1-1.3,1-2.7c0-0.7-0.3-1.3-0.8-2c-0.5-0.6-1.2-1-2.2-1c-0.8,0-1.5,0.3-2,1 C281.5,452.8,281.3,453.5,281.3,454.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st97",
  d: "M291.7,448.3c0-1.2,0.3-2.2,1-3c0.7-0.7,1.6-1.1,2.8-1.1c1.4,0,2.4,0.4,3,1.3c0.6,0.8,0.9,1.7,0.9,2.5 c0,0.7-0.1,1.2-0.2,1.5c1.8,0.8,2.8,2.4,2.8,4.8c0,1.7-0.5,3-1.5,3.9c-1,0.9-2.1,1.4-3.3,1.4c-1.3,0-2.4-0.5-3.4-1.4 c-0.9-0.9-1.4-2.2-1.4-3.9c0-0.8,0.3-1.7,0.8-2.6c-0.5-0.4-0.8-0.9-1.1-1.4C291.9,449.8,291.7,449.1,291.7,448.3z M294.2,448.3 c0,0.8,0.2,1.4,0.5,1.7c0.5-0.4,1.2-0.7,2.3-0.6c0.1-0.2,0.2-0.6,0.2-1.1c0-0.5-0.1-1-0.3-1.3c-0.2-0.4-0.6-0.5-1.2-0.5 c-0.5,0-0.9,0.1-1.1,0.3S294.2,447.5,294.2,448.3z M294.9,454.4c0,1.1,0.2,1.9,0.7,2.3c0.5,0.4,1,0.7,1.6,0.7 c0.7,0,1.3-0.3,1.7-0.7c0.4-0.5,0.6-1.2,0.6-2.3c0-0.9-0.2-1.6-0.7-2.1c-0.4-0.5-1-0.7-1.6-0.7c-0.7,0-1.2,0.2-1.7,0.7 S294.9,453.5,294.9,454.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st97",
  d: "M304.2,453.7c0-1.2,0.3-2.3,0.8-3.3l2.3,0.8c-0.4,1.2-0.6,2.1-0.6,2.7c0,1.3,0.2,2.3,0.6,2.8 c0.4,0.5,1,0.8,1.6,0.8c0.9,0,1.6-0.4,1.9-1.1c0.3-0.7,0.5-1.6,0.5-2.6c0-1.7-0.7-3.2-2.1-4.5c-1.4-1.3-2.1-2.9-2.1-4.9h2.4 c0,1.3,0.7,2.7,2.1,4.1c1.4,1.4,2.1,3.2,2.1,5.4c0,1.6-0.4,2.9-1.3,4.1s-2,1.8-3.6,1.8c-1.4,0-2.6-0.6-3.4-1.8 C304.6,456.7,304.2,455.3,304.2,453.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st97",
  d: "M315.9,455c0-0.6,0.2-1.4,0.5-2.3l2.4,0.6c-0.3,0.6-0.5,1.3-0.5,2.2c0,0.5,0.2,1,0.6,1.4 c0.4,0.4,1,0.6,1.7,0.6c0.7,0,1.3-0.2,1.7-0.5c0.4-0.3,0.6-0.7,0.6-1.2v-1.5c0-0.6-0.1-1.1-0.3-1.5c-0.2-0.4-0.6-0.6-1.1-0.6h-1.2 V450h1.2c0.4,0,0.7-0.2,0.9-0.4c0.2-0.3,0.3-0.8,0.3-1.4c0-0.5-0.2-0.9-0.5-1.2c-0.3-0.4-0.8-0.5-1.4-0.5c-0.9,0-1.4,0.2-1.7,0.5 c-0.3,0.3-0.4,0.6-0.4,0.9c0,0.3,0.1,0.7,0.3,1.1l-2.3,0.8c-0.2-0.7-0.4-1.3-0.4-1.9c0-0.9,0.4-1.7,1.3-2.5 c0.9-0.7,1.9-1.1,3.2-1.1c1.3,0,2.4,0.4,3.2,1.2c0.8,0.8,1.2,1.7,1.2,2.8c0,1.2-0.5,2.2-1.5,2.9c1.1,0.9,1.7,2.1,1.7,3.5 c0,1.5-0.4,2.7-1.2,3.6s-2,1.3-3.5,1.3c-1.5,0-2.7-0.4-3.5-1.2C316.3,457.6,315.9,456.5,315.9,455z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st97",
  d: "M327.6,454.4v-6.8c0-1.1,0.4-2,1.1-2.5c0.7-0.6,1.5-0.8,2.3-0.8h5.4v2.2l-5.2,0c-0.8,0-1.2,0.3-1.2,1v3 c0.8-0.7,1.6-1.1,2.4-1.1c1.3,0,2.4,0.4,3.3,1.2c0.9,0.8,1.3,2.1,1.3,3.8c0,1.7-0.4,2.9-1.3,3.8s-2,1.4-3.3,1.4 c-1.5,0-2.6-0.5-3.5-1.6C328.1,457.1,327.6,455.9,327.6,454.4z M330,454.4c0,1.2,0.2,2,0.7,2.4c0.5,0.4,1.1,0.6,1.7,0.6 c0.6,0,1.2-0.2,1.6-0.6c0.4-0.4,0.6-1.2,0.6-2.4c0-0.9-0.2-1.6-0.6-2.1s-0.9-0.7-1.6-0.7c-0.7,0-1.3,0.2-1.7,0.7 S330,453.5,330,454.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st97",
  d: "M339.3,451.5c0-2.2,0.4-3.9,1.3-5.3s2-2,3.5-2c1.5,0,2.7,0.7,3.5,2c0.8,1.3,1.2,3.1,1.2,5.3 c0,1.9-0.3,4.6-1,7.9h-2.7c0.9-3,1.3-5.7,1.3-8.1c0-1.7-0.2-2.9-0.7-3.7s-1-1.2-1.7-1.2c-0.6,0-1.2,0.4-1.6,1.2 c-0.4,0.8-0.7,2-0.7,3.7c0,2.4,0.5,5.1,1.4,8.1h-2.8C339.6,456.1,339.3,453.5,339.3,451.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st97",
  d: "M351,449.8c0-1.7,0.5-3.1,1.3-4.1c0.9-1,2-1.5,3.2-1.5c1.2,0,2.1,0.5,2.7,1.4c0.6-0.9,1.5-1.4,2.6-1.4 c1.1,0,2,0.5,2.7,1.4c0.3-0.5,0.7-0.9,1.1-1.1s1-0.3,1.6-0.3c1.3,0,2.3,0.5,3.2,1.4c0.9,0.9,1.3,2.3,1.3,4.2 c0,1.3-0.5,2.9-1.6,4.5l-3.1,0c1.5-1.8,2.3-3.3,2.3-4.5c0-1.4-0.2-2.3-0.6-2.7c-0.4-0.4-0.9-0.6-1.5-0.6c-1.1,0-1.6,0.8-1.6,2.5 v2.5h-2.3V449c0-1.6-0.5-2.5-1.4-2.5c-1,0-1.5,0.8-1.5,2.5v2.5H357V449c0-1.7-0.5-2.5-1.5-2.5c-0.5,0-1,0.2-1.4,0.7 c-0.5,0.5-0.7,1.3-0.7,2.7c0,2.2,1.4,4.2,4.2,5.9c3.2,0.1,5.5,0.4,6.9,0.9c1.4,0.5,2.2,1.5,2.4,2.9h-3.1c-0.3-0.8-0.9-1.2-2-1.4 c-1-0.2-2.2-0.3-3.5-0.3c-2.5,0-4.4,0.2-5.7,0.6v-2.2l1.6-0.2C352.1,454.3,351,452.2,351,449.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st97",
  d: "M373,451.5c0-2.2,0.4-3.9,1.3-5.3s2-2,3.5-2c1.5,0,2.7,0.7,3.5,2c0.8,1.3,1.2,3.1,1.2,5.3 c0,1.9-0.3,4.6-1,7.9h-2.7c0.9-3,1.3-5.7,1.3-8.1c0-1.7-0.2-2.9-0.7-3.7s-1-1.2-1.7-1.2c-0.6,0-1.2,0.4-1.6,1.2 c-0.4,0.8-0.7,2-0.7,3.7c0,2.4,0.5,5.1,1.4,8.1H374C373.3,456.1,373,453.5,373,451.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st97",
  d: "M21.4,473.8c0-1.7,0.4-3.1,1.2-4.1c0.8-1,2-1.5,3.6-1.5c1.1,0,2,0.3,2.7,1c0.8-0.7,1.8-1,2.7-1 c1.3,0,2.5,0.4,3.4,1.3c0.9,0.9,1.4,2.2,1.4,3.9c0,1.6-0.5,2.9-1.4,3.9c-0.9,1-2.1,1.5-3.3,1.5c-1.2,0-2.3-0.5-3.3-1.4 s-1.4-2.2-1.4-3.9c0-0.9,0.3-1.8,0.8-2.7c-0.6-0.2-1-0.3-1.5-0.3c-0.7,0-1.2,0.3-1.7,0.8c-0.4,0.5-0.7,1.4-0.7,2.7 c0,1.2,0.2,2.3,0.7,3.2c0.4,1,1.2,1.9,2.4,2.9c2.1,0.2,3.7,0.5,4.7,1.1c1,0.5,1.7,1.4,1.9,2.6h-3.4c0-0.4-0.2-0.8-0.7-1 c-0.5-0.2-1.5-0.4-3-0.4c-1.4,0-2.7,0.1-3.8,0.3v-2.2l1.4-0.2C22.2,478.3,21.4,476.2,21.4,473.8z M29.3,473.5 c0,1.1,0.2,1.9,0.7,2.4s1,0.7,1.6,0.7c0.6,0,1.1-0.3,1.6-0.8s0.7-1.3,0.7-2.4c0-1-0.2-1.8-0.6-2.3c-0.4-0.5-1-0.8-1.7-0.8 c-0.6,0-1.1,0.3-1.6,0.8S29.3,472.5,29.3,473.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st97",
  d: "M38.6,477.6c0-1.2,0.3-2.3,0.8-3.3l2.3,0.8c-0.4,1.2-0.6,2.1-0.6,2.7c0,1.3,0.2,2.3,0.6,2.8 c0.4,0.5,1,0.8,1.6,0.8c0.9,0,1.6-0.4,1.9-1.1c0.3-0.7,0.5-1.6,0.5-2.6c0-1.7-0.7-3.2-2.1-4.5c-1.4-1.3-2.1-2.9-2.1-4.9h2.4 c0,1.3,0.7,2.7,2.1,4.1c1.4,1.4,2.1,3.2,2.1,5.4c0,1.6-0.4,2.9-1.3,4.1s-2,1.8-3.6,1.8c-1.4,0-2.6-0.6-3.4-1.8 C39.1,480.7,38.6,479.3,38.6,477.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st97",
  d: "M50.4,479c0-0.6,0.2-1.4,0.5-2.3l2.4,0.6c-0.3,0.6-0.5,1.3-0.5,2.2c0,0.5,0.2,1,0.6,1.4 c0.4,0.4,1,0.6,1.7,0.6c0.7,0,1.3-0.2,1.7-0.5c0.4-0.3,0.6-0.7,0.6-1.2v-1.5c0-0.6-0.1-1.1-0.3-1.5c-0.2-0.4-0.6-0.6-1.1-0.6h-1.2 V474H56c0.4,0,0.7-0.2,0.9-0.4c0.2-0.3,0.3-0.8,0.3-1.4c0-0.5-0.2-0.9-0.5-1.2c-0.3-0.4-0.8-0.5-1.4-0.5c-0.9,0-1.4,0.2-1.7,0.5 c-0.3,0.3-0.4,0.6-0.4,0.9c0,0.3,0.1,0.7,0.3,1.1l-2.3,0.8c-0.2-0.7-0.4-1.3-0.4-1.9c0-0.9,0.4-1.7,1.3-2.5 c0.9-0.7,1.9-1.1,3.2-1.1c1.3,0,2.4,0.4,3.2,1.2c0.8,0.8,1.2,1.7,1.2,2.8c0,1.2-0.5,2.2-1.5,2.9c1.1,0.9,1.7,2.1,1.7,3.5 c0,1.5-0.4,2.7-1.2,3.6c-0.8,0.9-2,1.3-3.5,1.3c-1.5,0-2.7-0.4-3.5-1.2C50.8,481.6,50.4,480.4,50.4,479z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st97",
  d: "M62.1,477.6c0-1.2,0.3-2.3,0.8-3.3l2.3,0.8c-0.4,1.2-0.6,2.1-0.6,2.7c0,1.3,0.2,2.3,0.6,2.8 c0.4,0.5,1,0.8,1.6,0.8c0.9,0,1.6-0.4,1.9-1.1c0.3-0.7,0.5-1.6,0.5-2.6c0-1.7-0.7-3.2-2.1-4.5c-1.4-1.3-2.1-2.9-2.1-4.9h2.4 c0,1.3,0.7,2.7,2.1,4.1c1.4,1.4,2.1,3.2,2.1,5.4c0,1.6-0.4,2.9-1.3,4.1s-2,1.8-3.6,1.8c-1.4,0-2.6-0.6-3.4-1.8 C62.5,480.7,62.1,479.3,62.1,477.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st97",
  d: "M73.8,473.8c0-1.7,0.5-3.1,1.3-4.1c0.9-1,2-1.5,3.2-1.5c1.2,0,2.1,0.5,2.7,1.4c0.6-0.9,1.5-1.4,2.6-1.4 c1.1,0,2,0.5,2.7,1.4c0.3-0.5,0.7-0.9,1.1-1.1c0.5-0.2,1-0.3,1.6-0.3c1.3,0,2.3,0.5,3.2,1.4c0.9,0.9,1.3,2.3,1.3,4.2 c0,1.3-0.5,2.9-1.6,4.5l-3.1,0c1.5-1.8,2.3-3.3,2.3-4.5c0-1.4-0.2-2.3-0.6-2.7c-0.4-0.4-0.9-0.6-1.5-0.6c-1.1,0-1.6,0.8-1.6,2.5 v2.5h-2.3V473c0-1.6-0.5-2.5-1.4-2.5c-1,0-1.5,0.8-1.5,2.5v2.5h-2.3V473c0-1.7-0.5-2.5-1.5-2.5c-0.5,0-1,0.2-1.4,0.7 c-0.5,0.5-0.7,1.3-0.7,2.7c0,2.2,1.4,4.2,4.2,5.9c3.2,0.1,5.5,0.4,6.9,0.9c1.4,0.5,2.2,1.5,2.4,2.9h-3.1c-0.3-0.8-0.9-1.2-2-1.4 c-1-0.2-2.2-0.3-3.5-0.3c-2.5,0-4.4,0.2-5.7,0.6v-2.2l1.6-0.2C74.9,478.3,73.8,476.2,73.8,473.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st97",
  d: "M95.8,479c0-0.8,0.2-1.6,0.7-2.5l2.2,1.1c-0.3,0.7-0.4,1.3-0.4,1.9c0,0.6,0.2,1.1,0.6,1.4 c0.4,0.3,0.9,0.5,1.5,0.5c0.9,0,1.5-0.2,1.9-0.6c0.4-0.4,0.6-1.1,0.6-2.2V472c0-0.5-0.2-0.9-0.6-1.1c-0.4-0.3-0.9-0.4-1.6-0.4 c-0.8,0-1.4,0.2-1.6,0.5c-0.3,0.3-0.4,0.7-0.4,1.1c0,0.5,0.1,1,0.4,1.4l-2.1,1c-0.5-0.8-0.8-1.6-0.8-2.4c0-1,0.4-1.9,1.2-2.6 c0.8-0.8,1.9-1.2,3.2-1.2c1.5,0,2.7,0.4,3.5,1.1s1.2,1.6,1.2,2.7v6.6c0,1.8-0.5,3.1-1.4,3.9c-0.9,0.8-2.1,1.2-3.5,1.2 c-1.1,0-2.1-0.3-3.1-1C96.3,481.9,95.8,480.7,95.8,479z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st97",
  d: "M107.5,478.3c0-1.3,0.4-2.4,1.1-3.3s1.6-1.4,2.7-1.5l0.2-1.2c0.1-0.7-0.4-1.3-1.3-1.6 c-0.9-0.4-1.4-1.1-1.4-2.3h2.5c0,0.5,0.4,1,1.3,1.4s1.3,1.2,1.1,2.5l-0.3,1.4c0.9,0.1,1.6,0.6,2.4,1.5s1.1,2,1.1,3.3 c0,1.6-0.5,2.9-1.4,3.9c-0.9,1-2,1.5-3.4,1.5c-1.4,0-2.5-0.5-3.4-1.4C108,481.2,107.5,479.9,107.5,478.3z M110,478.3 c0,1.2,0.2,2,0.7,2.4c0.5,0.5,1,0.7,1.6,0.7c0.7,0,1.3-0.2,1.7-0.7c0.4-0.4,0.6-1.3,0.6-2.4c0-0.9-0.2-1.6-0.7-2 c-0.4-0.5-0.9-0.7-1.5-0.7c-0.8,0-1.4,0.2-1.8,0.7C110.2,476.8,110,477.4,110,478.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st97",
  d: "M119.2,479c0-0.8,0.2-1.6,0.7-2.5l2.2,1.1c-0.3,0.7-0.4,1.3-0.4,1.9c0,0.6,0.2,1.1,0.6,1.4 c0.4,0.3,0.9,0.5,1.5,0.5c0.9,0,1.5-0.2,1.9-0.6c0.4-0.4,0.6-1.1,0.6-2.2V472c0-0.5-0.2-0.9-0.6-1.1c-0.4-0.3-0.9-0.4-1.6-0.4 c-0.8,0-1.4,0.2-1.6,0.5c-0.3,0.3-0.4,0.7-0.4,1.1c0,0.5,0.1,1,0.4,1.4l-2.1,1c-0.5-0.8-0.8-1.6-0.8-2.4c0-1,0.4-1.9,1.2-2.6 c0.8-0.8,1.9-1.2,3.2-1.2c1.5,0,2.7,0.4,3.5,1.1s1.2,1.6,1.2,2.7v6.6c0,1.8-0.5,3.1-1.4,3.9c-0.9,0.8-2.1,1.2-3.5,1.2 c-1.1,0-2.1-0.3-3.1-1C119.7,481.9,119.2,480.7,119.2,479z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st97",
  d: "M130.9,478.3c0-1.3,0.4-2.4,1.1-3.3s1.6-1.4,2.7-1.5l0.2-1.2c0.1-0.7-0.4-1.3-1.3-1.6 c-0.9-0.4-1.4-1.1-1.4-2.3h2.5c0,0.5,0.4,1,1.3,1.4s1.3,1.2,1.1,2.5l-0.3,1.4c0.9,0.1,1.6,0.6,2.4,1.5s1.1,2,1.1,3.3 c0,1.6-0.5,2.9-1.4,3.9c-0.9,1-2,1.5-3.4,1.5c-1.4,0-2.5-0.5-3.4-1.4C131.3,481.2,130.9,479.9,130.9,478.3z M133.3,478.3 c0,1.2,0.2,2,0.7,2.4c0.5,0.5,1,0.7,1.6,0.7c0.7,0,1.3-0.2,1.7-0.7c0.4-0.4,0.6-1.3,0.6-2.4c0-0.9-0.2-1.6-0.7-2 c-0.4-0.5-0.9-0.7-1.5-0.7c-0.8,0-1.4,0.2-1.8,0.7C133.5,476.8,133.3,477.4,133.3,478.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st97",
  d: "M142.6,475.5c0-2.2,0.4-3.9,1.3-5.3c0.8-1.3,2-2,3.5-2c1.5,0,2.7,0.7,3.5,2s1.2,3.1,1.2,5.3 c0,1.9-0.3,4.6-1,7.9h-2.7c0.9-3,1.3-5.7,1.3-8.1c0-1.7-0.2-2.9-0.7-3.7c-0.5-0.8-1-1.2-1.7-1.2c-0.6,0-1.2,0.4-1.6,1.2 c-0.4,0.8-0.7,2-0.7,3.7c0,2.4,0.5,5.1,1.4,8.1h-2.8C142.9,480.1,142.6,477.5,142.6,475.5z"
}));

var SvgJoinClassroomBig = function SvgJoinClassroomBig(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\xD1\\xEB\\xEE\\xE9_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -1.2871,
    y1: 501.2871,
    x2: 498.7129,
    y2: 1.2871
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#11998E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1443,
    style: {
      stopColor: "#179A93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.342,
    style: {
      stopColor: "#299CA2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5707,
    style: {
      stopColor: "#46A0BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8206,
    style: {
      stopColor: "#6EA5DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8FA9F7"
    }
  })), _ref3, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 86.4834,
    y1: 310.5912,
    x2: 415.8754,
    y2: 310.5912
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D79FF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#400BCD"
    }
  })), _ref4, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 31.7355,
    y1: 266.1539,
    x2: 406.905,
    y2: 266.1539,
    gradientTransform: "matrix(0.9757 7.000000e-04 7.000000e-04 1.0195 37.1549 -8.9704)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#92F7FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2395E2"
    }
  })), _ref5, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.823,
    y1: 266.1539,
    x2: 422.8175,
    y2: 266.1539,
    gradientTransform: "matrix(0.9757 7.000000e-04 7.000000e-04 1.0195 37.1549 -8.9704)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#92F7FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2395E2"
    }
  })), _ref6), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 86.8776,
    y1: 306.5171,
    x2: 415.9044,
    y2: 306.5171
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#61E2E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1D7FB5"
    }
  })), _ref7, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 86.8688,
    y1: 252.6613,
    x2: 415.87,
    y2: 252.6613
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#92F7FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2395E2"
    }
  })), _ref8), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 110.3904,
    y1: 288.1671,
    x2: 392.3904,
    y2: 288.1671
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9D7DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#56399E"
    }
  })), _ref9, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 110.3828,
    y1: 239.4423,
    x2: 392.3608,
    y2: 239.4423
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C2B3FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6B4FC1"
    }
  })), _ref10), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 110.3906,
    y1: 127.6135,
    x2: 392.3904,
    y2: 127.6135
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#45DBFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D79FF3"
    }
  })), _ref11, _ref12), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _ref13, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 276.6749,
    y1: 204.9064,
    x2: 279.2198,
    y2: 204.9064
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#92F7FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#85D3FF"
    }
  })), _ref14, _ref15)), _ref16, /*#__PURE__*/React.createElement("g", null, _ref17, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 254.4389,
    y1: 192.2588,
    x2: 256.9838,
    y2: 192.2588
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#92F7FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#85D3FF"
    }
  })), _ref18, _ref19)), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 252.6842,
    y1: 173.0451,
    x2: 328.2332,
    y2: 173.0451
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A856E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3992,
    style: {
      stopColor: "#A957E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5444,
    style: {
      stopColor: "#AC5AD9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6483,
    style: {
      stopColor: "#B15FCD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7324,
    style: {
      stopColor: "#B967BC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8045,
    style: {
      stopColor: "#C370A6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8684,
    style: {
      stopColor: "#CF7C8B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9263,
    style: {
      stopColor: "#DE8B6B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9778,
    style: {
      stopColor: "#EF9B46"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F7A334"
    }
  })), _ref20, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 252.6841,
    y1: 169.1107,
    x2: 328.2332,
    y2: 169.1107
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D58DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFB850"
    }
  })), _ref21), /*#__PURE__*/React.createElement("g", null, _ref22, _ref23, _ref24, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 294.8529,
    y1: 167.5028,
    x2: 299.6043,
    y2: 159.2732
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6ABEDB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1469,
    style: {
      stopColor: "#82CFE4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3666,
    style: {
      stopColor: "#9FE3F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5844,
    style: {
      stopColor: "#B4F2F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7974,
    style: {
      stopColor: "#C1FBFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C5FEFF"
    }
  })), _ref25, _ref26, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 284.9122,
    y1: 173.7395,
    x2: 290.2422,
    y2: 164.5078
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C5FEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B3E8FF"
    }
  })), _ref27), _ref28, _ref29, _ref30, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _ref31, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 326.5416,
    y1: 207.3382,
    x2: 328.3615,
    y2: 207.3382
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#92F7FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#85D3FF"
    }
  })), _ref32, _ref33)), /*#__PURE__*/React.createElement("g", null, _ref34, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 313.2207,
    y1: 199.9579,
    x2: 315.0406,
    y2: 199.9579
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#92F7FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#85D3FF"
    }
  })), _ref35, _ref36)), /*#__PURE__*/React.createElement("g", null, _ref37, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 314.6924,
    y1: 212.8357,
    x2: 316.5122,
    y2: 212.8357
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#92F7FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#85D3FF"
    }
  })), _ref38, _ref39)), /*#__PURE__*/React.createElement("g", null, _ref40, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 301.3715,
    y1: 206.5893,
    x2: 303.1913,
    y2: 206.5893
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#92F7FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#85D3FF"
    }
  })), _ref41, _ref42)), _ref43, _ref44, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 315.9779,
    y1: 186.212,
    x2: 332.457,
    y2: 186.212
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D58DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFB850"
    }
  })), _ref45, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 317.0422,
    y1: 186.8296,
    x2: 333.5213,
    y2: 186.8296
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A856E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623,
    style: {
      stopColor: "#DA8773"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F7A334"
    }
  })), _ref46), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 317.0219,
    y1: 195.9986,
    x2: 331.4167,
    y2: 195.9986
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#92F7FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#85D3FF"
    }
  })), _ref47)), /*#__PURE__*/React.createElement("g", null, _ref48, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 155.1706,
    y1: 128.6122,
    x2: 226.6196,
    y2: 128.6122
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#81EABD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#55B58E"
    }
  })), _ref49, _ref50, _ref51, _ref52, _ref53), _ref54, _ref55, _ref56, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 166.8371,
    y1: 150.781,
    x2: 166.8371,
    y2: 141.3704
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A86BF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E4BDFF"
    }
  })), _ref57, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 181.0245,
    y1: 143.4149,
    x2: 183.0328,
    y2: 143.4149
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4BDFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A86BF7"
    }
  })), _ref58), /*#__PURE__*/React.createElement("g", null, _ref59, _ref60, _ref61, _ref62, _ref63, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 151.736,
    y1: 188.9637,
    x2: 160.981,
    y2: 188.9637
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#892758"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B7326F"
    }
  })), _ref64, _ref65, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 144.0408,
    y1: 192.2724,
    x2: 155.2448,
    y2: 192.2724
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B7326F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#892758"
    }
  })), _ref66, _ref67), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 144.3197,
    y1: 155.0327,
    x2: 161.2633,
    y2: 155.0327
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D58DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8036CE"
    }
  })), _ref68, _ref69, _ref70, _ref71, /*#__PURE__*/React.createElement("g", null, _ref72, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 141.4146,
    y1: 162.0358,
    x2: 148.606,
    y2: 162.0358
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4BDFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A86BF7"
    }
  })), _ref73, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 143.2419,
    y1: 178.8793,
    x2: 146.7826,
    y2: 178.8793
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4BDFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A86BF7"
    }
  })), _ref74)), _ref75, _ref76, _ref77, _ref78, _ref79, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _ref80, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 206.3849,
    y1: 249.6235,
    x2: 208.9298,
    y2: 249.6235
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#92F7FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#85D3FF"
    }
  })), _ref81, _ref82)), _ref83, _ref84, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 182.3942,
    y1: 217.7621,
    x2: 257.9433,
    y2: 217.7621
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A856E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3992,
    style: {
      stopColor: "#A957E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5444,
    style: {
      stopColor: "#AC5AD9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6483,
    style: {
      stopColor: "#B15FCD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7324,
    style: {
      stopColor: "#B967BC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8045,
    style: {
      stopColor: "#C370A6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8684,
    style: {
      stopColor: "#CF7C8B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9263,
    style: {
      stopColor: "#DE8B6B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9778,
    style: {
      stopColor: "#EF9B46"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F7A334"
    }
  })), _ref85, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 182.3943,
    y1: 213.8277,
    x2: 257.9433,
    y2: 213.8277
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D58DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFB850"
    }
  })), _ref86), /*#__PURE__*/React.createElement("g", null, _ref87, _ref88, _ref89, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 224.563,
    y1: 212.2198,
    x2: 229.3143,
    y2: 203.9903
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6ABEDB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1469,
    style: {
      stopColor: "#82CFE4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3666,
    style: {
      stopColor: "#9FE3F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5844,
    style: {
      stopColor: "#B4F2F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7974,
    style: {
      stopColor: "#C1FBFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C5FEFF"
    }
  })), _ref90, _ref91, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 214.6223,
    y1: 218.4565,
    x2: 219.9523,
    y2: 209.2248
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C5FEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B3E8FF"
    }
  })), _ref92), _ref93, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _ref94, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientUnits: "userSpaceOnUse",
    x1: 256.2517,
    y1: 252.0553,
    x2: 258.0716,
    y2: 252.0553
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#92F7FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#85D3FF"
    }
  })), _ref95, _ref96)), /*#__PURE__*/React.createElement("g", null, _ref97, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientUnits: "userSpaceOnUse",
    x1: 242.9308,
    y1: 244.6749,
    x2: 244.7506,
    y2: 244.6749
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#92F7FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#85D3FF"
    }
  })), _ref98, _ref99)), /*#__PURE__*/React.createElement("g", null, _ref100, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientUnits: "userSpaceOnUse",
    x1: 244.4025,
    y1: 257.5527,
    x2: 246.2224,
    y2: 257.5527
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#92F7FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#85D3FF"
    }
  })), _ref101, _ref102)), /*#__PURE__*/React.createElement("g", null, _ref103, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientUnits: "userSpaceOnUse",
    x1: 231.0816,
    y1: 251.3064,
    x2: 232.9014,
    y2: 251.3064
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#92F7FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#85D3FF"
    }
  })), _ref104, _ref105)), _ref106, _ref107, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_40_",
    gradientUnits: "userSpaceOnUse",
    x1: 245.6879,
    y1: 230.929,
    x2: 262.1671,
    y2: 230.929
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D58DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFB850"
    }
  })), _ref108, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_41_",
    gradientUnits: "userSpaceOnUse",
    x1: 246.7523,
    y1: 231.5466,
    x2: 263.2314,
    y2: 231.5466
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A856E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623,
    style: {
      stopColor: "#DA8773"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F7A334"
    }
  })), _ref109), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_42_",
    gradientUnits: "userSpaceOnUse",
    x1: 246.732,
    y1: 240.7157,
    x2: 261.1268,
    y2: 240.7157
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#92F7FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#85D3FF"
    }
  })), _ref110, _ref111)), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _ref112, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_43_",
    gradientUnits: "userSpaceOnUse",
    x1: 308.5895,
    y1: 266.1384,
    x2: 311.1344,
    y2: 266.1384
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#92F7FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#85D3FF"
    }
  })), _ref113, _ref114)), _ref115, /*#__PURE__*/React.createElement("g", null, _ref116, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_44_",
    gradientUnits: "userSpaceOnUse",
    x1: 286.3536,
    y1: 253.4908,
    x2: 288.8985,
    y2: 253.4908
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#92F7FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#85D3FF"
    }
  })), _ref117, _ref118)), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_45_",
    gradientUnits: "userSpaceOnUse",
    x1: 284.5988,
    y1: 234.2771,
    x2: 360.1479,
    y2: 234.2771
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A856E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3992,
    style: {
      stopColor: "#A957E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5444,
    style: {
      stopColor: "#AC5AD9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6483,
    style: {
      stopColor: "#B15FCD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7324,
    style: {
      stopColor: "#B967BC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8045,
    style: {
      stopColor: "#C370A6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8684,
    style: {
      stopColor: "#CF7C8B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9263,
    style: {
      stopColor: "#DE8B6B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9778,
    style: {
      stopColor: "#EF9B46"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F7A334"
    }
  })), _ref119, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_46_",
    gradientUnits: "userSpaceOnUse",
    x1: 284.5988,
    y1: 230.3427,
    x2: 360.1479,
    y2: 230.3427
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D58DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFB850"
    }
  })), _ref120), /*#__PURE__*/React.createElement("g", null, _ref121, _ref122, _ref123, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_47_",
    gradientUnits: "userSpaceOnUse",
    x1: 326.7676,
    y1: 228.7348,
    x2: 331.5189,
    y2: 220.5052
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6ABEDB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1469,
    style: {
      stopColor: "#82CFE4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3666,
    style: {
      stopColor: "#9FE3F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5844,
    style: {
      stopColor: "#B4F2F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7974,
    style: {
      stopColor: "#C1FBFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C5FEFF"
    }
  })), _ref124, _ref125, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_48_",
    gradientUnits: "userSpaceOnUse",
    x1: 316.827,
    y1: 234.9715,
    x2: 322.1569,
    y2: 225.7398
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C5FEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B3E8FF"
    }
  })), _ref126), _ref127, _ref128, _ref129, /*#__PURE__*/React.createElement("g", null, _ref130, /*#__PURE__*/React.createElement("g", null, _ref131, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_49_",
    gradientUnits: "userSpaceOnUse",
    x1: 358.4563,
    y1: 268.5703,
    x2: 360.2762,
    y2: 268.5703
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#92F7FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#85D3FF"
    }
  })), _ref132, _ref133)), /*#__PURE__*/React.createElement("g", null, _ref134, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_50_",
    gradientUnits: "userSpaceOnUse",
    x1: 345.1354,
    y1: 261.1899,
    x2: 346.9553,
    y2: 261.1899
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#92F7FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#85D3FF"
    }
  })), _ref135, _ref136)), /*#__PURE__*/React.createElement("g", null, _ref137, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_51_",
    gradientUnits: "userSpaceOnUse",
    x1: 346.6071,
    y1: 274.0677,
    x2: 348.4269,
    y2: 274.0677
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#92F7FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#85D3FF"
    }
  })), _ref138, _ref139)), /*#__PURE__*/React.createElement("g", null, _ref140, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_52_",
    gradientUnits: "userSpaceOnUse",
    x1: 333.2862,
    y1: 267.8213,
    x2: 335.106,
    y2: 267.8213
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#92F7FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#85D3FF"
    }
  })), _ref141, _ref142)), _ref143, _ref144, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_53_",
    gradientUnits: "userSpaceOnUse",
    x1: 347.8925,
    y1: 247.444,
    x2: 364.3717,
    y2: 247.444
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D58DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFB850"
    }
  })), _ref145, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_54_",
    gradientUnits: "userSpaceOnUse",
    x1: 348.9568,
    y1: 248.0616,
    x2: 365.436,
    y2: 248.0616
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A856E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623,
    style: {
      stopColor: "#DA8773"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F7A334"
    }
  })), _ref146), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_55_",
    gradientUnits: "userSpaceOnUse",
    x1: 348.9366,
    y1: 257.2306,
    x2: 363.3314,
    y2: 257.2306
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#92F7FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#85D3FF"
    }
  })), _ref147)), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_56_",
    gradientUnits: "userSpaceOnUse",
    x1: 110.3906,
    y1: 214.132,
    x2: 192.624,
    y2: 214.132
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D79FF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#45DBFF"
    }
  })), _ref148, _ref149))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_57_",
    gradientUnits: "userSpaceOnUse",
    x1: 250,
    y1: 500,
    x2: 250,
    y2: 376.7822
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), _ref150, _ref151));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgJoinClassroomBig, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/join-classroom-big.7da36dd6.svg";
export { ForwardRef as ReactComponent };